module.exports = {
  BusinessNo: 'Номер операции',
  WarehouseNo: 'Номер склада',
  MasterBillNo: 'Основной номер',
  HBL: 'HBL',
  FileNo: 'Номер документа',
  BookingNo: 'Номер бронирования',
  ItemNo: 'Номер проекта',
  BusinessReferenceNo: 'Оперативный справочный номер',
  BillNo: 'Номер счета',
  PreBookingNo: 'Номер бронирования',
  CBANumber: 'Номер таможенного поручения',
  CustomsStatus: 'Таможенное положение',
  CustomsStatusUpdateTime: 'Время обновления таможенного статуса',
  ReceiptDetails: 'квитанция',
  CustomsBrokerStatus: 'Статус таможенной строки',
  CustomsReceiptRecord: 'Таможенные квитанции',
  CustomsTime: 'Таможенное время',
  CustomsCode2: 'Таможенный код',
  CustomsDescription: 'Таможенное описание',
  UnifiedCoding: 'Унифицированное кодирование',
  HBLSplitCombineNo: 'HBL - Единый номер.',
  MBLSplitCombineNo: 'МБЛ с одним номером',
  ConsignationCompany: 'Подразделение - заказчик',
  BookingAgent: 'Агент по бронированию',
  BookingOrExchangeAgent: 'Агент по бронированию / замене',
  CarrierAgent: 'Судоходство',
  DestinationAgent: 'Агент порта назначения',
  ShippingCompany: 'Судоходная компания',
  OperateCarrier: 'Главный судоход',
  VSACarrier: 'Совместный перевозчик',
  InternalVoy: 'Внутренний рейс',
  CopyShip: 'Скопировать данные главного перевозчика в слота-перевозчика',
  ContainerNo: 'Номер ящика',
  BoxController: 'Управляющий ящиком',
  LFD: 'LFD',
  CarNumber: 'Номер вагона',
  ContainerNoOutOfRange: 'Длина ящика превышает лимит',
  PortOfLoading: 'Порт отпр.(POL)',
  PortOfLoadingPOR: 'Порт отправления (POR)',
  TransitPort: 'Порт транзита',
  PortOfDestination: 'Порт назначения',
  PortOfDestinationPod: 'Порт назначения (POD)',
  PortOfDischarge: 'Порт разгрузки (POD)',
  PortOfDischargeSeaAndComprehensive: 'Порт разгрузки (морской / комплексный)',
  DischargingPortCountry: 'Страна / район порта разгрузки',
  DestinationPortCountry: 'Страны / районы назначения',
  dischargingPort: 'Порт разгрузки',
  FirstPortOfDischarge: 'i) Порт разгрузки',
  branchLineDateOfDeparture: 'Дата отправления ответвления',
  branchLineDateOfArrival: 'Дата прибытия ответвления',
  DateOfDeparture: 'Дата отправления',
  DateOfDeparture2: 'Дата отгр.(ETD)',
  BookingDate: 'Дата бронирования',
  BargeDateOfDeparture: 'Дата отправления баржи',
  BargeCYCutOffDate2: 'Дата закрытия баржи',
  BargePortOfLoading: 'Порт отправления баржи (POL)',
  BargeVessel: 'Название баржи',
  BargeVoyage: 'рейс баржи',
  BargePOL: 'Баржа POL',
  SecondDateOfDeparture: 'Дата вылета',
  DeliveryCompletionDate: 'Время завершения доставки',
  DateOfArrival: 'Дата прибытия',
  DateOfArrival2: 'Дата прибытия (ETA)',
  DateOfArrival3: 'Дата прибытия (ETA)',
  DateOfCreation: 'Дата создания',
  CYCutOffDate2: 'Дата закрытия',
  DocCutOffDate: 'Дата закрытия',
  DeclareCutOffDate: 'Дата уведомления',
  LoadingDate: 'Дата упаковки',
  PreAuditTime: 'Сроки предварительного рассмотрения',
  CallSignOfBookingShip: 'Позывной корабля',
  MasterBLFreightTerm: 'Условия фрахта главной накладной',
  MasterBLFreightTermTootip: 'Условия фрахта главной накладной',
  OrderChannels: 'Каналы заказа',
  CargoType: 'Тип груза',
  Shipper: 'Отпр.',
  ShipperCode: 'Код отправителя',
  Consignee: 'Получ.',
  ConsigneeCode: 'Код грузополучателя',
  SONO: 'SO NO.',
  ShippingCompanyContractNo: 'Судоходная компания',
  PleaseEnterTheShippingCompanyContractNumber: 'Введите номер контракта судоходной компании',
  ValidityStartDate: 'Дата начала действия',
  ValidityEndDate: 'Дата окончания действия',
  CargoInsuranceUnit: 'Единица страхования груза',
  CargoInsuranceQuantity: 'Количество страхуемого груза',
  InnerContractNo: 'Номер внутреннего контракта',
  HBLRemarks: 'Примечания к коносаменту HBL',
  quotationNum: 'Номер предложения',
  Vessel: 'Название судна',
  Voyage: 'Рейс',
  CarrierVoyage: 'Внутренние рейсы Отдела',
  OperationDepartment: 'Операционный сектор',
  SalesDepartment: 'Отдел сбыта',
  FLCLType: 'Тип целой сборки',
  ExportControlledProducts: 'Экспортная продукция',
  LocalService: 'Местные услуги',
  NotLocalService: 'Нет локальных сервисов',
  SolicitationType: 'Тип груза',
  SO_NO1: 'S/O No.',
  MBL_NO: 'MB/L No.',
  ServiceProduct: 'Услуги',
  WoodOrNotWood: 'Дерево / недра',
  handlingInformation: 'Handling Information',
  HazardousGoodsOption: 'Опасные варианты',
  ContractRateProperty: 'Договорный характер',
  IsNac: 'Является ли NAC',
  ApplicableProductName: 'Применимое наименование товара',
  PleaseEnterNAC: 'Пожалуйста, введите NAC',
  CargoInsurance: 'Страхование груза',
  ShutOut: 'Возвращение таможенных пошлин',
  ShutOutDate: 'Возвращение таможенных пошлин представления',
  CancelShutOut: 'Отмена возврата',
  ABargeOrNot: 'Есть ли баржа',
  yes: 'Да.',
  no: 'Нет',
  Operation: 'Операция',
  Sales: 'Продажа',
  CustomerService: 'Обслуживание клиентов',
  Documents: 'Документация',
  Airline: 'Маршрут',
  PreAuditPerson: 'Досудебный аудитор',
  Creator: 'Создатель',
  Code: 'CODE',
  Accrued: 'Запланировано',
  AirlineCode: 'LINE CODE',
  ShowRelevantBusiness: 'Показать ассоциированные операции',
  CustomsBroker: 'Таможенная служба',
  AdvancePayment: 'Предоплата таможенных пошлин',
  PrintBooking: 'Печать бронирования',
  PaymentTime: 'Время уплаты налогов',
  CustomsDutyAmount: 'Сумма пошлины',
  VatAmount: 'Сумма налога на добавленную стоимость',
  TaxRemarks: 'Налоговые примечания',
  Warehouse: 'Склад',
  HaulageCompany: 'Транспортная компания',
  CarryingCmpAdjustBlockedTip: 'Среди выбранных заказов есть без отметки Погрузка/доставка до двери, изменение транспортной компании недоступно',
  AbnormalBusinessNo: 'Аномальный бизнес-номер',
  TradeTerms2: 'Условия торговли',
  BusinessStatus: 'Оперативный статус',
  StatusTracking: 'Отслеживание состояния',
  AuditStatus: 'Статус аудита',
  Display: 'пок.',
  EstimatedArrivalTime: 'Ожидаемое время прибытия',
  EstimatedPortArrivalTime: 'Расчетное время прибытия/прибытия в порт',
  ArrivalTime: 'Фактическое время прибытия',
  CustomsClearance: 'Таможенная очистка в порту назначения',
  ActualCustomsReleaseTime: 'Фактическое время выключения',
  DeliveryTime: 'Время доставки',
  ReturnTime: 'Время возврата',
  DeliveryTime2: 'Время доставки',
  DeliveryDate: 'Дата доставки',
  Query: 'Запрос',
  Return: 'Возвращение',
  Prompt1: 'Пожалуйста, введите номер операции.',
  ResetFilter: 'Условия сброса',
  Tip1: 'Двойной щелчок для отображения состояния SOP',
  TipCharge: 'Нажмите, чтобы показать основную информацию о бизнесе',
  MBLIssueBillLading: 'Статус выдачи коносамента MBL',
  HBLIssueBillLading: 'Статус выдачи коносамента HBL',
  ConsignationRelationNumber: 'Номер доверенности',
  BusinessCommissionedRelationNumber: 'Номер корреляции',
  ChannelNo: 'Номер канала',
  Customer: 'Клиенты',
  ConsignationStatus: 'Состояние доверенности',
  ConsignationStatusTime: 'Время выполнения поручения',
  PlaceOfDelivery: 'Место поставки',
  FinalPlaceOfDelivery: 'Конечный пункт поставки',
  DeliveryCountry: 'Страна поставки',
  AirlineArea: 'Маршруты (регион)',
  SequenceNumber: 'Серийный номер',
  Tip2: 'Запрос в Push Data Records',
  View: 'Посмотреть',
  Edit: 'Редактирование',
  Cancel: 'Отменить',
  SaveTheDefaultValues: 'Сохранить значение по умолчанию',
  NominatedAgent: 'Назначенный агент',
  NominatedAgentCount: 'Количество назначенных агентов',
  ActualQuantity: 'Факт.число',
  ActualWeight: 'Факт.бр.',
  ActualVolume: 'Факт.об.',
  ChargedWeight: 'Расчетный вес',
  VolumetricWeight: 'Материал',
  ChargedWeightRT: 'Расчетный вес RT',
  BookingProperty: 'Характер бронирования',
  IssueMethod: 'Способ выхода',
  TradeMethod: 'Форма торговли',
  HBLFreightClause: 'Условия фрахта по накладной',
  HBLFreightClauseTootip: 'Условия фрахта по накладной',
  MBLTransportationClause: 'Основные условия перевозки',
  MBLTransportationClauseTootip: 'Основные условия перевозки',
  HBLTransportationClause: 'Условия перевозки',
  HBLTransportationClauseTootip: 'Условия перевозки',
  ContainerDescription: 'Описание размера ящика',
  FeeCreationDate: 'Дата создания',
  MBLSplitNo: 'Основной номер',
  HBLSplitNo: 'Разделить номер',
  HarborDistrict: 'Портовый район',
  SOPStatus: 'Состояние SOP',
  HDS: 'HDS',
  TEU: 'TEU',
  AirlinePerson: 'Маршрут (ответственный)',
  AirlinePerson2: 'Руководитель маршрута',
  AirlineOffice: 'Авиакомпания',
  AirlineDepartment: 'Маршрутный сектор',
  BusinessCreator: 'Основатель бизнеса',
  Status: 'Статус',
  HblNo: 'HBL NO',
  RelevanceSoNo: 'Связь SO NO',
  DangerousGoodsClassification: 'Классификация опасных грузов',
  DangerousGoodsUNNo: 'Опасные грузы Номер ООН',
  FinalDestination: 'Конечный пункт назначения',
  HBLShipper: 'Грузоотправитель',
  HBLConsignee: 'Получатель субордера',
  Add: 'Дополнительные',
  mergeHblData: 'Объединение информации о распаковке HB / L',
  Delete: 'Удалить',
  AddHbl: 'Дополнительный основной билет',
  SplitHbl: 'Разделить основной билет',
  ExportToExcel: 'Экспорт Excel',
  OverseasAgentEDI: 'Зарубежные агенты EDI',
  EditSopStatus: 'Изменение состояния',
  BatchPrint: 'Массовая печать',
  BatchVessel: 'Массовая перегрузка',
  BatchUpdateType: 'Пакетное изменение типа сборки',
  Statistics: 'Статистика',
  BatchCommit: 'Массовое представление',
  AddCharges: 'Дополнительные расходы',
  EditCharges: 'Расходы на редактирование',
  DeleteCharges: 'Удалить расходы',
  print: 'Печать',
  PrintFclProfit: 'Печать всей прибыли',
  PrintLclProfit: 'Печать прибыли',
  PreSubmission: 'Предварительное представление',
  BatchPreSubmission: 'Предварительное представление партий',
  BatchCancellation: 'Отмена партии',
  Submission: 'Представлено',
  SubmissionDateTime: 'Дата представления',
  AuditDateTime: 'Время проверки',
  Consignation: 'Поручение',
  FreightStation: 'Грузовой терминал',
  SignBill: 'Подпись',
  ConsignationSI: 'Экспорт - реимпорт',
  CrossTenantSeToSiEtaMustNoNull: 'Пожалуйста, добавьте поле: Ожидаемая дата прибытия, это поле является обязательным для импортера!',
  ReturnAction: 'Операция возврата',
  PrintReturn: 'Снятие',
  AssociationBusinessInformation: 'Связанная оперативная информация',
  AssociationBusinessInformationSI: 'Информация об импортных операциях',
  ShowAssociationBusinessInformationSI: 'Ознакомьтесь с информацией о морских импортных операциях',
  Basic: 'Основные',
  Booking: 'Бронирование',
  EnterTheCabin: 'Вход в модуль',
  DataTracking: 'Отслеживание данных',
  AirDataTracking: 'Отслеживание судоходства',
  CustomsDeclaration: 'Таможенная декларация',
  InsureInfo: 'Страхование',
  Mbl: 'MBL',
  Hbl: 'HBL',
  HouseBillOfLading: 'HB/L',
  FormalHbl: 'Формальный лист',
  Vgm: 'VGM',
  AmsEns: 'AMS/ENS',
  Hds: 'HDS',
  CommodityInspection: 'Коммерческая инспекция',
  Fumigation: 'Фумигация',
  ForeignTrade: 'Внешняя торговля',
  ConsignInfo: 'Информация о поручении',
  RequiredItem: 'Обязательные записи',
  CustomerProperty: 'Свойства клиента',
  ContactPerson: 'Контактные лица',
  CustomerContactPerson: 'Контакты с клиентами',
  ContactPhone: 'Контактные телефоны клиентов',
  ContactMobile: 'Контактные телефоны клиентов',
  Detail: 'Подр. инф.',
  OperationDate: 'Дата операции',
  ManageAuditStatus: 'Статус проверки прибыли',
  PlaceOfDelivery2: 'Место получения',
  Transit: 'Транзит',
  PleaseSelectShippingCompany: 'Пожалуйста, выберите судоходную компанию.',
  AdditionalInformation: 'Дополнительная информация',
  WarehouseLoadingStorage: 'ВУпак./Склад.',
  DoorLoadingDelivery: 'Упак/ДВВ',
  NotResponsibleForTruckingAndLoading: 'Самодоставка',
  AutoDistribution: 'Автоматическое распределение',
  ObtainTheWarehouseNo: 'Пол. номер скл.',
  MblNo3: 'Номер основного билета',
  MasterBusinessNo: 'Номер основного векселя',
  PleaseTickCustomsDeclarationOption: 'Выберите опцию [bracket0]',
  PleaseTickDoorLoadingDeliveryOption: 'Выберите опцию [bracket0]',
  PleaseSelectWarehouse: 'Выберите опцию [bracket0]',
  PleaseCheckWarehouses: 'Выберите опцию [bracket0]',
  PlaceOfMblPayment: 'Место платежа по основному счету',
  PlaceOfHblPayment: 'Место платежа',
  CargoSize: 'Размер груза',
  SpecialPriceInstructions: 'Описание специальных цен',
  DirectBusiness: 'Прям.сп',
  Transport: 'Трансп',
  InBatches: 'P.ch',
  SpecialPrice: 'Спец.цена',
  ContainerInfo: 'Сведения об упаковке',
  QuantityConsignActual: 'Число претензий (КД / ПР)',
  WeightConsignActual: 'Вес брутто (КВ / В)',
  CubageConsignActual: 'Объем (в / в реальном выражении)',
  VolumetricWeightConsignActual: 'Материал (в / в действительности)',
  ChargeWeightConsignActual: 'Расчетный вес (КВ / В)',
  Package: 'Упаковка',
  Pieces: 'Небольшое число',
  PiecesType: 'Упаковка мелкими частями',
  Copy2: 'Запись',
  EnglishDescriptionOfGoods: 'Английское название',
  Marks: 'Маркировка',
  NCReferenceNo: 'Номер ссылки',
  SendProxyForecasts: 'Отправить прокси - прогноз',
  SerialNumber: 'Серийный номер S / N',
  Brand: 'Торговая марка Brand',
  ProductiveYear: 'Год производства',
  CustomsValue: 'Стоимость таможенной декларации',
  UnitType: 'Тип оборудования',
  DeviceType: 'Тип оборудования Category',
  CountryOrigin1: 'Страна происхождения',
  DeviceStatus: 'Состояние оборудования (старое и новое)',
  HsCode: 'Номер HS',
  bookingNotes: 'Замечания по бронированию',
  DangerousGoodsRemarks: 'Опасные грузы',
  BootHelperPage: 'Загрузить вспомогательную страницу',
  ChineseDescriptionOfGoods: 'Китайские названия',
  OperationInfo: 'Операционная информация',
  SalesCompany: 'Компании по сбыту',
  OperationCompany: 'Операторы',
  OperationRequirements: 'Требования к эксплуатации',
  DoubleClickToAddOperationRequirements: 'Двойной щелчок Добавить требования к операции',
  OperationTips: 'Настройка',
  ExtraChargeClause: 'Положение о дополнительных сборах',
  DoubleClickToAddExtraChargeClause: 'Двойной щелчок для добавления дополнительных условий',
  WarehousingInfo: 'Хранение информации',
  Remarks: 'Примечания',
  BasicRemarks: 'Примечания (основные)',
  manifestInformation: 'Основная информация о манифесте',
  manifestChannel: 'Канал предварительного размещения манифестов',
  CustomerDeliveryInfo: 'Отправка информации клиентом',
  CodeSearching: 'ПоискК',
  CopyToSeller: 'Коп-Продавец',
  CopyToBuyer: 'Коп-Покупатель',
  ExpandSellerBuyer: 'Развертывание продавца / покупателя',
  NoHouseNumber: 'Нет номера.',
  NotifyParty: 'Увед.',
  NotifyPartyCode: 'Уведомляющий код',
  MblShipperLine1: 'Отправитель MBL',
  MblConsigneeLine1: 'MBL грузополучатель',
  MblNotifyLine1: 'Уведомление MBL',
  DocDispatchingPlace: 'Место отправления коносамента',
  SecondNotifyParty: 'Второй уведомитель',
  PleaseSelect: 'Выберите',
  Add2: 'Дополнительные',
  WhetherDeclarations: 'Таможенная декларация',
  InBatchesOrNot: 'Выделяются ли партии',
  BookingInfo: 'Информация о бронировании',
  MultiJourneyAirline: 'ДМС многорейсовый отдел',
  NumberPasses: 'Количество поездок',
  MergingTickets: 'СБ-Пак',
  TicketsInfo: 'Информация о билетах',
  TotalTickets: 'Общее число голосов',
  NewTickets: 'Новые билеты',
  EditTickets: 'Редактировать билет',
  AddTickets: 'Присоединяйтесь к маленькому билету',
  RemoveTickets: 'Удалить маленький билет',
  DeleteTickets: 'Удалить маленький билет',
  Etd: 'ETD',
  SoNo: 'Номер квитанции',
  FunctionalOperation: 'Функциональные операции',
  MblNo2: 'MB/L NO',
  BookingShipCallSign: 'Позывной судна',
  USAirlineInfo: 'Американская информация',
  PortInfo: 'Информация о районе порта',
  PolPortInfo: 'Информация о районе порта отправления',
  PolAirPortInfo: 'Информация об аэропортах',
  PodPortInfo: 'Информация о районе порта назначения',
  PodAirPortInfo: 'Информация об аэропортах назначения',
  LocalTime: '(Данные возвращаются по местному времени)',
  TopLocalTime: 'Теплый совет: Время показывает местное время',
  CYOpeningDate: 'Дата открытия порта',
  PolPortInfoPrompt: 'Оранжевое поле поддерживает обратную запись данных после открытия службы данных',
  CYOpeningTime: 'Время отправления',
  CYCutOffDate: 'Дата перехвата',
  PortAreaCYCutOffTime: 'Время перехвата порта',
  CarrierCyCutOffTime: 'Время перехвата судна',
  PlannedDateOfBerthing: 'Планируемая дата причала',
  PlannedDateOfLeavingBerth: 'Запланированная дата отъезда',
  ActualDateOfBerthing: 'Фактическая дата причала',
  ActualDateOfLeavingBerth: 'Фактическая дата отъезда',
  PlannedDockingBerths: 'Планируемый причал',
  TheActualDockingBerths: 'Фактический причал',
  ActualTimeOfArrivalThePort: 'Фактическая дата прибытия',
  EquipmentEstimatedReturnTime: 'Ожидаемый срок возврата',
  EquipmentEstimatedReturnTimeTootip: 'Ожидаемый срок возврата',
  To: 'Б',
  OtherInfo: 'Прочая информация',
  CyCode: 'Код стека',
  PortCodeOfDischarge: 'Код порта разгрузки',
  EquipmentReceiptAddress: 'Адрес доставки',
  EquipmentReceiptContactPerson: 'Контактные лица',
  EquipmentReceiptContactWay: 'Контактные данные',
  CustomerCyCutOffDate: 'Дата закрытия клиента',
  CustomerShutOutDate: 'Дата возврата клиента',
  AmsEnsCyCutOffDate: 'Дата закрытия AMS / ENS',
  FreeDetension: 'Бесплатная аренда',
  SecondVesselInfo: 'Информация о морских перевозках',
  AirSecondVesselInfo: 'Информация о перевозке воздушным транспортом',
  SecondVoyage: 'Двойной рейс',
  BargeInfo: 'Информация о барже',
  ServiceCode: 'код маршрута судна',
  ModulesInfo: 'Информация о модуле',
  ShippingAdviceRemark: 'Shippingadvice Комментарии',
  BookingConfirmationRemarks: 'Примечания к уведомлению о распределении',
  InviteToChecktheBL: 'Приглашение к одному',
  ConfirmChecking: 'Подтверждение правильности',
  IdentificationList: 'Идентифицировать список',
  ChecktheBLBySmart: 'Умная пара',
  ViewCheckingFile: 'Просмотреть один файл',
  CheckingHistory: 'Однозначная история',
  UploadGuarantee: 'Загрузить гарантию',
  ReceiptHistory: 'История квитанций',
  CopyTheDataBy: 'Запись данных',
  CopyFromTheLastTime: 'Запись в прошлый раз',
  CopyFromOtherBill: 'Зап. номера ',
  CopyFromHbl: 'Скачать HBL',
  CompleteTheDetails: 'Завершение пополнения',
  Printed: 'Печать',
  Locked: 'Заблокировано',
  ShipperLocked: 'Поставщик заблокирован.',
  BlBeReleased: 'Дислокационный лист',
  BlEdi: 'коносамент EDI',
  ManifestEdi: 'Манифест EDI',
  ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS: 'Номер коробки, число мест, вес брутто',
  PrintBargeVesselAndVoyage: 'Распечатать номер баржи',
  ConsigneeShipperAndNotifyInfo: 'Пол.и пер.инф.',
  Reset: 'Очистить',
  CopyTheConsignee: 'Запись получателя',
  CargoInfo: 'Информация о грузе',
  OnlyOriginalSend: 'Только оригинал',
  OnlyAddAndDeleteSend: 'Только изменения и удаления',
  NoSuccessAddAndDeleteNotSend: 'Не удалось отправить, повторная отправка изменений или удалений невозможна',
  NeedFillPortBeforeEnteringEU: 'Необходимо указать порт перед въездом в ЕС',
  SyncContainerInfoTotal: 'Сбор информации о упаковке',
  SyncContainerInfoContent: 'Упаковка информационного элемента шерсти покрывает MBL, покрывает ли это?',
  SyncContainerInfoQuantity: 'Количество мест (упаковок): {0} - - > Количество мест (MBL): {1}',
  SyncContainerInfoWeight: 'Вес брутто (упаковка): {0} - - > Вес брутто (MBL): {1}',
  SyncContainerInfoCubage: 'Объем (упаковка): {0} - - - > Объем (MBL): {1}',
  NumberOfPackagesOnBl: 'Количество коносаментов',
  Pieces2: 'Количество мелких единиц',
  PiecesType2: 'Упаковка мелких деталей',
  Weight: 'Вес брутто',
  WeightUnit: 'Единицы брутто',
  Cubage: 'Объем',
  CubageUnit: 'Единицы объема',
  CopyEnglishDescriptionOfGoodsFromReceipt: 'Название (англ.)',
  CopyEnglishDescriptionOfGoodsFromHBL: 'HBL (англ.)',
  CopyMarksFromHbl: 'Маркировка HBL.',
  CapitalizedNumbersOfPackages: 'Количество записей в верхнем регистре',
  TransportInfo: 'Транспортная информация',
  VesselAndVoyage: 'Название судна',
  PlaceOfReceipt: 'Место отправления',
  PlaceOfReceiptOnBl: 'Место отправления коносамента',
  PlaceOfReceiptCodeOnBl: 'Место отправления (код)',
  PlaceHolderPOR: 'Пожалуйста, выберите код места отправки коносамента.',
  PlaceOfReceiptOnBlTootip: 'Место отправления коносамента',
  PortOfLoadingOnBl: 'Порт отправления коносамента',
  PortOfDischargeOnBl: 'Порт разгрузки коносамента',
  PlaceOfDeliveryOnBl: 'Место сдачи коносамента',
  BlFinalDestination: 'Конечный пункт назначения коносамента',
  MethodOfMblPayment: 'Способы оплаты MBL',
  PlaceOfMblPayment2: 'Место платежа MBL',
  TransportationClause: 'Условия перевозки',
  NoOfOriginalBls: 'Количество экземпляров коносамента',
  NoOfCopyBls: 'Количество экземпляров',
  PlaceOfIssue: 'Место выдачи',
  DateOfIssue: 'Дата выдачи',
  HBLDateOfIssue: 'Дата выпуска HBL',
  BlRemarks: 'Примечания к коносаменту',
  BlType: 'Форма коносамента',
  HBLBlType: 'Формы коносамента HBL',
  MBLBlType: 'Формы коносамента MBL',
  MBLBlProperty: 'Типы коносаментов MBL',
  HBLBlProperty: 'Виды коносаментов HBL',
  LastEntryPort: 'Последний порт въезда',
  BlProperty: 'Вид коносамента',
  CheckingStatus: 'Статус подтверждения коносамента',
  BillLadingIssued: 'Статус выдачи коносамента',
  HBLCheckingStatus: 'Статус коносамента HBL',
  MBLCheckingStatus: 'Статус коносамента MBL',
  ReleasingStatus: 'Статус проверки листа',
  HBLReleasingStatus: 'HBL Состояние.',
  MBLReleasingStatus: 'Состояние MBL',
  ReleaseEligibleStatus: 'Release Eligibility',
  ReleaseEligibleYes: 'Releasable',
  ReleaseEligibleNo: 'Not Releasable',
  FormalHblReleaseType: 'Формальные формы',
  FormalHblStatus: 'Формально - раздельное состояние',
  FormalHblIssuedStatus: 'Статус выдачи бланков',
  FormalHblType: 'Тип формы',
  FormalHblCombineNo: 'Формальные накладные и отдельные номера',
  fields: 'Поле &',
  tab: 'Подписка страницы',
  hint: 'Поле не совпадает, подтверждается ли отправка?',
  Audit: 'Проверка',
  Payable: 'Подлежащие оплате',
  CargoDetention: 'Арест',
  PaymentDate: 'Дата платежа',
  PaymentDate2: 'Дата платежа',
  DateOfCargoDetention: 'Дата вычета',
  BlReleasingNo: 'Поместить номер',
  BlReleasingApplicationTime: 'Время подачи заявки',
  BlReleasingApplicationPerson: 'Заявитель на выдачу ордера',
  ParamRemark: 'Подпись примечание',
  ShippingCompanySCAC: 'Судоходная компания SCAC',
  OverseasAgentSCAC: 'Зарубежные агенты SCAC',
  ShipperType: 'Тип отгрузки',
  ManifestDescriptionOfGoods: 'Наименование грузовых манифестов',
  ReasonOfCargoDetention: 'Причины вычета',
  HblNo2: 'Номер HBL',
  MblNo: 'Номер MBL',
  Quantity: 'Количество претензий',
  WeightKg: 'Вес брутто (KG)',
  CubageCbm: 'Объем (CBM)',
  ContainerAmount: 'Количество ящиков',
  CNTRNOSSEALNOS: 'Сведения об упаковке',
  BillOfLadingPackingInfo: 'Сведения об упаковке коносамента',
  CopyMblConsignee: 'Получ. о.м.',
  CopyNominatedAgentInfo: 'Информация об агенте заказа',
  PrintTheOriginalBl: 'Оригинальная печать',
  TelexRelease: 'Электропечать',
  Unlock: 'Разблокировать',
  AntiTerroristFormattedAddress: 'Антитерр. форм.',
  BlBeReleasedElsewhereOrNot: 'Располагается ли ордер',
  ClauseOfNoWoodPackingMaterial: 'Условия недревесной упаковки',
  AFRTheLastBill: 'Последний голос AFR',
  CopyEnglishDescriptionOfGoodsFromMbl: 'Английское название MBL.',
  CopyMarksFromMbl: 'Отметить MBL',
  BillOfLadingNumber: 'Номер коносамента',
  HBLBillOfLadingNumber: 'Номер коносамента HBL',
  MethodOfHblPayment: 'Способы оплаты HBL',
  PlaceOfHblPayment2: 'Место платежа HBL',
  CheckingQuestions: 'На один вопрос',
  BlType2: 'Тип коносамента',
  HBLBlType2: 'Тип коносамента HBL',
  DataSent: 'Распр. инф.',
  Completed: 'Завершено',
  paste: 'Вставить вложение',
  V3remind: 'Пожалуйста, скопируйте вложение.',
  DateOfcompletion: 'Дата завершения',
  GenerationOfABillOfLading: 'Выдача коносамента',
  GenerationOfABillOfLading2: 'Выдача коносамента',
  ShipperContactTelNo: 'Контактный телефон отправителя',
  ConsigneeContactTelNo: 'Контактный телефон грузополучателя',
  NotifyPartyTelNo: 'Контактный номер',
  ChargeClause: 'Условия оплаты',
  Amount: 'Сумма',
  CopyCargoDescriptionAndMarks: 'Список наименований',
  CopyMbl: 'Копировать MBL',
  RelatedMbl: 'Связанный основной лист',
  Add3: 'Присоединение',
  Copy: 'Копировать',
  Send: 'Отправить',
  CheckStatus: 'Статус запроса',
  ImportButNotSend: 'Импорт не отправляется',
  CapitalizedNumbersOfEquipmentWeight: 'Большой регистр',
  AmsSplitNo: 'Номер AMS',
  AmsNo: 'Номер AMS',
  EManifestSplitNo: 'eManifest Поделиться',
  EManifestNo: 'Номер eManifest',
  BlSplitList: 'Список разделов',
  sendStatusAMS: 'Состояние отправки (AMS)',
  sendStatusISF: 'Состояние отправки (ISF)',
  sendStatus: 'Отправить состояние',
  SealNoChangeAdfterInspection: 'Проверить изменение номера',
  AutoAllocation: 'Автоматическая упаковка',
  AutoAllocationContract: 'Автоматическая упаковка (доверенность)',
  CleanOutTheLoadingRecord: 'Уборка упаковочных документов',
  DeleteTheLoadingRecord: 'Удалить запись упаковки',
  CargoQuantityDescription: 'Описание объема',
  TotalNumberOfPackages: 'Общее число претензий',
  ContainerSize: 'Ящик',
  ContainerType: 'Ящик',
  ContainerWeight: 'Вес ящика',
  SealNo: 'Печать',
  TravelTrajectory: 'Маршрут',
  DrivingState: 'Текущий режим движения',
  CurrentVehicleLocation: 'Текущее расположение автомобиля',
  GetContainerNo: 'Получить номер ящика',
  TotalWeight: 'Общий вес брутто',
  TotalCubage: 'Общий объем',
  Soc: 'Контейнер владельца',
  Inspection: 'Проверка',
  ApproachDate: 'Время захода',
  PlayDate: 'Время выхода',
  LoadingPort: 'Порт погрузки',
  TheArrivalOfPacketsSent: 'Время отправки сообщений о прибытии',
  CustomsClearanceInfo: 'Информация о таможенном освобождении',
  DataTrackingBlHasNotContainer: 'Номер коносамента {0}, пожалуйста, перейдите на страницу упаковочной информации и подпишите его после использования функции сравнения данных. Подписка на этой странице покажет детали коробки.',
  WharfReleaseInfo: 'Информация о порту',
  ContainerAscription: 'Ящик',
  PlateNumber: 'Номер передней части',
  plateApproachDate: 'Время захода на посадку',
  platePlayDate: 'Время выхода на паркет',
  PackageType: 'Тип упаковки',
  NumberOfVotes: 'Число голосов',
  EmptyContainerWeight: 'Вес пустого ящика',
  VgmWeight: 'Вес VGM',
  VgmWeighingMethod: 'Метод взвешивания VGM',
  VgmWeighingTime: 'Время взвешивания VGM',
  WeightTime: 'Время взвешивания',
  VgmWeighingPlace: 'Место взвешивания VGM',
  WeighingPartyAddress: 'Адрес весовой стороны',
  StationStatus: 'Статус станции',
  CargosGrossWeight: 'Вес брутто груза',
  VgmContactPerson: 'Контакты VGM',
  VgmContactEmailAddress: 'Контактный почтовый ящик VGM',
  VgmContactWay: 'Контакты VGM',
  VgmResponsiblePerson: 'Руководитель VGM',
  ContactEmailAddress: 'Контактный почтовый ящик',
  ContactWay: 'Контактная информация',
  ContactAddress: 'Контактный адрес',
  ResponsiblePerson: 'Ответственные лица',
  Name: 'Имя',
  Warehouse2: 'Внутренний склад',
  WarehouseLoading: 'Внутри склада',
  LoadingCharge: 'Расходы на упаковку',
  LoadingCharge2: 'Расходы на упаковку',
  BoxOwner: 'Владелец ящика',
  RmbNumberOfDamagedAndDamp: 'Количество поврежденных мокрых мест',
  RmbNumberOfDamagedAndDamp2: 'Количество поврежденных мокрых мест',
  Tel: 'Телефон',
  CargosExpectedArrivalDate: 'Предполагаемая дата прибытия',
  WarehouseAddress: 'Адрес склада',
  LoadingRemarks: 'Внутреннее оборудование',
  DoorToDoorLoading: 'Упаковка от двери до двери',
  MultiDoors: 'Многодв.точка',
  HaulageNo: 'Номер заказа',
  HaulageCharge: 'Плата за буксировку',
  AuditMoney: 'Подтверждение суммы',
  AuditState: 'Состояние расходов',
  HaulageContactPerson: 'Связь с автоколоннами',
  Door: 'Точка входа',
  AddDoor: 'Новые двери',
  DestinationGatewayCity: 'Вход в город',
  DoorContactPerson: 'Контакты с точками входа',
  DoorAddress: 'Адрес точки входа',
  DispatchVehiclesAtDestinationDoorAddress: 'Адрес порта назначения',
  DoorCity: 'Город Ворот',
  Driver: 'Водитель',
  ComprehensiveLogisticsOrderType: 'Тип комплексного логистического заказа',
  ComprehensiveLogisticsTransportationType: 'Типы комплексных логистических перевозок',
  TransportType: 'Вид перевозки',
  SameTransportationCompany: 'Транспортная компания такая же.',
  SameDoorPoint: 'Дверь такая же.',
  ReturnYard: 'Склад возврата контейнеров',
  DriverIDCard: 'Водительское удостоверение.',
  DestinationGatePoint: 'Пункт назначения',
  DepartureGatePoint: 'пункт отправления',
  AddressOfDestinationGatePoint: 'Адрес пункта назначения',
  DestinationGateCity: 'Город назначения',
  CarryingCaseYard: 'Чемоданы',
  EstimatedPackingDate: 'Предполагаемая дата упаковки (прибытие на завод)',
  ActualPackingDate: 'Фактическая дата упаковки (прибытие на завод)',
  EstPackingDate: 'Предполагаемая дата упаковки (прибытие на склад)',
  ActPackingDate: 'Фактическая дата упаковки (прибытие на склад)',
  ExpectedArrivalDate2: 'Предполагаемая дата прибытия',
  ActualArrivalDate: 'Фактическая дата прибытия',
  GatheringTrailer: 'Прицеп для сбора карт',
  WholeVehicleLessThanCarload: 'Нос для всей машины',
  TruckCustomerService: 'Грузовик обслуживает',
  DtdDTWWTD: 'От двери до двери / от двери до склада / от склада до двери',
  DoorToDoor: 'От двери до двери',
  DoorToWarehouse: 'От двери до бункера.',
  WarehouseToDoor: 'От склада до двери',
  AdditionalNotes: 'Примечания',
  AssociatedPackingInfo: 'Сведения об ассоциативной упаковке',
  RemoveAssociations: 'Удалить связь',
  DispatchTuckOrder: 'Приказ',
  ModifyTuckOrder: 'Перечень изменений',
  TuckStatusDescription: 'Доставка автомобилей Подробнее',
  ManualDistribution: 'Ручное распределение',
  Unlock2: 'Снять',
  Size: 'Размер',
  WhetherOrNotBroken: 'Не поврежден',
  BrokenDesc: 'Описание ущерба',
  BangPic: 'Фотографии склада',
  WareHouseName: 'Название склада',
  WarehouseSupplier: 'Поставщики складов',
  WareHouseMarks: 'Маркировка склада',
  CustomsDeclarationInfo: 'Таможенная информация',
  OnwardInfo: 'Информация о продолжении',
  TheActualFlight: 'Фактический рейс',
  NewCustomsDeclaration: 'Дополнительные таможенные декларации',
  EditCustomsDeclaration: 'Редактирование таможенной декларации',
  DeleteCustomsDeclaration: 'Удалить таможенную декларацию',
  BlNo: 'Номер коносамента',
  OperatingCompany: 'Эксплуатационное подразделение',
  CustomsCode: 'Таможенная декларация 10 - битного кода',
  DateOfCustomsDeclaration: 'Дата таможенной декларации',
  StatusOfCustomsDeclaration: 'Статус таможенной декларации',
  CommodityInspectionOrNot: 'Есть ли коммерческая инспекция',
  CustomsInspectionOrNot: 'Проверка',
  UploadFile: 'Загрузить файл',
  CustomsFile: 'Таможенные документы',
  Chargeback: 'Платежи',
  TemplateDownload: 'Загрузить шаблон',
  ExcelImport: 'Импорт Excel',
  ExcelExport: 'Экспорт Excel',
  OrderNo: 'ORDER NO - Номер заказа',
  CaseNo: 'CASE NO Серийный номер',
  Item: 'ITEM Коды товаров',
  Sub: 'Номер партии SUB',
  Size2: 'Спецификация',
  CommodityClassification: 'Классификация',
  Qty: 'QTY Количество',
  BillingQTY: 'Количество счетов',
  UnitOfMeasurement: 'Единицы измерения',
  NetWeight: 'Вес нетто',
  CustomsDutyRate: 'Тарифные ставки',
  CustomsDuties: 'Таможенные пошлины',
  IncrementValueDutyRate: 'Ставка НДС',
  IncrementValueDuty: 'Налог на добавленную стоимость',
  ConsumptionDutyRate: 'Ставка акциза',
  ConsumptionDuty: 'Потребительский налог',
  ConsolidatedTax: 'Совокупный налог',
  Currency: 'Валюта',
  ExchangeRate: 'Обменный курс',
  CargoPrice: 'Цена',
  Tax: 'Налоги',
  TaxRate: 'Налоговые ставки',
  BigBagNo: 'Большой пакет',
  BigBagWeight: 'Вес большой упаковки',
  BigBagWeightUnit: 'Единицы веса',
  BigBagLength: 'Большая сумка',
  BigBagWidth: 'Ширина пакета',
  BigBagHeight: 'Высокий пакет.',
  BigBagDimensionUnit: 'Единицы длины пакетов',
  BigBagGoodsType: 'Тип груза большой упаковки',
  FulfillmentLabel: 'Вид исполнения',
  LandingPort: 'Пункт посадки',
  PackageQuantity: 'Количество упаковки',
  ExpectPickupStartTime: 'Ожидание начала сбора',
  ExpectPickupEndTime: 'Ожидание окончания сбора',
  PreviousCarrierCode: 'Предыдущий Code',
  PreviousResourceCode: 'Предыдущий Code',
  NextCarrierCode: 'Следующий Code',
  NextResourceCode: 'Следующий ресурс Code',
  SortCode: 'Код сортировки больших пакетов',
  BuyerRegion: 'Страна назначения',
  AddressL0: 'Адрес уровня L0',
  AddressL1: 'Адрес уровня L1',
  AddressL2: 'Адрес уровня L2',
  AddressL3: 'Адрес уровня L3',
  AddressL4: 'Адрес уровня L4',
  DetailsAddressMore: 'Подробный адрес 2',
  PickupFirstName: 'Фамилия получателя',
  PickupLastName: 'Имя получателя',
  PickupCompany: 'Название компании - получателя',
  PickupZip: 'Почтовый индекс',
  PickupPhone: 'Номер мобильного телефона.',
  TtOrderCode: 'Номер TT',
  MwbNo: 'Номер поставщика услуг',
  Export9610File: 'Экспорт файлов 9610',
  BatchChangeCompany: 'Компания по массовой замене',
  OnlyCheckOneData: 'Допускается только одна запись.',
  NoteUseNumLast: 'Примечание: после замены компании номер одного не будет воссоздан, все равно будет использоваться существующий номер.',
  OrderNo2: 'Номер заказа',
  SupportSales: 'Поддержка продаж',
  OrderAmount: 'Сумма заказа',
  ServiceFeeDiscountRate: 'Ставка скидок на оплату услуг',
  OperatingInstructions: 'Описание операций',
  OrderCurrency: 'Валюта заказа',
  TheAmountOfWriteOffs: 'Сумма списанных заказов',
  TheFirstBusinessOrNot: 'Является ли первый',
  Salesman: 'Оператор',
  OrderExchangeRate: 'Обменный курс заказа',
  Difference: 'Разница',
  FrameContractNumber: 'Рамочный контракт',
  PaymentNo: 'Номер платежа',
  PaymentAmount: 'Сумма платежа',
  ThePrePayment: 'Выплата аванса',
  PaymentExchangeRate: 'Валютный курс',
  ActualPaymentAmount: 'Фактическая сумма платежа',
  ServiceCharge: 'Плата за услуги',
  PostalCharges: 'Расходы на связь',
  AcceptanceFee: 'Плата за акцепт',
  RetreatMoreFillLessAmount: 'Сумма возмещения',
  Total: 'Резюме',
  UnpaidAmount: 'Сумма невыплаченных переводов',
  No: 'Нет',
  Yes: 'Да.',
  New: 'Новстрой',
  Clone: 'Копирование',
  Send2: 'Отправка',
  Back: 'Взять обратно',
  ExpressInfo: 'Экспедиция',
  PrintReceipt: 'Распечатать квитанцию',
  FileType: 'Тип документа',
  FileType2: 'Тип',
  FileCategory: 'Категория документа',
  CustomsNo: 'Таможенный номер',
  SendingDate: 'Дата отправки',
  SendingExpressNumber: 'Отправьте номер.',
  ReceivingDate: 'Дата возвращения',
  Receiver: 'Вернуть людей',
  ReturnDate: 'Дата возвращения',
  ReturnExpressNumber: 'Вернуть номер курьера',
  DateOfDeclaration: 'Дата объявления',
  FileStatus: 'Статус файла',
  TenBitCode: 'Десятизначный код',
  ReceiverCompanyName: 'Получающая единица',
  Receiver2: 'Получатель',
  CustomsDeclarationPages: 'Количество страниц таможенной декларации',
  CustomsTransitOrNot: 'Транспортировка',
  TakeByCustomsBroker: 'Таможенная декларация сама себя',
  ExpressAddress: 'Адрес курьера',
  PrintChargebackList: 'Печать (список возвратов)',
  ViewFile: 'Просмотр документов',
  ChargebackFile: 'Документ о возврате',
  CheckPreRecordedCustomsDeclaration: 'Предварительный запрос таможенной декларации',
  CheckStatusOfCustomsDeclaration: 'Проверка состояния таможенной декларации',
  All: 'Все.',
  GeneralTrade: 'Общая торговля',
  Processing: 'Обработка материалов',
  FeedingCounterparts: 'Входной коллектор',
  SamplesOfAdvertisingProducts: 'Образец рекламы',
  OtherImportsFree: 'Другие импортные бесплатно',
  CustomerName: 'Название клиента',
  CustomerAddress: 'Адрес клиента',
  Confirm: 'Подтверждение',
  DangerousGoods: 'Опасные грузы',
  DangerousGoodsRequired: '« Почтовый ящик контакта с опасными грузами», « факс контакта с опасными грузами» Обязательно заполнить',
  DangerousGoodsLabel: 'Маркировка опасных грузов',
  MedicalEmergencyGuideNo: 'Экстренная медицинская помощь.',
  SetTemperature: 'Установить температуру',
  MinimumTemperature: 'Минимальная температура',
  MaximumTemperature: 'Максимальная температура',
  PortForReturningContainer: 'район подачи контейнеров',
  NonStandardContainer: 'Стандартная коробка',
  OverFront: 'Предыдущий Супер',
  OverBack: 'После супер',
  OverHeight: 'Сверхвысокая',
  OverLeft: 'Левый Чао',
  OverRight: 'Правый Супер',
  EditionStatus: 'Изменить статус',
  UpdateExternalState: 'Обновить внешний статус',
  Refresh: 'Обновить',
  Save: 'Сохранить',
  ShowAllPoints: 'Показать все узлы',
  SopStateNote: '* Примечание: Закрытые узлы больше не будут отправлять предупреждения узлов и уведомления об изменении состояния SOP',
  PaymentInformationImport: 'Импорт платежной информации',
  Invalid: 'Отмена',
  QueryContainerInfo: 'Сведения об упаковке',
  Hbl2: 'Товарный номер',
  Mbl2: 'Основной номер',
  PortOfLoadingAgent: 'Агент порта отправления',
  TheFirstVessel: 'Название судна',
  CustomerReferenceNumber: 'Справочный номер клиента',
  BusinessType: 'Вид деятельности',
  BillExchange: 'Изменить заказ',
  Storage: 'Хранение',
  Devanning: 'Разбор ящиков',
  DeliveryToDoor: 'Доставка через ворота',
  MblNo4: 'Номер основного билета',
  InternationalTransport: 'Международные перевозки',
  ActualNotifyParty: 'Фактический уведомитель',
  ActualNotifyPartyHeader: 'Уведомление фактического лица',
  ConsignationCompanyHeader: 'Заказчик поднимает голову',
  Fax: 'Факс',
  BillExchangeAgent: 'Агент по обмену',
  CustomsHblNo: 'Номер таможенной декларации',
  SecondCheck: 'Две поездки',
  SecondVessel: 'Название второго судна',
  AutoRetrieve: 'Автоматический доступ',
  AccordingToVesselVoyageGets: 'Получено по названию судна',
  ActualDateOfArrival: 'Дата фактического прибытия',
  ActualDateOfArrival2: 'Фактическая дата прибытия (ATA)',
  AtaImport: 'ATA (Импорт)',
  DateOfDelivery: 'Дата получения',
  DateOfArrivalTheWarehouse: 'Дата входа в репозиторий',
  Code2: 'Код',
  Region: 'Зоны',
  CountryOrigin: 'Происхождение',
  PartyIDType: 'Тип документа',
  PartyID: 'Номер документа',
  BillsOfLadingDoubleClickEject: 'коносамент вверх - двойной щелчок всплывает',
  TradeTerms: 'Условия сделки',
  PreCollection: 'Авансы',
  HblCargoReleaseWay: 'Порядок раздельного выпуска',
  MblCargoReleaseWay: 'Основной способ выпуска',
  VesselCode: 'Код судна',
  BillExchangeDate: 'Дата обмена',
  Department: 'Сектор',
  PolOperation: 'Эксплуатация порта отправления',
  PodOperation: 'Операции в порту назначения',
  VesselOfChineseName: 'Название китайского судна',
  TotalWeight2: 'Общий вес',
  TotalWeightUnit: 'Единицы веса',
  NumberOfDamagedAndDamp: 'Количество поврежденных мокрых мест',
  EstimatedDateOfArrivalTheWarehouse: 'Предполагаемая дата складирования',
  EstimatedDateOfPickingUpTheContainer: 'Предполагаемая дата чемодана',
  DateOfReturningTheContainer: 'Дата возврата',
  SanitaryAndPhytosanitaryStandard: 'Инженерная инспекция',
  PriceCalculation: 'Расчет продажной цены',
  Down: 'Переместить вниз',
  Up: 'Переместить вверх',
  Total2: 'Всего',
  HasPrintBooking: 'Печать бронирования',
  FirstLegNo: 'Номер заголовка',
  FirstLegNoTips: 'Ключевые идентификаторы для управления внутренними перевозками и предэкспортными операциями в международной авиационной логистике',
  OperateType: 'Режим работы',
  CustomsDeclarationWay: 'Таможенная декларация',
  CustomsDeclarationType: 'Тип таможенной декларации',
  AirlineCompany: 'Авиакомпании',
  Flight: 'Рейсы',
  FlightNo: 'Номер рейса',
  PortOfHub: 'Порт HUB',
  CommissionedNumberOfPackages: 'Число поручений',
  CommissionedGrossWeight: 'Поручить вес брутто',
  CommissionedVolume: 'Объем заказа',
  ActualChargedWeight: 'Фактический вес',
  PrintingPlatePhotos: 'Фото на доске',
  ProtocolType: 'Тип соглашения',
  FieldOperation: 'Полевые операции',
  OverseaOperation: 'Операции за рубежом',
  Auditor: 'Аудитор',
  preverifyDate: 'Дата проверки',
  OtherWarehouseNotes: 'Прочие замечания',
  JobNo: 'Номер работы',
  NominatedAgent2: 'Назначить агента',
  AirFreighMode: 'Воздушные перевозки',
  WarehouseNo2: 'Номер входа',
  PleaseInputJobNo: 'Введите рабочий номер.',
  PrintProfitAnalysis: 'Анализ прибыли',
  SendToBranchCompany: 'Отправить филиал',
  EnterTransitInfo: 'Вв. транз. инф.',
  ArrivalForTheSecondJourney: 'Прибытие 2.',
  LeaveForTheSecondJourney: 'Отойдите на второй путь.',
  ArrivalForTheThirdJourney: 'Прибытие в три',
  LeaveForTheThirdJourney: 'Отойдите на три пути.',
  PreAlertOperation: 'Операции прогнозирования',
  Actual: 'Фактический показатель',
  Frontcabin: 'Передний отсек',
  FrontCabinActual: 'Передний отсек (фактический)',
  Documentation: 'Оформление',
  Select: 'Выбор',
  Join: 'Присоединение',
  Separate: 'Разделение',
  pbProportion: 'Кл. Pb',
  pbProportion2: 'Пост. Pb',
  SpaceRquirement: 'Требования в отношении класса проезда',
  OnBoardRequirements: 'Требования к монтажу',
  DocumentationRequirements: 'Требования к оплате',
  SellingPrice: 'Продажа',
  BuyingPrice: 'Покупательная цена',
  SalesBranchCompany: 'Отдел продаж',
  CopyFromOtherBill2: 'Запись номера',
  CodeSearching2: 'Выбор кода',
  ResetInitialValue: 'Сбросить начальное значение',
  CopyTheMbl: 'Переч. док.',
  InputWarehouseData: 'Ввод данных',
  EditWarehouseData: 'Редактирование входных данных',
  DeleteWarehouseData: 'Удалить входные данные',
  CancelInvalid: 'Отмена',
  MblInfo: 'Информация о билете',
  AirOperation: 'Воздушные перевозки',
  CustomerSpecialRequirements: 'Особые потребности клиентов',
  AirportHandlingAgent: 'Наземный агент',
  CustomsTenBitCode: 'Десятизначный код таможенной декларации',
  InspectionTenBitCode: 'Проверка десятичного кода',
  TradeDetail: 'Детали груза',
  TradeCommission: 'Торговля',
  HblInfo: 'Распределение информации',
  MBLInfo: 'Информация о коносаменте (MBL)',
  Charge: 'Расходы',
  InternalBillInfo: 'Внутренние счета',
  OverseaBillInfo: 'Зарубежные счета',
  AdvanceChargeInfo: 'Авансы по инкассации',
  DocumentCirculation: 'Передача документов',
  FileHistory: 'История файлов',
  ImportToPDF: 'Импорт PDF',
  Trucking: 'Клиентские двери',
  ImportOperation: 'Операция импорта',
  CustomsDeclarationOnward: 'Таможенная очистка / продолжение',
  WarehouseDoorLoading: 'Упаковка внутри склада / на двери',
  GrossWeight: 'Вес брутто',
  CustomJobType: 'Пользовательский тип бизнеса',
  TaxNature: 'Налоговый характер',
  ContainerInfo2: 'Информация о контейнерах',
  ContainerIdentification: 'Маркировка контейнеров',
  CopyConsignationDescriptionAndMarks: 'Перечень наименований по заказу',
  SelecteAll: 'Выбрать все',
  ConsigneeShipperAndNotifyAddress: 'Адрес приемопередатчика',
  ShipperId: 'Код отправителя',
  ConsigneeId: 'Код грузополучателя',
  NotifyId: 'Код уведомления',
  ShipperInfo: 'Информация о отправителе',
  ConsigneeInfo: 'Информация о грузополучателе',
  NotifyInfo: 'Уведомление',
  CopyShipper: 'Выбор отправителя',
  CopyConsignee: 'Выбор грузополучателя',
  CopyNotify: 'Выбор уведомителя',
  CopyManifestShipper: 'Выбор отправителя манифеста',
  CopyManifestConsignee: 'Выбор получателя манифеста',
  CopyManifestNotify: 'Выберите лицо, уведомляющее о манифесте',
  CopyAll: 'Выбор',
  FillInQuantityOfVotes: 'Число поданных голосов',
  QueryLCLJobOrder: 'Добавить запрос в корзину',
  QueryLCLJobOrder2: 'Добавить запрос в список',
  QuantityOfSelectedOrder: 'Число избранных голосов',
  NoDisplay: 'Не показывать',
  Number: 'Число голосов',
  SelectSoNo: 'S / O Нет выбора',
  MBLHBR: 'MBL с одним номером',
  AgentInfo: 'Агент',
  HBLHBR: 'HBL - Однозначный',
  ChargeItem: 'Название расходов',
  Close: 'Закрыть',
  SearchJobNo: 'Поиск рабочих листов',
  SerialNo: 'Поток',
  Search: 'Поиск',
  VolumeOnBl: 'Объем коносамента',
  MethodOfPayment: 'Способы оплаты',
  PortOfFinalDestination: 'Порт конечного назначения',
  SelectContainerInfo: 'Выберите информацию об упаковке',
  SearchTheWarehouseRecords: 'Поиск архивных записей',
  ReceiptNo: 'Номер квитанции',
  warehouseOp: 'Складчик',
  deliveryCMP: 'Компания доставки',
  inDate: 'Дата складирования',
  DamagedAndDamp: 'Ущерб от сырости',
  EntryCustomsInformation: 'Ввод таможенной информации',
  Recorded: 'Введён',
  ListPulled: 'Выдано',
  AtReception: 'На стойке регистрации.',
  CustomsDeclared: 'Хорошо.',
  Undeclared: 'Не сообщается',
  CustomsExamination: 'Таможенный контроль',
  InspectionExamination: 'Коммерческая инспекция',
  ExamedWithoutReleasing: 'Проверено не выпущено',
  AmendDeclaration: 'Перечень изменений',
  NotifyToDeclare: 'Таможенная декларация с уведомлением',
  CustomsExamed: 'Проблемы с таможенным контролем',
  PreNumber: 'Номер ввода',
  ContainerNo2: 'Шкаф',
  UnknownState: 'Неизвестное состояние',
  ProductName: 'Название программы',
  Carrier: 'Перевозчик',
  RecordCount: 'Число записей',
  Autowire: 'Автоматическое согласование',
  SchemaName: 'Название программы / расходов',
  Receivable: 'Получение и оплата',
  PartnerType: 'Тип расчетной единицы',
  Account: 'Фиксированная расчетная единица',
  MeasureCurrency: 'Расчетная единица',
  MeasureUnit: 'Расчетный модуль',
  UnitRate: 'Стоимость единицы',
  MiniMum: 'Минимальная плата',
  FCLFreightTariff: 'Тарифный лист',
  PleaseInputTariffSheet: 'Введите номер тарифного листа.',
  CostLeave: 'Класс тарифа:',
  ValidFrom: 'Срок действия с',
  ValidTo: 'Срок действия до',
  MON: 'Понедельник',
  TUE: 'Вторник',
  WED: 'Среда',
  THU: 'Четверг',
  FRI: 'Пятница',
  SAT: 'Суббота',
  SUN: 'Воскресенье',
  GetCostsByTheCabinet: 'Разбивка расходов по типу шкафа',
  ShippingFeesAreALLINTHEWAYImport: 'Морской тариф импортируется в виде ALL IN',
  PriceNo: 'Номер тарифа',
  BranchCMP: 'Филиал',
  IsDirect: 'Прямой',
  PriceState: 'Класс проезда',
  Trend: 'Тенденции',
  Share: 'Характер класса проезда',
  ContractNo: 'Номер договора',
  PriceFrom: 'Источник тарифа',
  SailingDate: 'Продолжительность судна',
  Voyage2: 'дальность полёта',
  Cargo: 'Товары',
  Box: 'Ящик',
  Dock: 'Присоединяйтесь к пристани.',
  LCLFreightTariff: 'Тарифный лист',
  ImportCostsByPeers: 'Расходы на импорт по паритетным ценам',
  PriceState2: 'Тарифное состояние',
  CostValue: 'Стоимость',
  PeerPrice: 'Эквивалент',
  DirectPrice: 'Прямая цена',
  MarketPrice: 'Рыночная цена',
  ClosingDay: 'День таможенной очистки',
  ShareCarrier: 'Комбункерная компания',
  VerificationSchedule: 'Подробная информация о списании',
  Cash: 'Наличные средства',
  Check: 'Чек',
  Transfer: 'Переводы',
  ClearingDate: 'Дата списания',
  PayReceiveDate: 'Дата получения',
  VerificationBy: 'Списание',
  ClearCurrency: 'Валюта списания',
  ClearRate: 'Курс списания',
  ClearAmount: 'Списанные суммы',
  VoucherNo: 'Номер документа',
  OurBank: 'Наш банк',
  AddBillCharge: 'Расходы на присоединение',
  RemoveBillCharge: 'Расходы на удаление',
  ShowBillDetail: 'Показать информацию о счете',
  Close2: 'Убрать',
  OverseasBillingMaintenance: 'Обслуживание счетов за рубежом',
  MainOffice: 'Счет компании',
  BillType: 'Тип счета',
  BillAmount: 'Налоги',
  AccountObject: 'Объект расчетов',
  Bank: 'Банк - депозитарий',
  BankAccount: 'Номер банковского счета',
  CounterPartyBillingNo: 'Номер счета',
  InputDate: 'Дата счета',
  RevenueTotalGroup: 'Итого, монеты',
  IncludingTaxAmount: 'Налоговая стоимость',
  ExcludingTaxAmount: 'Без учета налогов',
  WhetherCollectingAdvance: 'Получается ли аванс',
  Unit: 'Единицы измерения',
  Quantity2: 'Количество',
  ShowLcl: 'Показать стоимость билетов',
  AgentIntoBills: 'Агент делится на счет',
  Office: 'Возвышение счетов в филиале',
  Percentage: 'Разделение на пропорции',
  IsPercentage: 'Разделение',
  ChargeEnglishName: 'Название расходов на английском языке',
  ChangeSchema: 'Программа расходов',
  SendEMail: 'Отправить сообщение',
  LocalAgent: 'Локальный агент',
  placeholderVal: 'Выберите шаблон сообщения',
  UpDestAgent: 'Агент порта отправления / назначения',
  Haulage: 'Автоколонна',
  CompanyName: 'Название компании',
  GroupCode: 'Код компании',
  CompanyAddress: 'Адрес компании',
  Contact: 'Контактные лица',
  OtherInformation: 'Прочая информация',
  BlTitle: 'Наименование компании коносамента',
  BlAddress: 'Адрес коносамента',
  BlContact: 'Контактная информация коносамента',
  MscBlAddress: 'Адрес коносамента Msc',
  PleaseChooseItem: 'Сначала выберите проект, который необходимо выполнить.',
  WhetherDelete: 'Подтвердить удаление?',
  IsEmptyPleaseEnter: 'Для пустоты, заполните полностью.',
  Cc: 'Копировать',
  MailContent: 'Содержание почты',
  SystemEmail: 'Системный почтовый ящик',
  CompanyMail: 'Почтовый ящик компании',
  PersonalMailbox: 'Личный почтовый ящик',
  emailSubject: 'Почтовая тема',
  mailTemplate: 'Шаблоны сообщений',
  SaveTheDefaultCC: 'Сохранить копию по умолчанию',
  Title: 'Тема',
  Content: 'Содержание',
  operationalMotion: 'Действие операции',
  operationTime: 'Время работы',
  customsReceiptStatus: 'Статус таможенной квитанции',
  returnTime: 'Время возвращения',
  source: 'Источник',
  FileUpload: 'Загрузка файлов',
  FileName: 'Имя файла',
  FileSize: 'Размер файла',
  UploadProgress: 'Прогресс загрузки',
  DocumentType: 'Категория документа',
  SelectFile: 'Выбрать файл',
  DeleteFile: 'Удалить файл',
  Upload: 'Загрузить',
  PlsSeeEIR: 'Обратитесь к накладной на оборудование.',
  SelectCopyContent: 'Выберите содержимое для копирования',
  DuplicateContent: 'Копировать содержимое',
  BasicInfo: 'Основная информация',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAsk: 'После этого нажмите этот выбор, чтобы скопировать, больше не нужно спрашивать. Если необходимо изменить условия, нажмите кнопку Настройка в верхнем правом углу Настройки и Инструменты - Персонализация страницы',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft: 'Настройка этого выбранного содержимого для копирования содержимого по умолчанию',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight: 'Чтобы изменить настройки копирования содержимого, перейдите к значку меню в правом верхнем углу - Настройки & Инструменты - Персонализация страницы, нажмите кнопку Настройка',
  Slaves: 'Число голосов',
  Master: 'Число поданных голосов',
  CustomerCount: 'Число клиентов',
  SingleWeight: 'Индивидуальный вес',
  Weight2: 'Вес',
  ReceivableType: 'Вид поступлений и расходов',
  AccountType: 'Тип расчетной единицы',
  Account2: 'Расчетная единица',
  Oversea: 'Внутри страны и за рубежом',
  Remove: 'Удалить',
  SourceAmount: 'Первоначальная сумма',
  NewAmount: 'Новая сумма',
  IsUpdate: 'Обновить',
  ExportLog: 'Журнал экспорта',
  Role: 'Функции',
  Mobile: 'Мобильные телефоны',
  Email: 'Почтовый адрес',
  SOPOperatingState: 'Режим работы SOP',
  KG: 'Килограммы',
  CBM: 'кубический метр',
  Tons: 'Тонны',
  SelectOpRequirement: 'Операция требует выбора',
  PleaseInputAKeyword: 'Введите ключевое слово для поиска',
  contentDescription: 'Содержание',
  chargeItem: 'Расходы',
  LCLLastBillOfLading: 'Последний коносамент в упаковке',
  Addr: 'Адрес',
  HouseNumber: 'Номер дома',
  Country: 'Страна',
  Province: 'Провинции',
  City: 'Города',
  ZIP: 'Почтовый индекс',
  SelectCharge: 'Стоимость выбора',
  First: 'Первая страница',
  Pre: 'Предыдущая страница',
  Page: 'А',
  AllPage1: 'Всего',
  AllPage2: 'Страницы',
  Next: 'Следующая страница',
  Last: 'Последняя страница',
  ShowFromTo1: 'Показать',
  ShowFromTo2: 'А',
  AllRecord1: 'Всего',
  AllRecord2: 'Запись',
  Convert: 'Эквивалент',
  Received: 'Получено',
  Paid: 'Выплачено',
  AllPositions: 'Все посты',
  DestinationAgent1: 'Зарубежные агенты',
  Accessible: 'Доступно',
  IsDisplay: 'Показать',
  Uncertain: 'Не установлено',
  PrincipalUnitSOPReceiver: 'Получатель SOP',
  PortOfDestinationAgency: 'Агент порта назначения SOP получатель',
  DesignatedFreightAgentSOPReceiver: 'Назначение грузополучателя SOP',
  PortOfDepartureAgentSOPReceiver: 'Агент порта отправления',
  Unconfirmed: 'Не подтверждено',
  Confirmed: 'Подтверждено',
  PassAudit: 'Утверждено',
  Refuse: 'Отказ',
  Bl: 'коносамент',
  Original: 'Первоначальный',
  LateOriginal: 'Поздно',
  Correct: 'Исправление',
  Message: 'Сообщение',
  DeleteCustoms: 'Удаление (таможня удаляется, энтай - тай резервируется)',
  DeleteAll: 'Удалено (все таможенные службы Китая удалены)',
  send: 'Отправить',
  change: 'Перечень изменений',
  deleteSingle: 'Список сокращений',
  cancelBill: 'Снятие ордера',
  OverseasAgeFore: 'Прогн. ЗА',
  JclForecast: 'Прогноз JCL',
  AnnPackingList: 'Монтажный ящик',
  PreShippingBill: 'Авансовые накладные',
  PreShippingBillPperation: 'Эксплуатация накладных',
  ShippingBill: 'Манифест',
  Anti_terrorismShipping: 'Контртеррористический манифест',
  CleanShipping: 'Уборка грузов',
  Suitcase: 'Чемоданы',
  DelSuitcase: 'Удалить чемодан',
  ViewHistory: 'Посмотреть История',
  ElectronicPackingList: '99 Электронная упаковка',
  SendHistory: 'Отправить журнал',
  ShippingSchedule: 'Хронология',
  PortOfLoadingArea: 'район порта отправления',
  PortOfDestinationArea: 'Порт назначения',
  ShipsCallSign: 'Звонок судна EDI',
  ImportTheVoyage: 'Импорт рейса',
  IncreaseThePort: 'Увеличение порта',
  DeletePorts: 'Удалить порт',
  AutomaticallyImportVoyage: 'Автоматически импортировать рейс',
  CountryOfRegistration: 'Название судна',
  AddShippingCompany: 'Увеличение числа судоходных компаний',
  DelShippingCompany: 'Удалить судоходную компанию',
  DepartureTime: 'Время отправления',
  DateOfOrder: 'Дата получения',
  ProjectReceivedBy: 'Получатель',
  dateOfFiling: 'Дата архивирования',
  ArchivePeople: 'Архив',
  ReturnOrderExpressNumber: 'Номер возврата.',
  StateOfTheWithdrawal: 'Статус отозван',
  EmptyTheList: 'Очистить список',
  BatchStateTransition: 'Конвертирование пакетного состояния',
  CollectFormation: 'Информация о поступлениях',
  RetreatASingle: 'Список возвратов',
  BatchSaving: 'Сохранение пакетов',
  AppendQueryRecord: 'Дополнительные записи запросов',
  StateHisCase: 'Состояние чемодана',
  BoxStatus: 'Контейнерное состояние (только порт Шанхая)',
  StatusOfAnti_TerrorismManifest: 'Статус EDI антитеррористического манифеста',
  ManifestStatus: 'Статус манифеста EDI',
  AdvanceManifestStatus: 'Статус EDI по предварительной накладной',
  InstallPackingListStatus: 'Состояние одиночного EDI',
  StateOfTheBillOfLading: 'Статус EDI коносамента',
  BookingStatus: 'Статус бронирования EDI',
  reset: 'Сбросить',
  PrintStatus: 'Статус печати',
  TeamContact: 'Контакты с автоколоннами',
  ContactNumber: 'Контактный телефон',
  DoorContact: 'Контакты с точками доступа',
  DoorContactNumber: 'Контактный телефон',
  PleaseScanTheBarcodeOrInputDirectly: 'Сканируйте штрих - код или введите его напрямую.',
  CollectionSituation: 'Поступления',
  DocumentDate: 'Дата документа',
  checkbox: '【Параметры】',
  RefundDate: 'Дата возврата налога',
  RefundPerson: 'Налогоплательщик',
  AutomaticallyRefresh: 'Автоматическое обновление',
  Piece: 'Товар',
  Volume: 'Тело',
  CartonQuantity: 'Размер ячейки',
  ClientsRequirement: 'Требования клиентов',
  LandCarriage: 'Наземный транспорт',
  HLID: 'Интерактивный ID',
  ShippingCmp: 'Морской отдел',
  CarrierSpecificCode: 'Код судового отдела',
  PortOfLoadingAI: 'Порт отправления',
  RiverCarrier: 'Канхэ шиппинг корпорейшн',
  Synchronization: 'Синхронизация',
  BatchShutOut: 'Массовый возврат',
  OverseaCustomerService: 'Зарубежные клиенты',
  CargoFeature: 'Характер груза',
  CustomerLevel: 'Уровень клиента',
  ContractStatus: 'Статус контракта',
  HBLNotifier: 'Уведомляющее лицо',
  ExportWithSOPToExcel: 'Экспорт Excel (включая спецификации SOP)',
  ManagerSubmission: 'Представлено руководителем',
  CustomerSelfRelease: 'Заказчик самостоятельно',
  CompanySelfRelease: 'Корпоративный заказ.',
  QuantitySize: 'Размер',
  EquipmentEstimatedReturnTimeFrom: 'Ожидаемое начало',
  EquipmentEstimatedReturnTimeTo: 'Ожидается возврат',
  copyDGStuffing: 'Копирование',
  pasteDGStuffing: 'Вставить',
  viewDGStuffing: 'Посмотреть',
  copyAndAddPoItems: 'Копировать Добавить',
  SynchroHBLInfo: 'Синхронизация информации HBL',
  Cubage2: 'Объем м³',
  AMSLog: 'Журнал',
  AMSReceiptInfo: 'Посмотреть квитанции',
  ViewAssociatedBusiness: 'Посмотреть Связанные операции',
  isShutOut: 'Вернуть ли',
  RevokeTuckOrder: 'Снятие ордера',
  SearchTuckOrder: 'Запрос',
  ShowTuckOrderLog: 'Журнал',
  TuckStatus: 'Состояние отправки',
  DriverNameHL: 'Связанные водители',
  DriverPhoneHL: 'Интернет - телефония',
  TruckNoHL: 'Номерные знаки',
  TmsNoHL: 'Номер заказа',
  ContainerSerialNo: 'Номер ящика',
  ContainerNoDiff: 'Показывать разницу',
  isRelated: 'Связаны ли',
  viewDGStuffingInvalid: 'Отмена',
  CommissionedChargedWeight: 'Стоимость заказа',
  CustomsHasCheck: 'Таможня проверила',
  CustomsOneRelease: 'Одноразовое освобождение',
  CustomsRelease2: 'Отпусти.',
  PartnerShortType: 'Тип',
  Transit2: 'Транзит',
  AuditDate: 'Дата корректировки',
  IsNeedInvoice: 'Требуется ли выписка',
  needInvoice: 'Нужен счет.',
  InvoiceNo: 'Налоговый номер',
  Email2: 'Почтовый ящик',
  DgconsignParty: 'DGCONSIGN',
  ElseInvoiceParty: 'ELSEINVOICE',
  ShowPODAgency: 'ShowPODAgency',
  FnlTm: 'Внутренний транзитный режим',
  InvokeLocalMailClient: 'Вызов локального почтового ящика',
  preview: 'Создать вложение',
  attachment: 'Приложение:',
  AddPackingInfo: 'Добавить информацию о упаковке',
  RemovePackingInfo: 'Удалить информацию об упаковке',
  sendJdy: 'Отправить краткое облако',
  sendFailInfo: 'Отправить статью успеха {0}, ошибка {1}：',
  batchSendJdy: 'สКраткое облако для массовой отправки',
  batchUnlockGoodsDetails: 'Детали разблокировки груза партиями',
  IdentifyPackingList: 'Идентификация упаковочных листов',
  BoxListRecognition: 'AI - идентификация коробки',
  SupportingUploadFormat: 'Поддерживаются форматы загрузки pdf/xls/xlsx/doc/docx/jpg/gif/png, один файл не более 4 МБ',
  UploadedFile: 'Документы уже загружены',
  Parsing: 'анализируется',
  SpecialCharactersNotAllow: 'Имя файла не допускает специальных символов.',
  MaterialInformation: 'Материальная информация',
  MaterialNumber: 'Материал',
  HsCode2: 'HS CODE',
  NetWeightKg: 'Чистый вес (кг)',
  PONumber: 'PO номер',
  FilePreview: 'Предварительный просмотр документов',
  MultiCabinets: 'Шкафы',
  CopyDoorPoint: 'Запись данных буксира в точке входа.',
  SelectCabinetData: 'Выберите информацию о шкафу',
  ExportPackingInfo: 'Экспорт информации о ячейке',
  ImportPackingInfo: 'Импорт информации о ячейке',
  ContainerId: 'Идентификатор ящика',
  TrailerRemark: 'Отзывы о трейлере',
  RemarkItems: 'Примечания',
  DriverId: 'Удостоверение личности',
  DriverName: 'Пилоты',
  DriverPhone: 'Мобильные телефоны',
  TruckNo: 'Номер машины.',
  EstimatArrivalTime: 'Ожидаемое время',
  DownloadImportResults: 'Загрузить результаты импорта',
  ImportSuccess: 'Импорт успешно',
  ImportFaildAndDownFile: 'Существует набор данных, которые не удалось импортировать, загрузите результаты импорта для просмотра!',
  SendBack: 'Возврат средств',
  MSC: 'MSC',
  CompanyInfo: 'Информация о компании',
  LadingBillInfo: 'Информация о коносаменте',
  HV: 'HV',
  RefNo: 'Номер ссылки',
  DgStuffing: 'DG Stuffing',
  HSCODE: 'HSCODE',
  CustomsCommodity: 'Наименование таможенной декларации',
  TradeShortName: 'Сокращения',
  Code3: 'Код',
  TradeDescription: 'Рисунок',
  ShippingMark: 'Маркировка',
  ZipCode: 'Почтовый индекс',
  EmailAddress: 'Электронная почта',
  VipCode: 'VIP - код',
  InttraCode: 'Код INTTRA',
  MscCode: 'Код MSC',
  CompanyCode: 'Код компании',
  LadingBillTitle: 'коносамент',
  LadingBillAddress: 'Адрес коносамента',
  LadingBillContactInfo: 'Контактная информация коносамента',
  MstBooking: 'MST BOOKING',
  SplitType: 'Тип разделения',
  RelatedOrderNo: 'Соответствующий номер заказа',
  SignedType: 'Тип контракта',
  FreightTerm: 'Условия фрахта',
  PlaceOfPayment: 'Место платежа',
  ProductionInstallationPlace: 'Место производства',
  ProductionInstallationPlaceStation: 'ТПС производственно - монтажная станция',
  ProductionInstallationModeOfTransportation: 'Способ перевозки',
  PortOfLoadingWharf: 'Порт отправления',
  PortOfDischargeWharf: 'Порт разгрузки',
  PortOfDischargeRequire: 'Требования к порту разгрузки',
  Destination: 'Пункт назначения',
  DestinationStation: 'Станция назначения',
  DestinationTransportWay: 'Способ транзита в пункте назначения',
  TransferCountry: 'Страны транзита',
  BlNumber: 'BL NUMBER',
  FreightBL: 'Freight BL',
  PODAgency: 'POD Agency',
  MscServiceCode: 'Сервисный код',
  ToOrderType: 'TO ORDER TYPE',
  DestinationZipCode: 'Почтовый индекс назначения',
  CopyCompany: 'Копия корпоративной информации',
  ChargeImport: 'Импорт расходов',
  customerLevel: 'Уровень клиента',
  isSignContract: 'Подписаны ли',
  RemovePacking: 'Удалить упаковку',
  LastContainerDescription: 'Последний рисунок.',
  SelectLocation: 'Выбор места',
  GetBack: 'Взять обратно',
  CancelGetBack: 'Отзыв',
  Releasing: 'Расписание',
  CancelReleasing: 'Снятие ордера',
  StatusModefySuccessfully: 'Изменение состояния успешно',
  BillingOfLadingRecordManager: 'Журнал коносамента',
  ApplyForARelease: 'Заявка на выдачу',
  RequestReleaseBy: 'Заявка на освобождение',
  TicketHasSplit: 'Этот билет распечатан, пожалуйста, подайте заявку в распечатке',
  TicketHasMerged: 'Этот билет оформлен, пожалуйста, подайте заявку в сводном листе',
  RequestReleaseDate: 'Дата подачи заявки',
  RequestReleaseState: 'Статус заявки',
  MblRequestReleaseState: 'Статус запроса на выпуск MBL',
  HblRequestReleaseState: 'Статус запроса на выпуск HBL',
  NotApplying: 'Заявки не подавались',
  Requested: 'Заявки поданы',
  NoGuarantee: 'Без гарантии',
  InEffect: 'Вступил в силу',
  Expired: 'Неспособность',
  Uploaded: 'Загрузка',
  NotUploaded: 'Не загружено',
  NoUploadRequired: 'Нет необходимости загружать',
  NotUploadedYetPlease: 'Не загружен, пожалуйста',
  LongTermGuaranteeState: 'Состояние долгосрочной гарантии',
  SingleTicketGuaranteeState: 'Гарантийное состояние одного билета',
  WithdrawTheRequestForRelease: 'Отзыв заявки',
  NoRequestReleaseData: 'Нет данных для подачи заявки',
  NoCancelRequestReleaseData: 'Нет данных для отзыва заявки',
  ReleasingDate: 'Дата выпуска',
  mblReleasingDate: 'Дата MBL',
  receiptDate: 'Время',
  receiptContent: 'Содержание',
  receiptCode: 'Код квитанции',
  createdDate: 'Время',
  createdBy: 'Оператор',
  content: 'Содержание',
  consignorCode: 'Корпоративный код отправителя',
  codeAbbreviation: 'Сокращения кода',
  enterpriseCode: 'Код предприятия',
  consignorName: 'Наименование компании - отправителя',
  consignorDetailAddress: 'Подробный адрес отправителя',
  consignorPhone: 'Номер телефона отправителя',
  consignorEmail: 'Адрес отправителя EMAIL',
  consignorRelexNumber: 'Телефонный номер отправителя',
  cityName: 'Название города',
  consignorCityName: 'Название города отправителя',
  provinceCode: 'Код провинции',
  provinceName: 'Название провинции',
  postalCode: 'Почтовый индекс',
  countryCode: 'Код страны',
  aeoEnterpriseCode: 'Код компании AEO',
  formatSynchronizeToOrder: 'Синхронизация форматирования информации в заказ',
  ladingBill: 'Директивный коносамент',
  consigneeCode: 'Корпоративный код грузополучателя',
  consigneeCodeAbbreviation: 'Сокращения кода',
  consigneeEnterpriseCode: 'Код предприятия',
  consigneeName: 'Название грузополучателя',
  consigneeDetailAddress: 'Подробный адрес грузополучателя',
  consigneePhone: 'Номер телефона грузополучателя',
  consigneeEmail: 'Адрес EMAIL грузополучателя',
  consigneeRelexNumber: 'Телефонный номер грузополучателя',
  consigneeCityName: 'Название города',
  consigneeProvinceCode: 'Код провинции',
  consigneeProvinceName: 'Название провинции',
  consigneePostalCode: 'Почтовый индекс',
  consigneeCountryCode: 'Код страны',
  consigneeAeoEnterpriseCode: 'Код компании AEO',
  specificContactName: 'Имя конкретного контактного лица',
  specificContactPhone: 'Номер телефона конкретного контактного лица',
  specificContactAddress: 'Конкретный адрес EMAIL',
  specificContactRelexNumber: 'Конкретный контактный номер',
  notifyingCode: 'Корпоративный код уведомителя',
  notifyingCodeAbbreviation: 'Сокращения кода',
  notifyingEnterpriseCode: 'Код предприятия',
  notifyingName: 'Наименование компании',
  notifyingDetailAddress: 'Уведомляющий адрес',
  notifyingPhone: 'Номер телефона информатора',
  notifyingEmail: 'Адрес уведомления EMAIL',
  notifyingRelexNumber: 'Номер телекса',
  notifyingCityName: 'Название города',
  notifyingProvinceCode: 'Код провинции',
  notifyingProvinceName: 'Название провинции',
  notifyingPostalCode: 'Почтовый индекс',
  notifyingCountryCode: 'Код страны',
  notifyingAeoEnterpriseCode: 'Код компании AEO',
  formatManifestInformation: 'Форматирование информации о манифесте',
  freightChargesInfo: 'Информация о расходах',
  freightChargesUSDTotal: 'Итого, расходы USD:',
  tips: 'Подсказка!',
  checkNominatedAgent: 'Назначенный агент не может быть пустым!',
  checkActualNotifyParty: 'Фактический уведомитель не может быть пустым!',
  checkConsignationCompany: 'Подразделение не может быть пустым!',
  checkLoadingPort: 'Порт погрузки не может быть пустым!',
  checkLoadingPort2: 'Порт отправления не может быть пустым!',
  checkPortOfDischarge: 'Порт разгрузки не может быть пустым!',
  checkPlaceOfDelivery: 'Место доставки не должно быть пустым!',
  checkFinalDestination: 'Конечный пункт назначения не может быть пустым!',
  checkDateOfDepartureAndDateOfArrival: 'Отправление не может быть позже даты прибытия!',
  checkSales: 'Продажи не могут быть пустыми!',
  checkDept: 'Сектор не может быть пустым!',
  searchInfo: 'Нет ввода информации о запросе!',
  checkVslVoy: 'Название судна или рейс не должны быть пустыми.',
  prePlanBooking: 'Предварительная информация',
  VgmInfo: 'Информация VGM',
  ChooseSoNoInfoToCopy: 'Пожалуйста, скопируйте информацию по списку',
  ChooseContainerInfoToCopy: 'Пожалуйста, выберите ящик для копирования.',
  manifestLinkCopy: 'Ссылка на дубликат манифеста',
  manifestInviteSupplement: 'Приглашение к дополнительному манифесту',
  manifestQueryLog: 'авизо на накладную',
  manifestCfmStateLog: 'Статус манифеста',
  manifestByPreShipping: 'Авансовые накладные',
  manifestByClearBooking: 'Уборка грузов',
  manifestCfmButton: 'Подтверждение',
  manifestUnLockButton: 'Временная разблокировка',
  HBLWeight: 'Груз коносамента брутто',
  HBLQuantity: 'Количество коносаментов',
  BillPortOfLoading: 'Порт отправления коносамента',
  BillPortOfDischarge: 'Порт разгрузки коносамента',
  BillPlaceOfDelivery: 'Место сдачи коносамента',
  UserDefinedField1: 'Настройка поля 1',
  UserDefinedField2: 'Настройка поля 2',
  UserDefinedField3: 'Настройка поля 3',
  UserDefinedArea: 'Пользовательская информация',
  PleaseAddConsigneeFirst: 'Пожалуйста, добавьте Consignee.',
  CopyConsigneeToNotify1: 'Копирование Consignee',
  OnlyOne: 'Можно выбрать только один.',
  CopyPoItemInfo: 'Копирование информации о контейнерах',
  CopySuccess: 'Копировать успешно',
  CopyFaild: 'Ошибка копирования',
  PaseteSuccess: 'Вставить успешно',
  NoPasetePoItemInfo: 'Не копируйте информацию о грузе в ящике, сначала скопируйте.',
  IsOrNotSpelling: 'Добавить?',
  Insure: 'Страхование',
  billPaymentNo: 'Номер платежного поручения',
  confirmUser: 'Подтверждение расходов',
  ediFeedBackState: 'Журнал квитанций',
  receiptPrompt: 'Совет: Отправьте данные в течение 20 дней с момента отправки манифеста, и система автоматически получит квитанцию.',
  loadingManifestReceipt: 'авизо на погрузочный манифест',
  customsReceipt: 'манифест Главного таможенного управления',
  receiving: 'Выписка.',
  receiptSucceeded: 'Счет удался.',
  receiptFailed: 'Ошибка квитанции',
  customCode: 'Код зоны',
  transportation: 'Вид транспорта',
  receiptBillType: 'Тип накладной',
  transportationName: 'Название транспортного средства',
  receiptVoyage: 'Рейсы / рейсы',
  importArrivalSignal: 'Логотип прибытия импорта',
  receiptBillNumber: 'Строительные накладные',
  entryDepatureDate: 'Дата въезда',
  itemCount: 'Количество претензий',
  kilogram: 'Килограмм',
  receiptWeight: 'Количество',
  tallyStatus: 'Состояние обработки грузов',
  exportArrivalStatus: 'Прибытие экспорта',
  sendLog: 'Отправить журнал',
  ediStatus: 'Состояние EDI',
  ManifestDeliveryStatus: 'Состояние отправки манифеста',
  chooseShipper: 'Выбор отправителя',
  chooseConsignee: 'Выбор грузополучателя',
  chooseNotify: 'Выбор уведомителя',
  bulkReplication: 'Массовое копирование',
  PlannedDepartureTime: 'Планируемое время отправления',
  ActualDepartureTime: 'Фактическое время отправления',
  PlannedArrivalTimeAtTheFactory: 'Планируемое время прибытия на завод.',
  RealTimeOfArrivalAtTheFactory: 'Фактическое время прибытия на завод',
  PlannedTimeToLeaveTheFactory: 'Время выезда с завода.',
  ActualTimeToLeaveTheFactory: 'Фактическое время выезда с завода',
  PlannedArrivalTime: 'Планируемое время прибытия',
  ActualArrivalTime: 'Фактическое время прибытия',
  currentLocation: 'Текущее местоположение',
  ViewExceptions: 'Посмотреть Необычные',
  truckingPlaceDep: 'Шкафный склад',
  truckingPlaceDest: 'Склад возврата',
  travelTime: 'Время в пути',
  Hour: 'Часы',
  Minute: 'Минуты',
  salesOffice: 'Отдел продаж',
  opOffice: 'Эксплуатационное отделение',
  BookingAgentIsNull: 'Агент бронирования пустой.',
  SOPReceiver: 'Получатель SOP',
  Collectioninformation: 'Информация о поступлениях',
  Appendqueryrecord: 'Дополнительные записи запросов',
  SalesOfGoods: 'Сбыт товаров',
  BatchProcessing: 'Массовая обработка',
  ClickSpaceToDropDownOptions: 'Удалить пробелы',
  PleaseMaintainTheCorrespondingSalesInThePartner: 'Поддерживайте партнеров',
  CheckRecordedCustomsDeclaration: 'Уведомление о таможенной декларации',
  ClearPacking: 'Упаковка',
  CopyMarksFromReceipt: 'Маркировка билетов',
  PODCountry: 'Страны назначения',
  Details: 'Подробности',
  import: 'Импорт',
  DangerousClass: 'Класс опасности',
  DangerousGoodsContact: 'Контакты с опасными грузами',
  DangerousGoodsContactPhoneNumber: 'Контактные телефоны опасных грузов',
  emptyBox: 'Пустой ящик',
  ShipperByCompany: 'Отправитель (информация о компании)',
  ConsigneeByCompany: 'Грузополучатель (информация о компании)',
  PreverifyStatus: 'Статус предварительного производства',
  ChangeCommit: 'Расходы на представление ордеров на изменение',
  ConfirmChangeCommit: 'Вы уверены, что хотите представить расходы на перевод?',
  UserDefinedField4: 'Пользовательское поле 4',
  BoardSales: 'Продажа систем',
  BoardCsr: 'Сервис системы',
  BoardSite: 'Сайт системы',
  ArrivalMethod: 'Способ доставки',
  FlightLabel: 'Авиационные этикетки',
  bargePOL: 'Порт отправления баржи (POL)',
  SalesRequire: 'Требования к продажам',
  OnlyDisplayTicket: 'Показывать только маленькие билеты',
  batchImportCharge: 'Расходы на массовый импорт',
  importCharge: 'Импортные расходы',
  historyLogQuery: 'Запрос журнала',
  noRule: 'Правило нумерации',
  MBLNO: 'MBL NO',
  importSetting: 'Параметры импорта',
  receivable: 'Дебиторская задолженность',
  payable: 'К оплате',
  importFile: 'Импорт файлов',
  confirmImport: 'Подтверждение импорта',
  checkLines: 'Количество строк не должно превышать 1000.',
  checkLines200: 'Количество строк не должно превышать 200.',
  checkChargeInfo: 'Пожалуйста, введите информацию о расходах и сделайте операцию импорта!',
  internal: 'Внутренние',
  overseas: 'За границей',
  batchOperate: 'Массовые операции',
  batchImport: 'Масс.имп.',
  activity: 'Процесс',
  JobInfo: 'Оперативная информация',
  Service: 'Услуги',
  Supplier: 'Поставщики',
  InnerInfo: 'Внутренняя информация',
  Defined: 'Настройка',
  MoreInfo: 'Больше информации',
  unDisplayInfo: 'Скрыть информацию',
  GeneralInfo: 'Информация о билетах',
  BatchModifiedState: 'Режим пакетного изменения',
  SplitTicketsInfo: 'Информация о распределении голосов',
  destinationStation: 'Станция назначения',
  departureStation: 'исходящая станция',
  transitStation: 'Пункт пересечения границы',
  destinationStationRailport: 'Станция назначения (железная дорога)',
  departureStationRailport: 'Станция отправления (железная дорога)',
  transitStationRailPort: 'Транзитные станции (железные дороги)',
  CommonInfo: 'Обычная информация',
  settlementAgent: 'Расчетный агент',
  Dimension: 'Размер CM (длина * ширина * высота)',
  PaymentType: 'Авансы / платежи',
  ToPay: 'К оплате',
  PrePay: 'Авансы',
  PickUpGoods: 'Принимать ли товар',
  DocumentationNumberOfPackages: 'Количество единиц',
  DocumentationGrossWeight: 'Валовой вес',
  DocumentationVolume: 'Удельный объем',
  DocumentationChargedWeight: 'вес счета - фактуры',
  CustomerQuantity: 'Количество клиентов',
  CustomerGrossWeight: 'Вес клиента брутто',
  CustomerVolume: 'Объем клиента',
  CustomerChargedWeight: 'Вес клиента',
  VerifyReviewThrough: 'Утверждено',
  VerifyReviewRefusal: 'Пересмотр отказа',
  ImportTime: 'Время импорта',
  descr: 'Примечания',
  logFile: 'Файл журнала',
  ChargeBranchId: 'Филиал',
  DateCreated: 'Дата ввода',
  ProfitOwner: 'Сторона прибыли',
  ScfiDeclare: 'Заявление SCFI',
  ScfiPrice: 'Тарифы SCFI',
  Copy: 'Копирование',
  ImportOrder: 'Импорт данных заказа',
  ImportBusinessNo: 'Импорт бизнес - номера',
  SelectOrderNumber: 'Выберите номер заказа',
  ArrivalTime2: 'Дата прибытия',
  ProjectName: 'Название проекта',
  ProjectBatch: 'Партии проектов',
  CargosExpectedArrivalDateByTrucking: 'Предполагаемая дата прибытия (точка входа клиента)',
  CargosExpectedArrivalDateWarehouseLoading: 'Предполагаемая дата прибытия (погрузка на склад)',
  CargosExpectedArrivalDatePacking: 'Предполагаемая дата упаковки',
  EstimatedPackTheCabinetTime: 'Ожидаемое время установки',
  MaintainJobNoRule: 'Поддерживайте правила кодирования рабочих номеров!',
  SelectCodeRule: 'Выберите правила кодирования',
  CodeRuleDesc: 'Правила кодирования',
  SpecifyAgentNumber: 'Количество назначенных агентов',
  CustomsClearanceChargeRelatedEdit: 'Возмещение расходов может быть произведено только с изменениями, связанными с расходами',
  CustomsClearanceNoChargeNoChange: 'Бесплатный возврат не подлежит никаким изменениям (все сборы будут исключены)',
  ClearFeeNoChargeCustomsClearance: 'Неотъемлемый возврат не может быть произведен, если подтвержденные расходы не будут устранены.',
  VotesPreSubmission: 'Билеты сданы заранее?',
  AllNotPositiveOperationStatus: 'Выбранные записи данных полностью не являются [bracket0] состояниями',
  AllNotToVerifyStatus: 'Выбранные записи данных полностью не являются [bracket0] состояниями',
  ContainerLoadTypeNotCorrect: 'Этот вид билета не является самостоятельным, buyer consol、 Делегированный ящик',
  RecordNotPositiveOperationStatus: 'Билетный бизнес не является "активным" состоянием',
  RailwayCheckLob: 'Выбранные Job имеют разные типы бизнеса, выберите тот же тип бизнеса для повторного тестирования.',
  TheTicketIsMain: 'Этот билет является основным',
  TheTicketAssociatedMain: 'Билет уже связан с основным билетом.',
  TheTicketAssociatedContainerInfo: 'Билет связан с информацией об упаковке.',
  ContainerLoadTypeIs: 'Весь тип уже',
  NoneModified: 'Без изменений',
  ContainerLoadTypeBatchModifySuccess: 'Успешно изменен весь тип сборки:',
  NoDataProcessed: 'Нет обработанных данных',
  CustomsInformation: 'Таможенные данные',
  AddFile: 'Добавить файл',
  CustomsReceiptFile: 'Таможенная квитанция',
  CustomsReceiptState: 'Статус таможенной квитанции',
  CloneCabinBerth: 'Количество мест для размножения документов',
  BackFillCabinBerth: 'Заполнение мест',
  GenerateBusiness: 'Генерирование операций',
  ReturnCabin: 'Выход.',
  CheckBeforeEntrust: 'Вы поручаете {0} не поддерживать {1} код SCAC и другую соответствующую информацию, пожалуйста, проверьте друг друга, прежде чем делегировать!',
  CheckPortBeforeEntrust: 'Вы поручили [bracket1] не обслуживать [bracket0] порт, пожалуйста, проверьте друг друга, прежде чем делегировать!',
  CheckPackBeforeEntrust: 'Ваш заказ [bracket1] не обслуживает упаковку [bracket0], пожалуйста, проверьте друг друга, прежде чем делегировать!',
  PortDataPushLog: 'Журнал передачи данных в порту',
  EdiStatusChangeLog: 'Журнал изменений состояния EDI',
  BookingReceiptLog: 'журнал операций квитанций о бронировании',
  MergeAndSingle: 'А',
  OuJianDeclaration: 'таможенная декларация Оукена',
  AirportPort: 'Аэропорты',
  Airport: 'Аэропорт',
  GoodsStoragePlace: 'Место хранения товаров',
  ExchangeServiceAi: 'Нужны ли услуги таможенной службы',
  DataPushChangeLog: 'Запись изменений push - to - data',
  SendBookingData: 'Отправка данных о бронировании',
  SelectAction: 'Выбор операции',
  IsGroupBranch: 'Является ли филиал группы',
  SmtpServerError: 'Ошибка сервера SMTP',
  NotConnectSmtpServer: 'Невозможно подключить сервер SMTP',
  NotFindFile: 'Система не может найти указанный файл',
  SendFileError: 'Ошибка отправки файла',
  AttachTemplateError: 'Ошибка шаблона вложения',
  MailSentSuccess: 'Почта успешно отправлена',
  PleaseSelectAction: 'Выберите операцию',
  PleaseSelectCategory: 'Пожалуйста, выберите категорию товаров.',
  PleaseSelectOpDep: 'Выберите операционный отдел',
  SeaExportLetter: 'Морская экспортная грузовая доверенность',
  DataPush: 'Передача данных',
  MasterTicketSync: 'Синхронизация главного билета',
  BookingDataSentSuccess: 'Данные о бронировании отправлены успешно!',
  CostSettlementObjectBlocked: 'Объект расчетов за расходы [{0}] был заблокирован и может быть связан с риском сохранения?',
  ConsigneeRequired: 'Введите информацию о приемопередатчике интерфейса HB / L!',
  OverseaCustomerUpdate: 'Первоначальное зарубежное обслуживание клиентов [{0}] истекло, обновлено для нового зарубежного обслуживания клиентов [{1]',
  ConatainerNoRemoveRelation: 'Данные с номером ячейки {0} будут удалены, нужно ли продолжать?',
  EDIBooking: 'ЗБ EDI',
  EDIContainers: 'Упаковка информации EDI',
  ContainersLog: 'Журнал квитанций об упаковке',
  PleaseSelect2: 'Выберите бизнес для отправки!',
  MingShen: 'Средства к существованию',
  MingShenCompany: 'Международная судоходная компания с ограниченной ответственностью',
  EDIDoc: 'EDI Doc',
  RoundPaymentAmountExchangeRate: 'ROUND (Валютный курс платежей *)',
  VGMIsEmpty: 'VGM Пустой!',
  VGMRaw: 'Первоначальный VGM',
  VGMCorrection: 'Исправление VGM',
  FileOnlyXlsXlsx: 'Загрузить файлы можно только в формате xls и xlsx!',
  FileOnlyXlsx: 'Загрузить файл можно только в формате xlsx!',
  stayTuned: 'С нетерпением жду',
  UploadImageFormatWrong: 'Загруженные изображения имеют неправильный формат, и на данном этапе мы поддерживаем следующие форматы изображений: PNG、JPG、JPEG， Пожалуйста, замените или расшифровайте изображение.',
  ItIsEmpty: 'Пустота',
  AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge: 'Авансы на оплату денежных переводов (RMB) - Фактическая сумма денежных переводов (RMB) - Платежи за обработку (RMB) - Платежи за почту и телекоммуникации (RMB) - Платежи за акцепт (RMB)',
  RelatedBusinessNoSpecial: 'Отсутствует информация о специальных товарах',
  ReceiptImportFailed: 'Ошибка импорта квитанции!',
  ReceiptImportedSuccessfully: 'Импорт квитанции удался!',
  ReceiptImport: 'Импорт квитанций',
  CopyLinkPublic: 'Копирование ссылок (общедоступных)',
  CopyLinkPromissoryNote: 'Копирование ссылок (простые векселя)',
  RepeatBoxType: 'Есть два одинаковых типа контейнеров.',
  RepeatUldType: 'Уже есть запись того же кода сборщика!',
  RealDepartureTime: 'Фактическое время выхода',
  RealDeparture: 'Фактический выход',
  ActualBerthingTime: 'Фактическое время стоянки',
  ImportFailedContactAdministrator: 'Ошибка импорта, свяжитесь с администратором.',
  ContractPeriod: 'Партнеры: ${0} Наличие контракта в течение срока действия, пожалуйста, скорректировать соответствующий кредитный счет в 【Управление контрактами】.',
  HasBeenSelected: 'Уже выбрано',
  HasExceeded: 'Превышение!',
  HasExceededCannotEDI: 'Уже выше, не может EDI!',
  UnloadingPortNotMaintain: 'В настоящее время"Подразделение - заказчик"А"Порт разгрузки"Не поддерживается соответствующий агент, очищается ли выбранный назначенный агент и информация о продажах?',
  EnYuanHuaXiaKu: 'Энхара, Хуа Сяку',
  EnyuanYangyuanKu: 'Ён Юань',
  EnyuanGaoxiangku: 'Ёсихара, Такасу',
  NotInsuranceOperationPermission: 'У вас нет прав на [страхование] операции!',
  CorrectionBillOfLading: 'Исправление коносамента',
  ConfirmationBillOfLading: 'Подтверждение коносамента',
  Tips: 'Подсказка!',
  PickUpTypeDifferentSmallTicket: 'Тип доставки отличается от небольшого билета, убедитесь, что его нужно сохранить?',
  OperationDepartmentCannotBeEmpty: 'Оператор не может быть пустым.',
  FileContentIsEmpty: 'Файл пуст',
  FileContentWrong: 'Неправильное содержание документа',
  FileSizeCannotLargerThan2MB: 'Размер файла не должен превышать 2 Мб.',
  NoData: 'Данные отсутствуют',
  NoBusinessSelected: 'Не выбран бизнес.',
  OriginalNormal: 'Оригинал',
  NoImportEDI: 'В этом списке нет EDI.',
  PackingDataNotCconsistent: 'Данные упаковки этого рабочего листа не соответствуют фактическим данным, пожалуйста, проверьте информацию упаковки!',
  CreditControlTheClient: 'Письмо доверенного лица',
  SaveBusinessBeforeEnterMultiGate: 'Примечание: Введите несколько точек, сначала сохраните бизнес',
  SaveBusinessBeforeEnterMultiGate2: 'Примечание: Введите несколько точек входа или несколько шкафов, сначала сохраните бизнес',
  BookingWorkspace_PrePlan_ImportExcel: 'Морской бронирование Excel - Предварительная информация - Импорт Excel',
  SpecialCargoNumber: 'Специальный номер груза',
  RelevantTicketsResetAndUpdated: 'После подтверждения соответствующие небольшие билеты будут сброшены и обновлены, синхронизированы ли они?',
  ManifestConfirmed: 'Манифест подтвержден!',
  ManifestDataIsEmpty: 'Данные манифеста пусты!',
  ManifestConfirmationFailed: 'Упаковка подтверждена!',
  NodeTriggerFailed: 'Ошибка запуска узла!',
  LoadingOfPackingInformationFailed: 'Ошибка загрузки информации об упаковке.',
  PlanDepartureTime: 'Планируемое время выхода',
  PlannedBerthingTime: 'Планируемое время стоянки',
  OriginalPlanDepartureTime: 'Первоначально запланированное время отправления',
  OriginalPlannedBerthingTime: 'Первоначально запланированное время швартовки',
  NowPlanDepartureTime: 'Текущее запланированное время отправления',
  NowPlannedBerthingTime: 'Текущее запланированное время швартовки',
  CurrentETA: 'Текущее запланированное время прибытия',
  OriginalETA: 'Оригинальное запланированное время прибытия',
  CurrentETA1: 'Текущее запланированное время прибытия (Current ETA)',
  OriginalETA1: 'Оригинальное запланированное время прибытия (Original ETA)',
  ShippingScheduleNew: 'Шаблоны импорта по срокам (новая версия)',
  ShippingScheduleold: 'Шаблон импорта сроков судоходства (прежняя версия)',
  ImportNew: 'Импорт (новая версия)',
  ImportOld: 'Импорт (предыдущая версия)',
  PlannedBerthing: 'Планируемая стоянка',
  PlanDeparture: 'Планируемая стоянка',
  BookingEDI: 'Забронировать EDI',
  BookingCorrection: 'Исправление бронирования',
  PortMaintainedDesignatedFreightForwarder: 'Используется ли в порту соответствующий назначенный грузовой агент, обслуживающий порт?',
  MBLStatusNotIsUnStart: 'Билет MBL для одного состояния не начинается и не может быть импортирован.',
  PrimaryOrderNotSameReceipt: 'Основной номер билета не соответствует главному номеру квитанции, продолжается ли импорт?',
  RequestSuccessful: 'Запрос удался!',
  SpecialCharacters: 'Существуют специальные символы, которые не могут запускать подписку на данные порта или судоходной компании',
  EnterReleaseNumber: 'Введите номер',
  SelectAPieceOfData: 'Пожалуйста, выберите данные!',
  SelectARecord: 'Пожалуйста, выберите запись!',
  ChooseDesignatedAgent: 'Пожалуйста, выберите назначенного агента!',
  ChooseSpecialGoods: 'Пожалуйста, выберите специальный товар!',
  CargoInformationIsEmpty: 'Информация о грузе пуста.',

  InviteSupplementaryLinksPublic: 'Дополнительные ссылки на приглашения (общедоступные)',
  InviteSupplementaryLinkPromissoryNote: 'Дополнительные ссылки на приглашения (простые векселя)',
  DownloadCWTemplate: 'Скачать шаблон CargoWare',
  DownloadCWTemplateJC: 'Скачать шаблон CargoWare',
  DownloadSeaHouseTemplate: 'Загрузить шаблон экономки',
  DownloadWseTemplate: 'Скачать шаблон CargoWare (Циндао)',
  DownloadWseTemplateSh: 'Скачать шаблон CargoWare (Шанхай)',
  DownloadWseTemplateVgm: 'Скачать шаблоны',
  SendingChannelVgm: 'Каналы передачи',
  MailSendingFailed: 'Ошибка отправки почты!',
  DistributionFailed: 'Неудача с доставкой',
  SalesAndOperationAreSame: 'Продажи и операции одинаковы, подтвердить, что сохранить?',
  PreConfiguredManifestAPI: 'Авансовые накладные API',
  PreConfiguredManifestDeletion: 'Удаление авансовых накладных',
  PreConfiguredManifestIsEmpty: 'Предзаказ - лист Удалить объект пустым, пожалуйста, обновите страницу и попробуйте снова',
  CorrectionOfPreAllocatedManifest: 'Исправления к расходным ордерам',
  OperationFailed: 'Операция не удалась!',
  RedOffsetCannotModified: 'Расходы на красный удар или расходы на красный удар не могут быть изменены снова, выберите увеличение корректировки.',
  RedOffsetCannotDeleted: 'Плата за красный или красный удар не может быть удалена, пожалуйста, выберите заново',
  MaintainNodeDetailCode: 'Поддерживайте код деталей узла.',
  DeleteNumRecord: 'Удалить запись {0}?',
  DeleteNumFile: 'Вы уверены, что хотите удалить этот {0} файл?',
  ClickYesRetrievedToReturnedStatus: 'Нажмите «Да», чтобы перейти на страницу печати, и измените статус документов с «Возвращено» на «Возвращено в архив».',
  ClickYesToReturnedStatus: 'Нажмите « да», чтобы перейти на страницу печати и изменить статус документа как « возвращенный».',
  FileNotAllowedView: '{0} Файл не разрешается никому просматривать или загружать.',
  NoPermissionToView: 'У вас нет прав на просмотр или загрузку файлов [0]',
  UploadFailed: 'Ошибка загрузки!',
  UploadSuccess: 'Загрузка удалась!',
  UploadSuccessNoOrder: 'Загрузка удалась, соответствующий заказ не найден!',
  UploadedFileNotMatch: 'Тип загруженного файла не совпадает, проверьте!',
  UploadType: 'Тип загрузки',
  FileSource: 'Источник документа',
  ReceiptType: 'Тип квитанции',
  SendAisle: 'Канал EDI',
  BusinessNotSubmitted: 'Операции не представлены, не могут быть возвращены',
  BusinessNotBeenApproved: 'Бизнес еще не проверен, подтвердил, что его нужно вернуть?',
  NoPermissionToViewOrprinted: 'У вас нет прав на просмотр файлов, загруженных или распечатанных другими людьми.',
  DocumentDelivery: 'Выдача документов',
  SameStatusCanBePrinted: 'Можно распечатать только один и тот же документ!',
  ReceiptContent: 'Содержание квитанции',
  ReceiptTime: 'Время квитанции',
  PrintCommonControls: 'Печать общедоступных элементов управления',
  CustomsBrokerOthers: 'Таможенная декларация / Прочее',
  ReceiveReceiptTime: 'Время получения квитанции',
  ReceivingAddress: 'Адрес получения',
  bookingParty: 'Бронированная единица',
  BusinessIsLocked: 'Бизнес заблокирован и не может вернуть счет',
  ConfirmUploadFileType: 'Пожалуйста, подтвердите тип загруженного файла, продолжайте ли вы загружать?',
  InputCustomerName: 'Введите имя клиента!',
  InputExpressNumber: 'Пожалуйста, введите номер курьера!',
  InputExpressAddress: 'Пожалуйста, введите адрес доставки!',
  InputRecipient: 'Введите получателя!',
  InputRecipientName: 'Введите имя получателя!',
  InputReceivingcompany: 'Пожалуйста, введите получателя!',
  InputReceivingAddress: 'Введите адрес получения!',
  InputContactNumber: 'Введите контактный телефон!',
  InputContactNumberMark: 'Введите контактный телефон!',
  InputReturnExpressNumber: 'Введите номер возврата!',
  ReturnInformation: 'Вернуться к информации',
  ReturnDateGreaterThanRetrieveDate: 'Дата возврата должна быть больше, чем дата возврата!',
  DateModified: 'Время обновления',
  OperationCannotBeEmpty: 'Операция не может быть пустой.',
  OperationCompanyCannotBeEmpty: 'Оператор не может быть пустым.',
  BookingAudit: 'Проверка бронирования',
  UseThisNo: 'Использовать этот номер',
  WarehousingFee: 'Расходы на хранение',
  BookingSuccess: 'Заказ успешно',
  ToBeConfirmed: 'Заказ будет подтвержден.',
  BookingFail: 'Заказ не удался.',
  CabinState: 'Класс проезда',
  CostGenerationMethod: 'Формы исчисления расходов',
  SettlementInPriginalCurrency: 'Расчет в первоначальной валюте',
  SettlementInBillCurrency: 'Расчет в валюте счета',
  ShowDetails: 'Показать подробности',
  ImportResultLog: 'Импорт журнала результатов',
  ImportComplete: 'Импорт завершен',
  SuccessItemFailedItem: 'Статья успеха [bracket1], статья неудачи [bracket0].',
  ContinueImporting: 'Продолжить импорт',
  DownloadResultLog: 'Загрузить журнал результатов',
  PONo: 'По',
  VoyageOnlyNum: 'Рейсы могут вводить только цифры или буквы.',
  UpdateSuccess: 'Изменение успешно.',
  ShippingSpace: 'Класс проезда',
  RejectTips: 'Подтвердить отказ {0} пройти аудит? Пожалуйста, укажите причины отказа:',
  GenerateBusinessTips: 'Подтверждаются ли генерирующие операции? (После создания не подлежит отзыву)',
  ReturnedShipping: 'Подтверждена ли эвакуация? (Регистрация не подлежит отзыву после выхода)',
  ReturnedShippingSuccess: 'Вылет успешно.',
  ShippingCompanyAndBookingAgent: 'Введите соответствующую судоходную компанию и агента бронирования.',
  CabinCopySuccess: 'Успешное воспроизведение класса проезда, новый операционный номер:',
  CheckShippingCompanyAndBookingAgent: 'Судоходные компании и агенты по бронированию не могут заполнять только одно.',
  ReviewRejectedSuccess: 'Отказ в пересмотре',
  ReviewSuccess: 'Успешное рассмотрение',
  BatchReviewSuccess: 'Успешный обзор',
  CheckBatchReview: 'Количество проверок не должно превышать 50!',
  RefuseSuccess: 'Отказ удался',
  BatchAuditSuccess: 'Массовый аудит успешно',
  AuditSuccess: 'Проверка прошла успешно',
  CheckCreditTipOne: 'Подразделения, выполняющие следующие операции, находятся под сверхдоверительным контролем и не могут быть проверены',
  CheckCreditTipTwo: 'Подразделения, которым поручено следующее предприятие, были сверхдоверенными и подтверждены для проверки и утверждения?',
  BatchAuditBusinessTip: 'Количество проверок не должно превышать 50!',
  CheckCreditSaveTip: 'Из - за превышения контроля над письмом, простой вексель заблокирован, не может быть напечатан или EDI, пожалуйста, свяжитесь с вышестоящим начальником, чтобы разблокировать, когда это необходимо!',
  CabinCopy: 'Количество мест для размножения документов',
  EnterShippingCompany: 'Пожалуйста, введите судоходную компанию в [bracket0]',
  EnterBookingAgent: 'Пожалуйста, введите агента бронирования в [bracket0]',
  EnterEtd: 'Введите дату отправления в [bracket0]',
  CheckEnterShippingCompanyBookingAgentEtd: 'Пожалуйста, введите соответствующую каюту судоходной компании, агента по бронированию, дату отправления.',
  UnreviewedBusinessNumber: 'Необработанный номер операции: {0}',
  UnreviewedBusinessNumber2: 'Необработанный номер поручения',
  DateOfCreation2: 'Время создания',
  plateNumberAndMblCannotBeEmpty: 'Номер машины и коносамента не должны быть пустыми.',
  ActualDateOfDeparture: 'Фактическая дата отправления',
  ActualDateOfDeparture2: 'Фактическая дата отправления (ATD)',
  nameOfVesselCannotBeEmpty: 'Название судна не может быть пустым.',
  voyageNumberCannotBeEmpty: 'Рейс не может быть пустым.',
  shippingCompanyCannotBeEmpty: 'Судоходная компания не может быть пустой.',
  MasterShippingCompanyCannotBeEmpty: 'Главная судоходная компания обязательна',
  hasBeanSend: 'Отправлено',
  notSend: 'Не отправлено',
  UpdateTime: 'Время обновления',
  CategoryOfGoods: 'Категория товаров',
  ShipperLine1: 'Отправитель, первая строка',
  ConsigneeLine1: 'Грузополучатель, первая строка',
  NotifyPartyLine1: 'Первая строка',
  CargoDocShipperLine1: 'Отправитель коносамента, первая строка',
  CargoDocConsigneeLine1: 'Грузополучатель коносамента, первая строка',
  CargoDocShipper: 'Отправитель коносамента',
  CargoDocConsignee: 'Получатель коносамента',
  CargoDocNotify: 'Уведомление о коносаменте',
  CargoDocNotifyPartyLine1: 'Уведомление о коносаменте',
  MBLBillOfLadingNum: 'главный однопоточный номер',
  HBLBillOfLadingNum: 'Единовременная вода',
  RegularBusiness: 'Трансформация',
  InputDate2: 'Дата ввода',
  ExpectedArrivalDate: 'Предполагаемая дата прибытия',
  PleaseChooseEtdStartDate: 'Выберите дату начала ETD.',
  PleaseChooseEtdEndDate: 'Выберите дату окончания ETD.',
  VOYAGE_NUMBER_ALERT: 'Заполните номер рейса.',
  voyageNumberRepeat: 'Рейсы не повторяются.',
  DirectOrderOrNot: 'Является ли прямой',
  EDICode: 'Код EDI',
  MSCVesselImport: 'Импорт MSC',
  MSCEDIExport: 'MSC Vessel CODE',
  pleaseDelEmptyCarrierRecord: 'Записи судоходной компании не могут быть пустыми.',
  CannotBeTheSame: 'Фидерная линия не может совпадать с главной линией',
  PortNotNull: 'Обнаружены записи с пустыми портами; все порты в каждом рейсе обязательны',
  PortDuplication: 'Порты не должны повторяться',
  EtdAndEtaNotNull: 'Original ETA и Original ETD не могут быть одновременно пустыми',
  shipNameCannotBeEmpty: 'Название судна на китайском или английском языке не должно быть пустым.',
  EnglishShipNameCannotBeEmpty: 'Английское название корабля не может быть пустым',
  alreadyExistsShipNameAndContinueToSave: 'Сохраняется ли китайское или английское название судна с таким же названием?',
  ExportAllToExcel: 'Экспорт Excel',
  FlightAndTime: 'Рейсы /',
  exportThisPageEdi: 'Экспорт этой страницы EDI',
  ExportAgentList: 'Экспорт списка агентов',
  ContinueToExport: 'Продолжить экспорт',
  OnlyMainTicketAndFCLServicesCanBeExported: 'Только основной билет и весь бизнес могут экспортировать выбранный вами бизнес.',
  IgnoresNonExportableServices: 'Только основной билет и весь бизнес могут быть экспортированы, и система будет автоматически игнорировать, будет ли экспортироваться не экспортируемый бизнес?',
  ExportSuccess: 'Экспорт успешно',
  voyageShippingCompanyCanNotNull: 'Судоходная компания не может быть пустой.',
  PleaseSelectShippingName: 'Выберите название судна.',
  DownloadTemplate: 'Загрузить шаблон',
  BLForm: 'Форма коносамента',
  FreeDetention: 'Бесплатная аренда',
  FreeDemurrage: 'Количество дней без реактора',
  CustomsAreaApplication: 'Заявка таможенного района',
  SettlementCompanyNotEmpty: 'Расчетный отдел не может быть пустым!',
  StartMbl: 'Префикс главного номера',
  EndMbl: 'Конец основного номера',
  BillOfLading: 'Номер коносамента',
  CartonQuantityCannotBeZero: 'Ящик не может быть пустым!',
  DistributionNo: 'Номер распределительного листа',
  DistributionWarehouse: 'распределительный склад',
  PreDateOfCustomsDeclaration: 'Прогнозируемая дата закрытия',
  sendFailed: 'Ошибка отправки',
  SelfDeclaration: 'Самотаможенная декларация',
  FilingType: 'Тип заявления',
  emailAccount: 'Отчетность',
  secondGeneration: 'Прим. 2G: указ. канад. тамож. №',
  CanadianCustomsRecordNumber: 'Канадская таможенная регистрация.',
  ExchangeService: 'Требуется ли услуга таможенного обмена',
  SpecialRelationshipOfBuyer: 'Особые отношения между продавцами',
  IncludeRoyalty: 'Включены ли роялти',
  AffectPrice: 'Влияет ли это на цены',
  WoodPacking: 'Является ли деревянная упаковка',
  Combination: 'Комбинация',
  Split: 'Разделить',
  FinalStepSync: 'Синхронизация последнего этапа',
  FinalStepSyncBtn: 'Синхронизация последнего этапа',
  Synced: 'Синхронизировано',
  NotSynced: 'Не синхронизировано',
  PleaseSelectSyncOrder: 'Пожалуйста, выберите заказы для синхронизации',
  PleaseFillLastMilePlanner: 'Пожалуйста, заполните Руководителя бизнес-операций последней мили',
  PleaseSelectNotSyncedOrder: 'Пожалуйста, выберите несинхронизированные заказы',
  CombinationJob: 'Портфельные операции',
  ReceivableChargeLockedStatus: 'Статус дебиторской задолженности',
  PayableChargeLockedStatus: 'Положение с фиксацией кредиторской задолженности',
  NotLocked: 'Не заблокирован',
  ChargeLocked: 'Дебиторская или кредиторская задолженность заблокирована и не может быть выполнена!',
  ArChargeLocked: 'Дебиторская задолженность заблокирована, эта операция не может быть выполнена!',
  ApChargeLocked: 'Кредиторская задолженность заблокирована, эта операция не может быть выполнена!',
  LockedStatus: 'Состояние блокировки',
  LockedDate: 'Время блокировки',
  LockAr: 'Заблокировать дебиторскую задолженность',
  UnLockAr: 'Отмена заблокированной дебиторской задолженности',
  LockAp: 'Блокировать обработку',
  UnLockAp: 'Отменить блокировку',
  importExpenseStatus: 'Состояние расходов после импорта',
  accountingDate: 'Финансовые даты после импорта',
  BatchReturnSubmit: 'Снятие партии',
  BatchReturnPreSubmission: 'Возврат партии к предпредставлению',
  BatchUnlockReceivableExpenses: 'Сборы за массовую разблокировку дебиторской задолженности',
  BatchUnlockPayableFees: 'Расходы на массовую разблокировку',
  UnlockApplyBtn: 'Подать заявку на разблокировку',
  UnlockApplyTitle: 'Заявка на разблокировку расходов',
  UnlockApplyJobCount: 'Количество заявок в этой заявке: {0}',
  UnlockApplyCountLimitTip: 'не более 200 за одну заявку',
  UnlockApplyReason: 'Причина разблокировки',
  UnlockApplyReasonPlaceholder: 'Пожалуйста, введите причину разблокировки',
  UnlockApplyReasonRequired: 'Пожалуйста, введите причину разблокировки',
  UnlockApplyReasonOverLength: 'Причина разблокировки не может превышать 500 символов',
  DeclaredProfitImpact: 'Заявленная сумма влияния на маржу',
  UnlockApplyAmountRequired: 'Пожалуйста, введите заявленную сумму влияния на маржу',
  UnlockApplySubmit: 'Подать заявку',
  UnlockApplyPrecheckFailed: 'Проверка не пройдена. Следующие заявки не могут быть поданы, скорректируйте и повторите попытку:',
  UnlockApplyFailureReason: 'Причина отказа',
  UnlockApplyOnlySeaExport: 'Только заявки на морской экспорт могут быть поданы',
  UnlockApplyOverLimit: 'За одну операцию нельзя превысить 200 заявок',
  UnlockApplyChargeNotLocked: 'Ни дебиторские, ни кредиторские расходы не заблокированы, заявка на разблокировку не требуется',
  UnlockApplyJobNotLocked: 'Текущий заказ не заблокирован, заявка на разблокировку невозможна!',
  UnlockApplyJobStateInvalid: 'Среди выбранных заказов есть заказы в статусе, отличном от «Утверждён». Проверьте!',
  UnlockApplySubmitted: 'Заявка подана, номер партии: {0}',
  UnlockApplyApproving: 'На рассмотрении',
  UnlockApplyUnlocking: 'Разблокировка',
  UnlockApplyUnlockedBanner: 'Расходы данного заказа разблокированы для редактирования и будут автоматически заблокированы через 3 дня в 01:00',
  BatchLockingReceivableExpenses: 'Блокирование дебиторской задолженности оптом',
  BatchLockingPayableFees: 'Суммы, причитающиеся в связи с массовым блокированием',
  ReplaceSOPTemplatesInBatches: 'Массовая замена шаблонов SOP',
  BatchUpdateScNo: 'Серийное изменение номера контракта',
  BatchUpdateScNoSuccess: 'Серийное изменение номера контракта успешно: {0}',
  BatchUpdateScNoCheck: 'Изменить только действующий список.',
  BatchReturnSubmitCheck: 'Разрешается только аннулировать статус бизнеса в представленном списке.',
  MasterChargeIsShare: 'Распределение расходов по основным векселям',
  PackageDisplayName: 'Упаковка Показать имя',
  ChargeSource: 'Источник данных',
  AddressOfContact: 'Контактный адрес',
  FinancialExamineDate: 'Дата финансовой проверки',
  ReceiptStatus: 'Статус квитанции',
  TransitInformation: 'Информация о транзите',
  ThreeWay: 'Три.',
  placeOrder: 'Выписать заказ',
  BatchUpdateCustomJobType: 'Изменить пользовательский тип бизнеса',
  CustomJobTypeBatchModifySuccess: 'Успешное изменение пользовательского типа бизнеса:',
  BatchManagerSubmission: 'Представлено руководителем партии',
  BatchManagerSubmissionTips: 'Руководитель может отправлять только текущие и предварительно представленные операции в пакете!',
  BatchManagerSubmissionSuccessfully: 'Руководитель пакетов успешно представил:',
  VotesManagerSubmission: 'Билеты подает руководитель?',
  CopyEnglishDescriptionOfGoodsFromMergeJob: 'английское название',
  CopyMarkFromMergeJob: 'Отметить включение',
  SyncToSmallTicket: 'Синхронизация с малыми билетами',
  externalBusinessStatus: 'Статус заказа', // 爱拼订单状态
  SoNo1: 'S/O No.',
  NaturalPerson: 'Физические лица',
  LegalPerson: 'Юридическое лицо',
  IndividualAssociation: 'Индивидуальные ассоциации',
  TelSeparate: 'Зоны, пожалуйста.' - 'Разделить',
  EnsNo: 'Номер ENS',
  ShippingCompanyEORI: 'Судоходная компания EORI',
  DeclarantEORI: 'Заявление EORI',
  Memberstate: 'Первая страна в ЕС',
  ENSNumber: 'Номер ENS',
  EnsHsCodeNotMatch: 'Номер груза не совпадает с номером ящика.',
  EnsCorrelativeNoRepeat: 'Номера серийных номеров повторяются.',
  LinkedCargoInformationNoNotNull: 'Информация о упаковке Номер серийного номера связанного груза не может быть пустым',
  maxLength: 'Длина не должна превышать {0} символов.',
  PleaseEnterLength: 'Введите {0} символ',
  FreightTermConflict: 'Выбор противоречит выбору места сдачи груза в порту разгрузки',
  FreightTermConflict2: 'Выбор противоречит выбору информации о месте получения в порту погрузки',
  NeedPrefix: 'Требуется декларация с префиксом, префикс одного номера: {0}',
  RemoveThePrefix: 'Необходимо удалить префикс: {0}',
  PhoneTooLong: 'Номер зоны не может превышать 4 символов, телефон не должен превышать 20 символов',
  SaveOnly: 'Сохранить только',
  Only6: 'Поддерживаются только 6 цифр.',
  ChargesPaymentMethod: 'Способы покрытия расходов',
  CopyConsignor: 'Копирование отправителя',
  CopConsignee: 'Копирование грузополучателя',
  BuyerAndSellerInformation: 'Информация о продавце',
  StreetNumber: 'Номер улицы',
  WaitingForReceipt: 'Последняя отправка прошла успешно и еще не получила квитанцию, пожалуйста, подождите квитанцию, чтобы отправить ее снова',
  DirectlyRepresenting: 'Прямое представительство',
  IndirectRepresentation: 'Косвенный представитель',
  NeedOne: 'Нужно только добавить данные.',
  ContainShutOutJob: 'Включая операции по возврату',
  BatchEditJobNo: 'Серийное изменение бизнес - номера',
  IncludingSCFIFreightRate: 'Включает тарифы SCFI',
  SCFIDesignatedBoxType: 'Укажите тип ящика SCFI',
  JingyiSystemForecast: 'Прогноз системы Цзинъи',
  OriginalAHR: 'Оригинальный AHR',
  AddChr: 'Увеличение CHR',
  CorrectAFR: 'Исправление AFR',
  NonRepeatingNumbers: 'Введите цифры, которые не повторяются.',
  AddressFormatting: 'Форматирование адресов',
  SendToGoFreight: 'Отправить в GO Freight',
  ViewSendLog: 'Просмотреть журнал отправки',
  BookingFreightRate: 'Тариф бронирования',
  SelectedDataDeclaration: 'Выберите декларацию данных',
  EmptySubmissionDeclaration: 'Пустое представление декларации',
  SettlementFreightRate: 'Расчетный тариф',
  DeclarationRecord: 'Отчетность',
  ImNotHavePermissionDetails: 'я извиняюсь! У вас нет прав на просмотр подробностей.',
  ActionOptionsNotCaptured: 'Параметры операции не захвачены!',
  BatchNotSupportedPleaseAgain: 'Не поддерживается массовая отправка, пожалуйста, выберите заново!',
  ItFreightAndRepeatedAllowed: 'Отправлено в GO Freight, повторная отправка не допускается',
  SentSuccessfully: 'Отправить успешно',
  CheckTheSendingLog: 'Проверить журнал отправки',
  OnlyToViewTheSelect: 'Выберите только один бизнес для просмотра журнала отправки, пожалуйста, выберите заново!',
  ItUpTo50Businesses: 'Максимально можно выполнить 50 операций.',
  Business: 'Операции:',
  NonIntegralType: 'Неполный тип',
  SendComplete: 'Отправка завершена',
  PackingList: 'Упаковочный лист',
  PleaseContainerBusinessForOperation: 'Пожалуйста, выберите весь бизнес для операции!',
  EmptyInterfaceSendingPleaseWait: 'Отправка интерфейса данных пустого ящика, пожалуйста, подождите...',
  VerificationOfDeclarationData: 'Проверка декларируемых данных',
  DataCheckTheDataAgain: 'Ошибка проверки данных, пожалуйста, проверьте данные и попробуйте снова.',
  PleaseWhetherToSubmitThis: 'Пожалуйста, убедитесь, что это сделано.',
  TicketData: 'Данные о билетах?',
  DataDeclarationSucceeded: 'Объявление данных успешно.',
  EmptySubmittedSuccessfully: 'Пустая подача прошла успешно.',
  NotData: 'Нет данных.',
  ThereElectronicPackingListData: 'Нет данных в электронном ящике.',
  SendFailed: 'Ошибка отправки:',
  Empty: 'Пустота',
  PleaseOfDepartureMustPort: 'Пожалуйста, подтвердите, что портом отправления должен быть порт Шанхая.',
  PleaseMustBeTheExchange: 'Просьба подтвердить, что порт разгрузки должен быть указан в качестве порта, указанного судоходной станцией.',
  PleaseOfGoodsMustGoods: 'Пожалуйста, убедитесь, что тип груза должен быть универсальным.',
  PleaseOfTheMainCY: 'Пожалуйста, подтвердите, что условия перевозки основного листа должны быть "CY - CY".',
  PleaseTradeTermsMustCIF: 'Пожалуйста, подтвердите, что условия торговли должны быть "CIF".',
  PleaseBoxQuantityInformationCorrect: 'Пожалуйста, убедитесь, что информация о количестве ящика верна.',
  TheAmountReceivableIncludesUSD: 'Пожалуйста, подтвердите стоимость - Дебиторская задолженность включает указанную сумму USD.',
  NoBillOfLadingInformation: 'Нет информации о коносаменте HBL.',
  ResponseDataIsEmpty: 'Данные ответа пусты',
  PleaseToViewTheLog: 'Выберите бизнес для просмотра журнала отправки!',
  ExportEDI: 'Экспорт EDI?',
  LandTransportationDetailsEditing: 'Редактор подробной информации о наземном транспорте',
  PreviewOfBookingFileParsing: 'Предварительный просмотр документов бронирования',
  GenerateOrder: 'Создать заказ',
  HangInTheAir: 'Не завершено',
  Completed: 'Завершено',
  Dustbin: 'Мусорный контейнер',
  PictureLoadingFailed: 'Ошибка загрузки изображения',
  ResolutionCompletionTime: 'Время завершения анализа',
  ViewParsingResults: 'Просмотреть результаты анализа',
  ViewOrder: 'Посмотреть заказ',
  AreYouWantToDelete: 'Подтвердить удаление?',
  BusinessNumber: 'Номер операции',
  LCL: 'Весь ящик',
  NearlyAWeek: 'Почти неделю.',
  NearlyAMonth: 'Почти месяц.',
  NearlyThreeMonths: 'Почти три месяца.',
  DragUploadTheFileIdentified: 'Перетащите файл сюда, чтобы загрузить файл, который должен быть идентифицирован',
  SupportUploadFormat: 'Поддерживаемый формат загрузки',
  ParsingFailed: 'Ошибка анализа',
  ParsingComplete: 'Анализ завершен',
  OrderGenerated: 'Создан заказ',
  UploadCompletedParsing: 'Загрузка завершена, анализируется...',
  Second: 'Секунда',
  ReviewRejectedBusinessNumber: 'Оперативный номер для пересмотра отказа',
  RejectedBusinessNumber: 'Номер операции, в которой было отказано',
  TheNotExceed5Lines: 'Максимум не должен превышать 5 строк!',
  Interface: 'Интерфейс',
  Sinotrans: 'Транспорт',
  SinotransEastChinaCoLtd: 'Китайская компания с ограниченной ответственностью',
  NingboEPort: 'Электронный порт Нинбо',
  SeaHousekeeper: 'Дворецкий',
  Wse: 'Фюс',
  CargoWare: 'Отправить Cargoware',
  EDISend: 'Отправить EDI',
  OtherChannel: 'Другие каналы',
  Ningbo99Road: 'Маршрут 99.',
  DeclarationHistory: 'История декларирования',
  CredentialNumber: 'Номер документа',
  ResponseCode: 'Код ответа',
  ElectronicBoxListSendingHistory: 'История отправки электронных ящиков',
  PrintTime: 'Время печати',
  PrintingTimes: 'Количество печатей',
  BookingDataFeedback: 'обратная связь с данными бронирования',
  QuerySendingLog: 'Журнал отправки запросов',
  SendDataInformation: 'Передача информации о данных',
  ExportAllEDI: 'Экспорт всех EDI',
  UploadThisPageEDI: 'Загрузить эту страницу EDI',
  UploadAllEDI: 'Скачать все EDI',
  EmailUploadEDI: 'Отправить EDI',
  IsExportEDI: 'Экспорт EDI?',
  UploadEDI: 'Скачать EDI?',
  IsUploadAllEDI: 'Загрузить все EDI?',
  MailSending: 'Отправка почты',
  UploadEDISucceeded: 'Удалось загрузить EDI',
  FailedToUploadEDI: 'Ошибка загрузки EDI',
  MultiSegmentNumberRuleConfiguration: 'Настройка многосегментных правил',
  StartNumber: 'Начальный номер',
  IncrementalRule: 'Дополнительные правила',
  DirectExport: 'Прямой экспорт',
  Plus1: 'Плюс 1',
  Plus10: 'Плюс 10',
  TheNumberCannotBeEmpty: 'Начальный номер не может быть пустым.',
  IllegalNumberEntry: 'Номер вводится незаконно.',
  TheMustBeGreaterZero: 'Количество экземпляров должно быть больше нуля.',
  IncrementRuleIsNotSelected: 'Увеличивающее правило не выбрано.',
  PleaseBusinessNumberSearchCriteria: 'Введите номер операции. Условия поиска.',
  UploadCompletedProcessing: 'Загрузка завершена, обработка продолжается',
  SuccessfulProcessing: 'Успешно обработано',
  ProcessingFailed: 'Ошибка обработки',
  ExportTime: 'Время экспорта',
  UnitPriceCannotBe0: 'Цена не может быть 0',
  ExchangeRateCannotBe0: 'Обменный курс не может быть 0',
  CustomsNoCannotBeBlank: 'Номер не может быть пустым!',
  ShipperCityCannotBeBlank: 'Введите название города отправителя',
  PrimaryCustomsNo: 'Является ли основной номер',
  GetPackingInformation: 'Получение информации о упаковке',
  GetGoodsInformation: 'Доступ к информации о грузе',
  GetGoodsInformationTip: 'Размер входной записи, связанной с подписью на странице [информация о грузе]',
  SynchronizeMainTicketPackingInformation: 'Синхронизация информации об упаковке основного билета',
  CaseNumberCannotBeEmpty: 'Номер ящика не должен быть пустым.',
  InvalidCaseNumber: 'Неверный номер ящика.',
  TheSealNumberCannotBeEmpty: 'Печать не может быть пустой.',
  BoxTypeCannotBeEmpty: 'Ящик не может быть пустым.',
  EnglishNameCannotBeEmpty: 'Английское название не может быть пустым.',
  TheMarkCannotBeEmpty: 'Маркировка не должна быть пустой.',
  HscodeCannotBeEmpty: 'HSCODE не может быть пустым.',
  ThePackageCannotBeEmpty: 'Упаковка не должна быть пустой.',
  ThePiecesCannotBeEmpty: 'Количество мест не может быть пустым.',
  GrossWeightCannotBeEmpty: 'Вес брутто не может быть пустым.',
  VolumeCannotBeEmpty: 'Объем не может быть пустым.',
  DanUNNoCannotBeEmpty: '【UN Code】 Обязательное заполнение опасных грузов, диапазон 0001 - 9999',
  DanClassNoCannotBeEmpty: '【Класс опасности】 Обязательное заполнение опасных грузов, диапазон: 1–9.9',
  DangerousGoodsContactCannotBeEmpty: 'Контакты с опасными грузами не должны быть пустыми.',
  DangerousGoodsContactPhoneNumberCannotBeEmpty: 'Контактные телефоны опасных грузов не могут быть пустыми',
  TherePleaseEnterItTab: 'Нет импортируемой информации, пожалуйста, подпишите и введите на странице « Информация о упаковке»',
  NoMasterTicketInformationYet: 'Нет информации о билете!',
  WeighingMethod: 'Способ взвешивания',
  VGMLLC: 'Компания VGM',
  VGMWeightAddress: 'Весовой адрес VGM',
  VGMSignature: 'Подпись VGM',
  TareWeight: 'Вес тары',
  TareWeightUnit: 'Единицы веса тары',
  WeighingAddress: 'Весовой адрес',
  WeighingMethodCannotBeEmpty: 'Вес не может быть пустым.',
  TheWeightCannotBeEmpty: 'Общий вес не может быть пустым.',
  VGMCompanyCannotBeEmpty: 'Ответственная компания VGM не может быть пустой.',
  VGMSignatureCannotBeEmpty: 'Подпись VGM не может быть пустой.',
  MailboxCannotBeEmpty: 'Почтовый ящик не может быть пустым.',
  PhoneNumberCannotBeEmpty: 'Телефон не может быть пустым.',
  WeighingAddressCannotBeEmpty: 'Весовой адрес не может быть пустым.',
  NotifierCodeCannotBeEmpty: 'Корпоративный код уведомителя не может быть пустым.',
  ContactNotifierCannotBeBlank: 'Контактная информация уведомителя не может быть пустой.',
  ImportTallyInformation: 'Импорт информации о грузе',
  PTImport: 'Импорт PT',
  SelectTime: 'Время выбора',
  CaseNoSealNo: 'Номер ящика',
  CopySmallTicketCost: 'Стоимость небольших билетов',
  PleaseCostToBeCopied: 'Выберите стоимость копирования.',
  CrossTenantDelegationHistory: 'Транстенантная запись состояния',
  Operator: 'Оператор',
  OperationTime: 'Время работы',
  DelegationStatusHistory: 'История состояния доверенности',
  GeneratePrimaryDocNo: 'Создать основной номер',
  PleasePrimaryOrderNumberRule: 'Выберите главное правило',
  PleaseCodeOfTheNo: 'Пожалуйста, выберите номер службы',
  SendOnlineManifestInvitationEmail: 'Отправка приглашений по электронной почте',
  PleaseConfirmEmailAddress: 'Подтвердите адрес почтового ящика:',
  ShippingPreConfigurationInformationManifest: 'Экстремальная версия морского бронирования - Предварительная информация - Приглашение к онлайн - манифесту',
  TheSentToTheIt: 'Ссылки на приглашения были отправлены в почтовый ящик, обратите внимание, чтобы проверить!',
  TotalCustomsNo: 'Итого, таможенный номер',
  TotalNumberOfPieces: 'Общее число претензий',
  TotalGrossWeight: 'Общий вес брутто',
  TotalVolume: 'Общий объем',
  CustomsNoNotImported: 'Не импортирован номер таможенного листа:',
  ImportDate: 'Импорт даты',
  ImportUser: 'Импорт пользователей',
  SendUser: 'Отправить пользователю',
  ManifestImportUser: 'Импорт накладной пользователя',
  SendTag: 'Отправить метку',
  SubtotalOfCustomsOrderNo: 'Итого, таможенный номер',
  ConfirmToVoid: 'Подтверждается ли аннулирование?',
  MBNOCannotBeEmpty: 'MB / L No не может быть пустым!',
  ShipNameCannotBeEmpty: 'Название корабля не может быть пустым!',
  VoyageCannotBeEmpty: 'Рейс не может быть пустым!',
  ShippingCompanyCannotBeEmpty: 'Судоходная компания не может быть пустой!',
  ShippingAgentCannotBeEmpty: 'Корабли не могут быть пустыми!',
  DestinationPortCannotBeEmpty: 'Порт назначения не может быть пустым!',
  GoodsTypeCannotBeEmpty: 'Тип груза не может быть пустым!',
  TransportationTermsCannotBeBlank: 'Условия перевозки не должны быть пустыми!',
  FreightTermsCannotBeBlank: 'Условия доставки не могут быть пустыми!',
  BillTypeCannotBeEmpty: 'Тип коносамента не может быть пустым!',
  PaymentPlaceCannotBeEmpty: 'Место оплаты не может быть пустым!',
  MattersNeedingAttention: 'Замечания',
  DontRemindMeAgain: 'В следующий раз не напоминать.',
  CloseSpace: 'Закрыть',
  TheBeenSentToSending: 'Номер таможенного манифеста в этом манифесте 【{0}】 был отправлен в EDI и продолжается ли отправка?',
  SelectToSendPreManifest: 'Выберите канал для отправки предварительных накладных',
  SelectCorrectConfiguredManifestChannel: 'Выберите канал для исправления предварительной накладной',
  SelectDeleteConfiguredManifestChannel: 'Выберите канал для удаления предварительной накладной',
  ThePleaseRefreshTheAgain: 'Объект чистки манифеста пуст, попробуйте снова после обновления страницы',
  CustomsClearanceNo: 'Номер таможенной декларации',
  ShippingCompanyOperation: 'Операции судоходной компании',
  CustomsRestAssured: 'Таможенники спокойны',
  PlanType: 'Тип плана',
  AcceptanceTime: 'Дата принятия',
  ScheduledStartTime: 'Планируемое время начала',
  PlannedEndTime: 'Планируемое время окончания',
  DepartureTime2: 'Время отправления:',
  PortCutOffTime: 'Время перехвата:',
  ActualBerthingTimeColon: 'Фактическое время стоянки:',
  ActualDepartureTimeColon: 'Фактическое время выхода:',
  ClickToViewTheTrailer: 'Посмотреть трейлер',
  DisplayPortArea: 'Ниже приведены данные по портам / судоходным компаниям.',
  DetailedData: 'Подробные данные',
  manualPrompt: 'Оранжевые данные: Служба данных',
  thirdPartyPrompt: 'Светло - синие данные: ручной ввод',
  promptNo: 'Серые данные: нет данных',
  promptNoData: 'НД',
  ArrivalReportStatus: 'Статус отчета о прибытии',
  CustomsClearanceSheetStatus: 'режим сортировки',
  PlanDetails: 'Подробности плана',
  PutInTheBox: 'Выпущенный ящик',
  EmptyBox: 'Пустой ящик',
  Arrival: 'Въезд в порт',
  EstimatedCYOpening: 'Предполагаемый порт',
  PortDocCutOff: 'Портовый ордер',
  ActualBerthing: 'Фактический причал',
  ActualDeparture: 'Фактическая загрузка',
  customsClearance: 'Таможенное разрешение',
  DockRelease: 'Отпуск на пристань.',
  CancelCustomsClearance: 'Отменить морскую',
  CancelDockRelease: 'Отмена кода',
  AllocateVehiclesToTransportSth: 'Загрузка',
  Sail: 'Отправление',
  Departure: 'Отъезд',
  Pickup: 'Поднимать вес',
  BusinessFunction: 'Оперативные функции',
  ClickTheButton: 'Нажмите кнопку',
  ReturnAddress: 'Вернуть адрес',
  DepartureTime3: 'Время вылета',
  ArrivalWharf: 'Прибытие на пристань',
  departureTime: 'Время выхода',
  StowageTime: 'Время загрузки',
  AbnormalCause: 'Необычные причины',
  StackingTime: 'Время ввода кода',
  StackingState: 'Состояние кода',
  SeaReleaseTime: 'Морское время',
  SeaReleaseDescription: 'Описание морской',
  SeaReleaseState: 'Активное состояние моря',
  arrivalTime: 'Время прибытия',
  TrailerFollow: 'Прицеп за мной.',
  SuitcaseLocation: 'Местонахождение чемодана',
  BoxReleaseTime: 'Время загрузки',
  EstimatedPickUpPoint: 'Ожидаемая точка чемодана',
  Wharf: 'Причал',
  NameNumberOfImportedVessels: 'Импорт судна',
  FieldBoxPosition: 'Места в полевых ящиках',
  NameNumberOfExportVessel: 'Название судна на выходе',
  containerWeight: 'Вес контейнера',
  VGMWharfWeighing: 'Вес терминала VGM',
  ContainerHolder: 'Владелец ящика (только порт Шанхая)',
  LeadSeal: 'Свинец',
  TransshipmentPort: 'Порт транзита',
  VGMMessageReceiving: 'Прием сообщений VGM',
  ApproachMode: 'Режим захода',
  ArrivalMessageTime: 'Время прибытия сообщения',
  AppearanceMode: 'Способ выхода',
  ReeferTemperatureRequired: 'Температура охлаждения',
  ReceivedTheReleaseTime: 'Прием. Время выхода.',
  NationalInspectionRelease: 'Госинспекция разрешила',
  OverrunCode: 'Суперкод',
  WharfStowage: 'доковая загрузка',
  EmptyContainerRelease: 'Пустой ящик.',
  Front: 'Предыдущий',
  After: 'А',
  SuperLong: 'Очень длинный.',
  FlowTo: 'Поток',
  Left: 'Левый',
  Right: 'Правый',
  UltraWide: 'Гиперширина',
  MaritimeReleaseException: 'Морская аномалия',
  SuperHigh: 'Сверхвысокая',
  QuantityOfBoxesAndPieces: 'Количество ячеек:',
  GreaterActualNumberOfPieces: 'Больше, чем фактическое число:',
  BoxWeight: 'Вес ящика:',
  GreaterThanActualWeight: 'Больше фактического веса:',
  BoxVolume: 'Объем ящика:',
  LargerThanActualVolume: 'Больше, чем фактический объем:',
  JobNoColon: 'Номер работы:',
  AddSpellCustomsOrderNo: 'Комбинированный таможенный номер',
  PleaseForAddingAndForm: 'Пожалуйста, выберите правила',
  PleaseSelectSuffixSeparator: 'Выберите суффиксный разделитель',
  PleaseCustomsDeclarationNoSpelled: 'Введите номер таможенного листа',
  DirectToCanada: 'Прямая дорога в Канаду',
  ToInlandWarehouse: 'На внутренний склад.',
  TransitClearancePullToStates: 'Транзит в Канаде, без таможенной очистки, в США',
  TheThroughTheUnitedStates: 'Грузовой путь в США',
  PleaseSelectAnAccount: 'Выберите счет',
  PleaseOfYourCurrentFirst: 'Пожалуйста, сохраните код вашего текущего отдела!',
  ItServiceProviderOfHouse: 'Становится поставщиком услуг « Дом ВБ.',
  YouHisPartnerAndService: 'Вы можете подать заявку онлайн, чтобы стать его партнером, и вы можете наслаждаться онлайн - сервисом заказа.',
  PleaseSelectTheEntrustingCompany: 'Пожалуйста, выберите доверительную организацию!',
  PleaseSelectDestinationAgent: 'Пожалуйста, выберите агента порта назначения!',
  UncheckedSmallTicket: 'Небольшой билет',
  CustomerInformation: 'Информация о клиентах',
  CodeCannotBeEmpty: 'Код не может быть пустым.',
  TheNameCannotBeEmpty: 'Имя не может быть пустым.',
  CertificateTypeCannotBeBlank: 'Тип документа не может быть пустым.',
  IDNumberCannotBeEmpty: 'Номер документа не может быть пустым.',
  AddressCannotBeEmpty: 'Адрес не может быть пустым.',
  CityCannotBeEmpty: 'Город не может быть пустым.',
  CountryCannotBeEmpty: 'Государство не может быть пустым.',
  ThisSuccessfullyInsuredRepeatedAllowed: 'Этот билет успешно застрахован, повторное страхование не допускается',
  Seller: 'Продавец',
  Manufacturer: 'Производитель',
  Consolidator: 'Экспедитор',
  OriginalBookingParty: 'Первоначальная сторона бронирования',
  GoodsReceiver: 'Получатель груза',
  PackingPoint: 'Точка упаковки',
  Importer: 'Импортеры',
  AMSNoCannotBeBlank: 'Номер AMS не может быть пустым.',
  SCACCompanyCannotBeEmpty: 'Судоходная компания SCAC не может быть пустой.',
  TheDischargeCannotBeEmpty: 'Порт разгрузки не может быть пустым.',
  TheDeliveryCountryCannotBeEmpty: 'Страна места сдачи груза не может быть пустой.',
  TheDeliveryCannotBeEmpty: 'Место поставки не должно быть пустым.',
  CorrectionOfBillOfLading: 'Исправление коносамента',
  OriginalBillOfLading: 'Оригинальный коносамент',
  TheBillOfLadingEmpty: 'Место отправления коносамента не должно быть пустым.',
  SailingDateEmpty: 'Дата отправления не может быть пустой.',
  TransceiverSelection: 'Выбор приемопередатчика',
  YouServiceOfTheManifest: 'Вопросы по предварительной накладной можно нажать на значок, чтобы проконсультироваться с экономкой.',
  OriginalCleaningManifest: 'Первоначальная чистка манифеста',
  Correction1: 'Исправление1',
  CorrectCleaningManifest: 'Исправление манифеста уборки',
  SendPreConfiguredManifest: 'Отправка предварительных накладных',
  CorrectionOfPreAllocationManifest: 'Исправления к предварительной накладной',
  DeletePreConfiguredManifest: 'Удаление предварительных накладных',
  CancelPreConfiguredManifest: 'Отмена авансовых накладных',
  OriginalPreAllocatedManifest: 'Первоначальная предварительная накладная',
  CleanManifestAPI: 'Уборка накладных API',
  OriginalVGM: 'Оригинальный VGM',
  HscodeConfigurationInformationCannotEmpty: 'Предназначенная информация HSCODE не может быть пустой.',
  HscodeInformationMustBeDigits: 'Предварительная информация HSCODE должна быть 6 - битной.',
  PleaseTickTheBoxForTheCargoInformationYouWantToAmendTheManifest: 'Пожалуйста, укажите информацию о грузе, который вы хотите изменить в манифесте.',
  PleaseConfirmThatTheCustomsInformationYouSelectedHasNotBeenModified: 'Выбранная вами информация о таможенной декларации не была изменена, пожалуйста, убедитесь',
  PleaseSelectAllSeaHouseUpdateData: 'Вы изменяете содержимое модуля 【Основная информация о манифесте】 & 【Отправка информации клиентом】, выбирая все отправленные сообщения о таможенной декларации для отправки вместе',
  SendingSucceeded: 'Отправить успешно!',
  TheTheReceiptLogInformation: 'Оригинальный манифест отправлен, нажмите журнал квитанций, чтобы увидеть информацию о квитанции.',
  UpdateSucceeded: 'Обновление успешно!',
  PleaseSuccessfullyIfNotFirst: 'Пожалуйста, убедитесь, что оригинал был отправлен успешно, и если он не был отправлен, сначала отправьте оригинал.',
  DeleteSucceeded: 'Удалить успешно!',
  WseModifyReasonNotEmpty: 'Пожалуйста, выберите причину изменения',
  WseModifyRemarkNotEmpty: 'Просьба пояснить',
  WseDeleteReasonNotEmpty: 'Выберите причину удаления',
  WseDeleteRemarkNotEmpty: 'Пожалуйста, добавьте исключение.',
  BrandNew: 'Совершенно новый.',
  SecondHand: 'Вторые руки',
  Unknown: 'Неизвестно',
  ReImportAfterModification: 'Изменить и повторно импортировать',
  FailedToDownloadData: 'Ошибка загрузки данных',
  ClickVehiclePositioningAndTrack: 'Нажмите кнопку, чтобы узнать местоположение и траекторию движения автомобиля.',
  VehiclePositioningTrack: 'траектория траэтория наведения вагона',
  IfToTheCurrentIt: 'Текущий статус платежей, причитающихся транспортной компании, был изменен, и после (удаления / редактирования) он больше не будет синхронизироваться с подписями на странице сборов, будет ли он продолжаться?',
  VehicleTrajectory: 'Траектория движения автотранспортных средств',
  DistributionCustomsNo: 'Номер распределительной декларации',
  BookingReceipt: 'квитанция о бронировании',
  InMailOfThePrevail: 'Этап внутреннего тестирования, в зависимости от почты судовладельца',
  CorrectBooking: 'Исправление бронирования',
  OriginalBooking: 'Оригинальный заказ',
  TheBeVoidedAndThis: 'Основной номер был создан, повторная генерация отменит оригинальный номер и создаст новый номер, подтверждается ли это?',
  BasicTab: 'Базовая подпись страницы',
  TheHairBodyCannotEmpty: 'Реальное тело не может быть пустым.',
  PackageCannotBeEmpty: 'Упаковка не должна быть пустой.',
  MBLTab: 'Подписка страницы MBL',
  ShipperCannotBeBlank: 'Отправитель не может быть пустым.',
  ConsigneeCannotBeEmpty: 'Получатель не может быть пустым.',
  NotifierCannotBeBlank: 'Уведомление не может быть пустым',
  TheEmptyPleaseRefreshAgain: 'Предназначенный объект манифеста пуст, пожалуйста, обновите страницу и попробуйте снова',
  TheIsEmptyPleaseAgain: 'Исправление предварительной накладной пусто, попробуйте снова после обновления страницы',
  VGMRefreshThePageAgain: 'Объект VGM пуст, попробуйте снова после обновления страницы',
  TheCleaningIsEmptyPleaseAgain: 'Предназначенная чистка манифеста пуста, пожалуйста, обновите страницу и попробуйте снова',
  TheNoCannotBeBlank: 'Номер не может быть пустым.',
  MBLNoCannotEmpty: 'MB / L NO не может быть пустым.',
  NewGoods: 'Дополнительные товары',
  DeleteGoods: 'Удалить товар',
  TotalOfThisBox: 'Всего в этом ящике:',
  DataComparison: 'Сравнение данных',
  UpdatePortAreaData: 'Обновление данных по портам',
  NoPortDataHasBeenObtained: 'Данные по порту пока не получены.',
  SynchronizePortData: 'Синхронизация портовых данных',
  NotVerified: 'Не проверено',
  SystemVerification: 'Проверка системы на соответствие',
  ManualVerification: 'Проверка соответствия вручную',
  ToBeConfirmed2: 'Подлежит подтверждению',
  TheInThePortOpened: 'Служба отправки данных о контейнерах в порту еще не открыта',
  TheDirectlyImportTheCall: 'Служба данных о контейнерах в порту может помочь вам проверить правильность информации о контейнерах или импортировать данные о контейнерах непосредственно в бизнес. Для открытия обратитесь в службу онлайн или позвоните по телефону:',
  HarbourNotInServiceNoOpen: 'В портах - партнерах пока не функционирует служба сопоставления данных, которая не может обеспечить функцию сопоставления данных. В настоящее время поддерживается сравнение данных в других портах, обратитесь в онлайн - службу обслуживания клиентов или позвоните по контактному телефону, если вам нужно открыть:',
  HarbourInServiceNoOpen: 'Служба данных о контейнерах в порту может помочь вам проверить правильность информации о контейнерах, а также напрямую импортировать данные о контейнерах в порту, чтобы обеспечить легкий ввод данных. Для открытия обратитесь в службу онлайн или позвоните по телефону:',
  HarbourNotInServiceOpen: 'В настоящее время не поддерживается публикация и сравнение данных по этому району.',
  ThisActionCannotBeUndone: 'Эта операция не может быть отозвана',
  DoYouWantToContinue: 'Продолжите?',
  ItPortDataAndVerified: 'Данные не совпадают с данными порта, не могут быть проверены',
  TheNotContainTheData: 'Текущие данные не включают следующие портовые данные',
  PortInformationVerification: 'Проверка портовой информации',
  SIsMissingAndVerified: 'Отсутствие S / O NO, невозможно проверить',
  PleaseNoForTheFirst: 'Пожалуйста, заполните S / O NO для текущего билета.',
  TheOverwriteTheCurrentData: 'Функция покрывает текущие данные.',
  OperationSucceeded: 'Операция удалась!',
  OrderNumber: 'Количество заказов',
  TotalPacking: 'Общее количество упаковок',
  ContainerList: 'Список контейнеров',
  UpdateStatus: 'Обновить статус',
  ClearThePackingInformation: 'Очистить информацию об упаковке',
  ExportThePackingPlan: 'Экспорт плана упаковки',
  checkGoods: 'Посмотреть товары',
  checkPackages: 'Посмотреть упаковку',
  NumberOfPackages: 'Количество упаковки',
  AskForPositionTime: 'Требуется время входа.',
  EstimatedPositionTime: 'Ожидаемое время ввода',
  CheckTheDetailsOfTheGoods: 'Посмотреть детали груза',
  UnableToRemove: 'Невозможно удалить, контейнер заблокирован или упакован',
  removeOrderTips: 'Вы уверены, что удалили этот заказ?',
  removeOrder: 'Удалить заказ',
  PackageNo: 'Номер упаковки',
  NumberOfPackagesAnticipateOrReality: 'Количество упаковок (предварительно / фактически)',
  Code4: 'Код',
  LengthAnticipateOrReality: 'Длинная (предварительная / реальная)',
  WidthAnticipateOrReality: 'Ширина (предварительно / реально)',
  HighAnticipateOrReality: 'Высокий (предварительный / реальный)',
  UnitVolumeAnticipateOrReality: 'Единичный объем (предварительный / реальный)',
  GrossWeightAnticipateOrReality: 'Единичный вес брутто (предварительный / реальный)',
  Considerations: 'Замечания',
  Anufacturer: 'Производитель',
  EstimateLoadingTime: 'Ожидаемое время доставки',
  ActualWarehousingTime: 'Фактическое время ввода',
  NO: 'А',
  NoCorrespondingFile: 'Не удалось получить соответствующий файл!',
  ChooseState: 'Выбрать состояние',
  ActualPackingTime: 'Фактическое время упаковки',
  ChooseActualPackingTime: 'Выберите фактическое время упаковки.',
  updateContainerStateTip: 'Ошибка обновления, в коробке есть незагруженный заказ',
  firstCleanedContainer: 'Для начала выберите контейнер, который необходимо очистить.',
  containerBeCleared: 'Контейнеры не могут быть очищены',
  removeSelectedContainer: 'Удалить все заказы на выбранный контейнер?',
  ClearContainerInformation: 'Удаление информации о контейнерах',
  goodsOperateTips: 'Пожалуйста, сохраните этот номер до операции с грузом.',
  removeGoodsTips: 'Выберите товар для удаления',
  NumberOfCartons: 'Количество ящиков',
  importGoodsTips: 'Выберите товар для импорта',
  ChooseGoods: 'Выбрать товар',
  RemoveTheGoods: 'Удалить заказ',
  Source: 'Источник',
  PreCommitUser: 'Предъявитель',
  PreCommitDate: 'Сроки предварительного представления',
  SubmissionDate: 'Дата представления',
  CommitUser: 'Автор сообщения',
  RelatedSubmissionDate: 'Сроки представления корреспонденции',
  RelatedCommitUser: 'Автор корреспонденции',
  RelatedPreCommitUser: 'Авансы на операции со связанными сторонами',
  RelatedPreCommitDate: 'Сроки предварительного представления корреспонденции',
  FcAuditDate: 'Время проверки',
  FcAuditUser: 'Аудитор',
  LockJobDate: 'Время блокировки',
  LockJobUser: 'Запертый человек',
  PrintListTip: 'Выберите список, который вы хотите распечатать',
  CargoActArrivalDatePacking: 'Фактическая дата упаковки',
  releaseStowageState: 'Режим выпуска',
  ChangeHistory: 'Изменить историю',
  SynchronizationInformation: 'Синхронизация информации',
  SyncChargeToEas: 'Синхронизация EAS',
  NoEasCharge: 'Стоимость синхронизации с EAS не требуется.',
  CheckEasChargeState: 'Нет необходимости синхронизироваться с расходами EAS, пожалуйста, проверьте состояние расходов EAS.',
  CheckBusinessUuid: 'Бизнес UUID не может быть пустым!',
  KingDeeChargePush: 'Золотая бабочка стоимость',
  ExternalSerialNumber: 'Номер документа',
  EmptyCabinetDate: 'Время ввода пустых шкафов на завод',
  RealArrivalsDate: 'Фактическое время прибытия',
  ActualLiftingDate: 'Фактическое время подъёма',
  DeliveryDoneDate: 'Время завершения доставки',
  CleaningDate: 'Время чистки',
  ReturnBoxDate: 'Время возврата',
  DestinationDeliveryTime: 'Время доставки в порт назначения',
  DestinationReturnTime: 'Время в порту назначения пусто.',
  PortDischargeTime: 'Фактическое время выгрузки',
  EstimatedPortDischargeTime: 'Предполагаемое время разгрузки',
  UnloadingTime: 'Время разгрузки',
  LiftingTime: 'Время подъёма',
  RailwayDepartureTime: 'Фактическое время железнодорожных перевозок',
  EstimatedRailwayDepartureTime: 'Ожидаемое время железнодорожного транспорта',
  RailwayDischargeTime: 'Фактическое время разгрузки по железной дороге',
  EstimatedRailwayDischargeTime: 'Ожидаемое время разгрузки железной дороги',
  EstimatedTimeOfArrivalAtThePlaceOfDelivery: 'Ожидаемое время прибытия',
  Arrived: 'Прибытие',
  Acquire: 'Счета - фактуры',
  TheActualTimeOfArrivalAtThePlaceOfDelivery: 'Фактическое время прибытия',
  EstimatedCustomsReleaseTime: 'Ожидаемое время выключения',
  EstimatedPickupTime: 'Ожидаемое время подъема',
  ActualPickUpTime: 'Фактическое время подъёма',
  EstimatedDeliveryToWarehouseTime: 'Ожидаемое время доставки на склад',
  EstimatedReturnTime: 'Ожидаемое время',
  ActualReturnTime: 'Фактическое время',
  PODDeliveryInformation: 'Отправка информации из порта назначения',
  ActualDeliveryToWarehouseTime: 'Фактическое время доставки на склад',
  EstimatedDeliveryToCustomersWarehouseTime: 'Ожидаемое время доставки',
  ActualDeliveryToCustomersWarehouseTime: 'Фактическое время доставки',
  PickupMessage: 'CY-DOOR， От порта до склада для разделки ящиков / контейнеров',
  DeliveryToWarehouseMessage: 'Время доставки груза на склад в порту назначения',
  EstimatedDeliveryToCustomersWarehouseMessage: 'От склада контейнеров до склада клиента (B2B) / Доставка с последнего километра склада (B2C)',
  ActualDeliveryToCustomersWarehouseMessage: 'От склада до склада клиента / доставка в последнем километре от склада',
  CargoReadyDate: 'Доставка времени',
  BackUpWarehouse: 'Передний бункер',
  PleaseSelectBackUpWarehouse: 'Выберите опцию [bracket0]',
  HeavyContainerMobilization: 'заход на посадку в тяжёлом контейнере',
  checkLines100: 'Количество выбранных строк не должно превышать 100!',
  estimatedDeliveryTime: 'Ожидаемое время выхода',
  estimatedArrivalTime: 'Ожидаемое время прибытия',
  EmailGroup: 'Группа почты',
  EmailTemplate: 'Шаблоны сообщений',
  CargoAllocationList: 'Перечень модулей',
  CheckApproved: 'Пожалуйста, выберите бизнес для проверки!',
  StateVerifyingReview: 'Проверено (подлежит пересмотру)',
  VotesSubmission: 'Билеты сданы?',
  BatchSubmitCheckOperate: 'Можно отправлять только действующие листы!',
  BatchSubmitCheckPre: 'Только предъявить заранее поданный список!',
  CancelFormalHblTips: 'Уже существует список форм, пожалуйста, удалите галочку после отмены!',
  BatchSend: 'Массовая отправка',
  BatchSendCheck: 'Укажите стоимость отправки EAS',
  BatchSendTip: 'Только синхронизировать непроверенные расходы, пожалуйста, проверьте состояние расходов',
  PleaseSelectRemovedContainer: 'Выберите информацию о упаковке, которую необходимо удалить!',
  PleaseRemovedSplitOrder: 'Сначала удалите лист формы, связанный с текущим демонтажем!',
  ThereAreTheFollowingExceptionsInTheImportDataPleaseCheckTheDataInTheForm: 'Импорт данных имеет следующие аномалии, пожалуйста, проверьте данные в форме',
  NoPrimaryTicketIsAssociatedSoTheContainerDataCannotBeImported: 'Несвязанный основной билет, невозможно импортировать данные о контейнере',
  ImportContainerInformation: 'Импорт информации о контейнере?',
  SecondLoadingTime: 'Транзитная погрузка',
  SecondDepartureTime: 'транзитный рейс',
  SecondArrivalTime: 'транзитное прибытие',
  SecondUnloadingTime: 'транзитный разгрузочный судно',
  TransferModeAtTransferPoint: 'транзитный режим',
  DispatchVehiclesAtDestination: 'Доставка а/м в ПН',
  PortOfDestinationServices: 'Услуги порта назначения',
  Manifest: 'Авансовые накладные',
  Other: 'Прочее',
  Temperature: 'Температура',
  OpenVentilation: 'Открыть вентиляцию.',
  VentilationQuantity: 'Объем вентиляции',
  VentilationUnit: 'Единица вентиляции',
  FlashPointUnit: 'Flashpoint единицы',
  HazardForm: 'Формы опасных грузов',
  AutoSpecialGoods: 'Автоматический доступ к упаковочной информации для специальных грузов',
  HaveMaintainedSpecialInfo: 'Вы обнаружили, что вы поддерживаете специальную информацию о грузе, автоматически получаете информацию о упаковке на основе английского наименования и кода HS?',
  PackingInformation: 'Успешное получение упаковочной информации.',
  NoPackingInformation: 'Отсутствует информация о упаковке.',
  Humidity: 'Влажность%',
  OverSize: 'Гиперразмер',
  ZYQHG: 'Левый / правый / передний / задний / превосходный (CM)',
  PortOfDestinationCustomsClearance: 'Таможенная очистка в порту назначения',
  DestPortCustomsClearanceInfo: 'Информация о таможенной очистке',
  PleaseSelectData: 'Выберите указанные данные',
  PlateNumberAndBillLadingNumberCannotEmpty: 'Номер машины и коносамента не должны быть пустыми.',
  LineXQuantityMustGreaterThanZero: 'Количество строк {rowNum} должно быть больше 0',
  LineXQuantityExceedsMaxValue: 'Количество строк {rowNum} {quantity} превышает максимальное значение {maxValue}',
  LineXWeightMustGreaterThanZero: 'Вес брутто строки {rowNum} должен быть больше 0',
  LineXWeightExceedsMaxValue: 'Масса брутто строки {rowNum} {weight} превышает максимальное значение {maxValue}',
  LineXCubageMustGreaterThanZero: 'Размер строки {rowNum} должен быть больше 0',
  LineXCubageExceedsMaxValue: 'Объем строки {rowNum} {cubage} превышает максимальное значение {maxValue}',
  HasExport: 'Экспорт',
  DelegatedAssociatedBusinessStatus: 'Статус доверенной связи',
  TransactionRelatedBusinessStatus: 'Состояние корреспонденции',
  SecondarySynchronization: 'Квадратная синхронизация',
  NumberOfCustomsOrders: 'Закрытое число',
  CustomerClosingTime: 'Заказчик останавливает время',
  AddToMainTicket: 'Присоединиться к основному билету',
  CustomsDeclarationRemark: 'Примечания к таможенной декларации',
  OperationGuide: 'Руководство по эксплуатации',
  ServiceInformation: 'Руководство по обслуживанию',
  ScopeServices: 'Сфера обслуживания',
  DeletionGuide: 'Шанхайский порт Руководство по удалению',
  BusinessData: 'Информация о деятельности порта Шанхай',
  SecondVesselInformation: 'Двойная информация',
  vesselText: 'Получение названия судна с помощью данных о контейнере в порту: ${1}, рейс: ${2} и имя судна, подписанное на странице бронирования: ${3}, рейс: ${4} не совпадает, записывается ли в номер судна, полученный в коносаменте, и очищаются полученные данные о продолжительности судна?',
  textiles: 'Текстильные изделия',
  nonTextiles: 'Нетканые',
  importEmpty: 'Импортировать и очистить',
  importNotEmpty: 'Импорт не чист',
  ignore: 'Игнорировать',
  empty: 'Пустой',
  salveNoDcToKeepMaster: 'Доверительная организация не обслуживает соответствующий документарный персонал, сохраняет ли он основной вексельный документ?',
  CustomersCollectByBubble: 'Покупатель получает',
  CollectionBySupplier: 'Сбор средств поставщиками',
  Slac: 'Количество мелких грузов',
  BookingShutOut: 'Отгрузка при бронировании',
  tip: 'Подсказка',
  ShippingCompanyDialogModifyText: 'Вы изменили судоходную компанию, чтобы очистить имеющуюся информацию о порту назначения? Если вы откроете службу отслеживания грузов судоходной компании, вы повторно подпишетесь на страницу бронирования, чтобы подписать информацию о порту назначения.',
  ShippingCompanyDialogDeleteText: 'Вы удалили судоходную компанию, очистили ли вы информацию о существующем порту назначения?',
  emptyDestinationInformation: 'Очистить',
  noEmptyDestinationInformation: 'Не чистить',
  BatchModifyBusiness: 'Операции пакетного изменения',
  DataAdjustment: 'Корректировка данных',
  OriginalData: 'Исходные данные:',
  AfterAdjustment: 'После корректировки:',
  inputContainerNo: 'Заполните номер ящика.',
  inputSealNo: 'Заполните, пожалуйста, номер.',
  BoxType: 'Ячечный вид',
  BusinessPeopleType: 'Оперативный персонал',
  clearConfirm: 'Данные о выбранном бизнесе 【{0}】 【{1}】 будут удалены, подтверждается ли это?',
  clearCategoryConfirm: 'Данные о выбранном бизнесе [bracket0] будут удалены, подтверждается ли это?',
  changeTwoConfirm: 'Данные по выбранному бизнесу 【{0}】 【{1}】 будут заменены, подтверждается ли это?',
  changeOneConfirm: 'Данные по выбранному бизнесу 【{0}】 будут заменены, подтверждается ли это?',
  hasRefreshCharge: 'У агента по бронированию уже есть расходы, обновить расходы?',
  SuccessTip: 'Успешно {0} шт.',
  successTipAlreadyNotEditCharge: 'Успешно {0} шт., <br/> объяснение: <br/> {1} уже имеет нередактируемые расходы, пожалуйста, обработайте своевременно!',
  hasOneAtleast: 'Пожалуйста, выберите хотя бы один вариант и попробуйте снова!',
  hasOneNoAtleast: 'Пожалуйста, заполните хотя бы одну колонку и попробуйте снова!',
  maxSelectBusiness: 'Выберите бизнес, превышающий {0}, пожалуйста, выберите заново и попробуйте снова!',
  requireAllSelect: 'Пожалуйста, выберите измененные {0} и {1} и попробуйте снова.',
  hasOneCategoryAtleast: 'Выберите данные, которые вам нужно записать!',
  adjustedDestinationAgent: 'Введите скорректированного агента порта назначения!',
  whetherCoverMBLReceiver: 'Данные выбранного агента назначения будут заменены. Перезаписать получателя MBL новой информацией об агенте?',
  lclSlavesJobCannotModify: 'Билетик не может изменить поле！',
  BusinessNotSameOpAndSalesOffice: 'Бизнес {0} Операционный филиал не соответствует сбытовому филиалу',
  SuccessfullyClearXPieces: 'Успешное удаление {0} {1} данных',
  PartSuccessClearXPieces: 'Успешное удаление статьи {0} {1} данных, ошибка статьи {2}, причина неудачи:',
  DataAdjustmentSame: '{0} Данные согласуются до и после корректировки, никаких изменений не вносилось.',
  DataAdjustmentAgainConfirm: 'Отмеченные операции {0} Данные будут заменены, подтверждено ли это?',
  SuccessfullyReplacedXPieces: 'Успешная замена {0} {1} данных',
  NotReplacedXPieces: 'Не найдено соответствие {0}, замена 0',
  PartSuccessReplacedXPieces: 'Успешная замена статьи {0} {1} данных, ошибка статьи {2}, причина неудачи:',
  BusinessisNotPositiveOperation: 'Бизнес {0} не работает',
  BusinessisBlocked: 'Бизнес {0} заблокирован',
  BusinessisHblLock: 'Операции {0}HBL Заперто',
  BusinessisInvalidLoadType: 'Бизнес {0} Весь тип сборки не является заказным пакетом',
  BusinessisContainerExist: 'Операция {0} Существуют модифицированные типы коробок',
  BusinessPicecNotMatch: 'Бизнес {0} Не существует типов коробок, соответствующих исходным данным',
  BusinessisMblHblContainerExist: 'Бизнес {0} Добавлен MBL Description и On / HBL Description',
  BusinessisContainerSealNoExist: 'Бизнес {0} Заполнен номер ящика',
  BusinessisTruckingContainerExist: 'Бизнес {0} Информация о связанных точках',
  BusinessisDischarginTruckingExist: 'Операция {0} Доставка из порта назначения',
  BusinessisAmsContainerExist: 'Операции {0} Связанные с антитеррористическими накладными',
  CopyFailedBusinessNumber: 'Ошибка копирования бизнес - номера одним кликом',
  PackagingCategoryOfDangerousGoods: 'Класс упаковки опасных грузов',
  CargoReleaseWay: 'Способ выпуска',
  WarehouseLoadingRemarks: 'Оборудование на складе',
  CheckStatuses: 'Состояние галочки:',
  ClearStatuses: 'Очистить галочку:',
  SelectAtLeastOneAdjustment: 'Пожалуйста, выберите хотя бы одну настройку и попробуйте снова!',
  ClearStateComfirm: 'Состояние отмеченного бизнеса {0} будет очищено, подтверждено ли это?',
  CheckStateComfirm: 'Состояние отмеченного бизнеса {0} будет обозначено, подтверждается ли это?',
  SuccessfullyCancelXPieces: 'Успешное удаление {0} данных',
  SuccessfullyCheckXPieces: 'Успешное выделение {0} данных',
  PartSuccessClearXThePieces: 'Успешное удаление {0} данных, неудача {1}, причина неудачи:',
  PartSuccessCheckXThePieces: 'Успешная галочка {0} данных, ошибка {1}, причина неудачи:',
  BusinessisCargoDocLock: 'Операция {0} Закрытый заказ',
  DataCategoryProcessingFailed: 'Ошибка обработки категорий данных',
  PleaseSelectATemplate: 'Выберите шаблон',
  PleaseSelectANode: 'Выберите узел',
  PleaseSelectAState: 'Выберите статус',
  SuccessModifiedXBusinessState: 'Успешно изменен {0} статус бизнеса',
  SuccessWithdraw: 'Снято {0} статей',
  PleaseSpecificTemplateFilePreview: 'Пожалуйста, выберите конкретный файл шаблона для предварительного просмотра!!',
  CopyLast: 'Запись в прошлый раз',
  WaybillNumberCopy: 'Зап. номера ',
  CargoInformation: 'Информация о грузе',
  BillOfLadingQuantity: 'Количество коносаментов',
  Packing: 'Упаковка',
  PleaseChoose: '- Пожалуйста, выберите...',
  CustomerType: 'Тип клиента',
  HTSCode: 'Номер HTS',
  EnglishCommodityName: 'Английское название',
  TransportationInformation: 'Транспортная информация',
  MBLNumber: 'Номер MB / L',
  HBLNumber: 'Номер HB / L',
  CCNNumber: 'Номер CCN',
  ShipName: 'Название судна',
  ShipNumber: 'Номер судна',
  PortArrivalDate: 'Дата прибытия',
  CountryOfOrigin: 'Страна происхождения',
  BillLadingPlaceOfDispatch: 'Место отправления коносамента',
  BillLadingPortOfDeparture: 'Порт отправления коносамента',
  BillLadingPortOfDischarge: 'Порт разгрузки коносамента',
  BillLadingPlaceOfDelivery: 'Место сдачи коносамента',
  LastOverseasPort: 'Последний зарубежный порт.',
  FirstPortOfCall: 'Первый порт захода',
  SynchronizeHBLInformation: 'Синхронизация информации HBL',
  addHbl: 'Дополнительный список',
  NonVesselCarrierSCAC: 'Безводный перевозчик SCAC',
  DeclarationAccount: 'Отчетность',
  DeclarationType: 'Тип заявления',
  DirectToTheUnitedStates: 'Прямые рейсы в США',
  ToTheInlandWarehouse: 'На внутренний склад.',
  TransferClearancePullToStates: 'Транзит в Канаде, без таможенной очистки, в США',
  CargoThroughTheUnitedStates: 'Грузовой путь в США',
  ContainerInformation: 'Сведения об упаковке',
  AddContainerInformation: 'Добавить информацию о упаковке',
  RemoveContainerInformation: 'Удалить информацию об упаковке',
  BoxSpecies: 'Ящик',
  BoxHeight: 'Высота ящика',
  ContainerNumber: 'Номер ящика',
  SealNumber: 'Печать',
  CommodityName: 'Наименование',
  PleaseEnterTheCommodityNameOrHSCode: 'Пожалуйста, введите наименование товара или код HS',
  ShippingCompanyContractNoRequired: 'Номер контракта судоходной компании не может быть пустым',
  ApplicableRoutesNoRequired: 'Применимые маршруты не могут быть пустыми',
  ShippingCompanyNoRequired: 'Судоходная компания не может быть пустой',
  ValidityNoRequired: 'Срок действия не может быть пустым',
  ShippingCompanyAndBaseDifferent: 'Судоходная компания в данном соглашении не совпадает с информацией в основной вкладке. Подтвердить перезапись?',
  GiveUp: 'Отмена',
  BackFillToRoute: 'Для данного номера соглашения указано несколько применимых маршрутов. Выберите маршрут для обратного заполнения в базовой вкладке.',
  MultipleApplicableRoutesDifferent: 'Для данного номера соглашения указано несколько применимых маршрутов, и все они отличаются от введенных в базовой вкладке. Выберите маршрут для обратного заполнения в базовой вкладке.',
  ApplicableRoutesDifferent: 'Все применимые маршруты для данного номера соглашения отличаются от введенных в базовой вкладке. Подтвердить перезапись?',
  ShippingCompanyDifferent: 'Выбранная вами судоходная компания не соответствует применимой компании выбранного контракта. Подтвердить перезапись?<br/><span style=\'color:red\'>{0}</span>',
  AirlineDifferent: 'Выбранный маршрут порта не соответствует применимому маршруту выбранного контракта. Подтвердить перезапись?<br/><span style=\'color:red\'>{0}</span>',
  EtdDifferentValidityPeriod: 'Выбранная вами ETD не соответствует сроку действия контракта. Подтвердить перезапись?<br/><span style=\'color:red\'>{0}</span>',
  ValidityPeriodCannotCoverETD: 'Срок действия выбранного контракта не покрывает ETD. Подтвердить перезапись?<br/><span style=\'color:red\'>{0}</span>',
  DoNotBackFill: 'Не выполнять обратное заполнение',
  ValidPeriodMessage: 'Срок действия соглашения: {0}',
  ValidPeriodEtdMessage: 'Срок действия соглашения: {0}, ETD: {1}',
  NumberApplicableToShippingCompany: 'Применимая судоходная компания соглашения: {0}',
  NumberApplicableToAirline: 'Применимый маршрут соглашения: {0}',
  PleaseToDeleteTheContract: 'Вы уверены, что хотите удалить выбранные {0} контрактных номера? Это действие нельзя отменить.',
  ScNoIsUsed: 'Этот номер записи уже используется и не может быть удален',
  BeginDateNotLessThanEndDate: 'Дата начала действия не может быть позже даты окончания',
  ConfirmEnableTips: 'После активации пользователи смогут выбирать этот номер контракта на странице деталей заказа. Подтвердить активацию?',
  EnableTips: 'Активация возможна только если все выбранные контрактные номера отключены',
  DisEnableTips: 'После отключения этот номер контракта нельзя будет выбрать в деталях заказа. Отключить?',
  ConfirmDisEnableTips: 'Отключение возможно только если все выбранные контрактные номера активны',
  ContractRatePropertyRequired: 'Характеристика тарифа по контракту не может быть пустой',
  NACRequired: 'NAC не может быть пустым',
  CommodityNameRequired: 'Наименование товара не может быть пустым',
  ContractNumberRequired: 'Номер договора судоходной компании уже существует',
  PleaseSelectAirLine: 'Пожалуйста, выберите маршрут (можно выбрать несколько)',
  PleaseInputNumber: 'Пожалуйста, введите число',
  CargoInsuranceQuantityRequired: 'Количество страхового груза не может быть пустым',
  CargoInsuranceUnitRequired: 'Единица страхового груза не может быть пустой',
  SendingStatus: 'Отправить состояние',
  SendingStatusUpdateTime: 'Время обновления состояния отправки',
  CancellationStatus: 'Статус отмены',
  Notifier: 'Уведомление',
  SecondNotifier: 'Второй уведомитель',
  ShippingAndReceivingInformation: 'Получение и передача информации',
  ShipperName: 'Наименование отправителя',
  CompanyTitle: 'Подними голову.',
  Address: 'Адрес',
  Phone: 'Телефон',
  Optional: 'Необязательно заполнять',
  ConsigneeName: 'Наименование грузополучателя',
  NotifierName: 'Имя уведомляющего',
  SecondNotifierName: 'Наименование второго уведомителя',
  BatchModifyDestinationPortInformation: 'Массовое изменение информации о порту назначения',
  OverseasWarehouseNonAmazonWarehouse: 'Зарубежные транзитные склады, не Amazon',
  SelectedBePositivePleaseSelect: 'Выбранный бизнес должен быть положительным, пожалуйста, выберите заново!',
  DomesticWarehouse: 'Внутренний склад',
  OverseasWarehouse: 'Зарубежные склады',
  ContainerNumber2: 'Номер ящика:',
  ContainerNumberContainerNoNull: 'Номер ящика: containerNoNull',
  Exceeded: 'Превышение',
  CancelCustomsReturn: 'Отмена возврата',
  AttachmentContentTooLarge: 'Приложение слишком большое',
  LockedPleaseContactSupervisorUnlock: 'Заблокирован, не может быть напечатан, пожалуйста, свяжитесь с вышестоящим руководителем для разблокировки!',
  FCLProfitPrinting: 'Печать всей прибыли',
  LCLProfitPrinting: 'Печать прибыли',
  DueToPrintOrUnlock: 'Из - за превышения контроля над письмом, простой вексель заблокирован, не может быть напечатан или EDI, пожалуйста, свяжитесь с вышестоящим начальником, чтобы разблокировать, когда это необходимо!',
  FeeName: 'Название расходов',
  BatchFeeScheme: 'Программа пакетных расходов',
  NoCostCanBeTranscribed: 'Нет копируемых затрат.',
  ThisBeenSentEDIAllowed: 'Информация о манифесте была отправлена в EDI и не может быть удалена.',
  TheVoidedAndCannotAgain: 'Этот манифест аннулирован и не может быть вновь аннулирован.',
  ShanghaiManifestShippingCompany: 'Шанхайская судоходная компания:',
  NoResultsFound: 'Результат не найден',
  ExportClearanceNewRegulation: 'Новые правила экспорта',
  ShanghaiAfterClearanceManifestContinuing: 'Приказ № 172 Шанхайской таможни о переключении условий выпуска, передача информации о морском выпуске на причал с квитанцией « погрузочный манифест», попросите клиента обратить внимание на состояние погрузочного манифеста после завершения таможенной очистки, аномалии своевременно связаться с клиентской службой для подтверждения. К тому времени избыточный манифест в упаковке не был своевременно удален, несвоевременная посадка, нестандартная сборка после выпуска, неудачное изменение данных манифеста, смешивание и повторное использование номера коносамента в течение двух лет повлияют на погрузку. Во - вторых, после получения обычной квитанции по погрузочному манифесту, если возникает необходимость в изменении, исключении или добавлении любого предварительно установленного манифеста, необходимо связаться с представителем судна, чтобы удалить погрузочный манифест и продолжить работу.',
  YangshanDistrictNovember152021: 'Горный район: 15 ноября 2021 года',
  WaigaoqiaoDistrictNovember222021: 'Внешний порт: 22 ноября 2021 года',
  GarbageManifest: 'Мусорный манифест',
  N1YourGoodsAreManifest: '1. Мусорный манифест строго запрещен таможней! Согласно таможенным правилам, каждый билет должен быть заранее оформлен в соответствии с одним билетом, фактически отправленным товаром. После отправки манифеста, если ваш груз не отправлен (не успеет на борт судна, изменение плана доставки и т.д.), этот манифест считается манифестом для мусора!',
  N2StowManifestMustSent: '2. Пример ситуации с накладной на вывоз мусора: после перегруппировки судна первоначальная предварительная накладная должна быть удалена, после удаления должна быть отправлена новая предварительная накладная!',
  N3OnTheFreightManifest: '3. Последствия неудаления мусорного манифеста: не только повлияет на погрузку, но и таможня может наложить штраф в размере до 50 000 юаней на экспедитора и дисквалифицировать его от таможенной декларации! После появления мусорного манифеста, пожалуйста, свяжитесь со службой обслуживания клиентов, чтобы помочь удалить мусорный манифест!',
  BusinessNotSelected: 'Не выбран бизнес.',
  DoNotImportAndSend: 'Импорт не отправляется',
  ViewReceipt: 'Посмотреть квитанции',
  ImportEXCEL: 'Импорт Excel',
  Receipt: 'Аккредитация',
  ReceiptNumber: 'Номер квитанции',
  Time: 'Время',
  PleaseSelectAccount: 'Выберите счет',
  MappingValueNotEmpty: '{0} не может быть пустым, пожалуйста, настройте код отображения для {0} в управлении отображением',
  AfrFieldNotEmpty: '{0} Нельзя быть пустым',
  AfrEfreightDgTip: 'Опасные грузы нельзя отправлять прямым способом. Пожалуйста, переключитесь обратно на косвенный способ отправки. И дополните информацию об опасных грузах в YiFei.',
  AfrFieldNotAccess: 'Не превышать {0} символа',
  CustomerNumberCannotBeEmpty: '【Информация о клиентах】 Номер подраздела AMS не может быть пустым.',
  CustomerNOCannotBeEmpty: '【Информация о клиентах】 MB / L NO не может быть пустым.',
  CustomerPortCannotBeEmpty: '[bracket0] порт разгрузки не может быть пустым.',
  CustomerDeliveryCannotBeEmpty: '【Информация о клиентах】 Место поставки не может быть пустым.',
  AMSNumber: 'Номер AMS',
  AFRNumber: 'Номер AFR',
  ACINumber: 'Номер ACI',
  EManifestNumber: 'Номер eManifest',
  SendSucceeded: 'Отправить успешно',
  NotSent: 'Не отправлено',
  ServiceChannel: 'Каналы обслуживания',
  ExpectedAmazonWarehouseEntryTime: 'Ожидаемое время входа в Amazon',
  DestinationDeliveryMethod: 'Способ доставки',
  CourierCompany: 'Экспедиционная компания',
  TrackingNumber: 'Экспедиционный номер.',
  POoriginalNumber: 'По (оригинальный номер)',
  CustomsDeclarationMethod: 'Таможенная декларация',
  CustomsClearanceMethod: 'Порядок таможенной очистки',
  EORIEnterpriseNumber: 'EORI Энтерпрайз',
  VATTaxNumber: 'Номер VAT / Налоговый',
  VATRegistrationCountry: 'Страны регистрации VAT',
  VATRegistrationAddress: 'Адрес регистрации VAT',
  VATCompanyEnglishName: 'Английское название компании VAT',
  WithPower: 'Под напряжением',
  WithMagnet: 'Магнитная лента',
  Powder: 'Пор.',
  Liquid: 'Жидк.',
  EstimatedWarehouseEntrygoodArrivalTime: 'Ожидаемое время складирования / доставки',
  RemoteWarehouse: 'Далекура',
  OceanFreight: 'Морские перевозки',
  ServiceChannel2: 'Каналы обслуживания:',
  FeeType: 'Тип расходов:',
  EstimatedAmount: 'Предполагаемая сумма:',
  Equivalent: 'Эквивалент',
  FreightRateLevel: 'Класс тарифа:',
  BillingWeight: 'Расчетный вес:',
  CalculationMethod: 'Метод расчета:',
  EstimatedTimeCannotBeEmpty: 'Ожидаемое время прибытия / доставки не может быть пустым!',
  DestinationCannotBeEmpty: 'Место назначения не может быть пустым!',
  DestinationCountryCannotBeEmpty: 'Страна назначения не может быть пустой!',
  ZipCodeCannotBeEmpty: 'Почтовый индекс не может быть пустым!',
  CannotBeEmpty: 'Нельзя быть пустым!',
  PleaseTheConsignorUnitFirst: 'Пожалуйста, выберите доверенное подразделение.',
  DearAndThenCarryOperation: 'Pro, пожалуйста, сначала сохраните бизнес, а затем проведите автоматическую операцию распределения.',
  ClearanceMethod: 'Порядок таможенной очистки',
  EstimatedStorageReadyGoodsTime: 'Ожидаемое время складирования / доставки',
  ForeignWarehouse: 'Зарубежные склады',
  WithElectricity: 'Под напряжением',
  WithMagnetism: 'Магнитная лента',
  YourPieceWeightAndTo: 'Ваш товар уже участвует в сопоставлении данных, и автоматическая упаковка обновит информацию о волосах простых и основных билетов, в которых вы находитесь.',
  Prompt: 'Подсказка',
  GotIt: 'Понял.',
  DocumentNumber: 'Номер документа',
  Origin: 'Происхождение',
  AreaCode: 'Зоны',
  BoxAndCargoInformationFunction: 'Информация о контейнере не совпадает, пожалуйста, убедитесь, что информация верна? Информация о контейнере может быть изменена на основной странице или приведена в соответствие с функцией 【Обновление данных по портам】.',
  InconsistencyBetweenPortAreaDataAndPackingInformationTips: 'Примечание: Когда данные порта не совпадают с информацией о упаковке, это может привести к тому, что не будут отправлены напоминания о раннем предупреждении, напоминания о настройках SOP',
  TheComparisonFunctionToPossible: 'Получив последнюю информацию о контейнерах в порту, выберите нужные данные о контейнерах как можно скорее с помощью 【Обновление данных по портам】',
  DetectionOfBasicTab: 'Обнаружена базовая подпись страницы',
  InconsistentThePortAreaReturn: 'Возвращение в порт',
  PleaseTheOperationIsCorrect: 'Несоответствие',
  YouBoxAndCargoTab: 'Пожалуйста, посетите [bracket0] прямо сейчас.',
  BoxNum: 'Коробка.',
  GoCheck: 'Иди проверь.',
  BoxQuantity: 'Количество ящиков',
  BoxModel: 'Ящик',
  CutOffDate: 'Дата закрытия',
  PortOpeningTime: 'Время отправления',
  PortOpeningDate: 'Дата открытия порта',
  ScheduledBerthingTime: 'Планируемое время стоянки',
  ScheduledDepartureTime: 'Планируемое время выхода',
  ActualUnloadingTime: 'Фактическое время выгрузки',
  ActualHeavyLiftingTime: 'Фактическое время подъёма',
  ActualEmptyReturnTime: 'Фактическое время',
  PleasePackingInformationToRemoved: 'Выберите информацию о упаковке, которую необходимо удалить!',
  BillOfLadingType: 'Тип коносамента',
  ArrivalDate: 'Дата прибытия',
  ShippingType: 'Тип отгрузки',
  DischargingPort: 'Порт разгрузки',
  DeliveryPlace: 'Место поставки',
  CustomerShippingInformation: 'Отправка информации клиентом',
  CargoReceiver: 'Получатель груза',
  Buyer: 'Покупатель',
  Modify: 'Изменения',
  PleaseSelectABox: 'Пожалуйста, выберите коробку.',
  ReleaseOrderNumber: 'Поставьте номер:',
  ExportReleaseNewRegulation: 'Новые правила экспорта',
  WechatPrompt: 'Пожалуйста, обратитесь к каждому пользователю, который должен быть открыт в настройках и инструментах - Персональные данные, откройте лицензию push сообщений WeChat и обратите внимание на публичный номер.',
  YangshanAreaNovember152021: 'Горный район: 15 ноября 2021 года',
  WaigaoqiaoAreaNovember222021: 'Внешний порт: 22 ноября 2021 года',
  GarbageCargoManifest: 'Мусорный манифест',
  N1ActuallyShippedIfGarbage: '1. Мусорный манифест строго запрещен таможней! Согласно таможенным правилам, каждый билет должен быть заранее оформлен в соответствии с одним билетом, фактически отправленным товаром. После отправки манифеста, если ваш груз не отправлен (не успеет на борт судна, изменение плана доставки и т.д.), этот манифест считается манифестом для мусора!',
  N2ManifestMustBeDeletion: '2. Пример ситуации с накладной на вывоз мусора: после перегруппировки судна первоначальная предварительная накладная должна быть удалена, после удаления должна быть отправлена новая предварительная накладная!',
  N3YuanOnTheManifest: '3. Последствия неудаления мусорного манифеста: не только повлияет на погрузку, но и таможня может наложить штраф в размере до 50 000 юаней на экспедитора и дисквалифицировать его от таможенной декларации! После появления мусорного манифеста, пожалуйста, свяжитесь со службой обслуживания клиентов, чтобы помочь удалить мусорный манифест!',
  DetailsOfSeaExportGoods: 'Подробная информация о морских экспортных грузах',
  PleaseSelectTheSpecifiedData: 'Выберите указанные данные',
  LicenseOfLadingNumberEmpty: 'Номер машины и коносамента не должны быть пустыми.',
  NoRelevantInformation: 'Нет соответствующей информации',
  EstimatedDeliveryTime: 'Ожидаемое время доставки',
  ActualDeliveryTime: 'Фактическое время доставки',
  ObtainedContainerAndGoodsData: 'Введите название судна',
  Sailing: 'Рейс:',
  WithBookingTab: 'Название судна из порта.',
  InconsistentFromTheBillData: 'Несоответствия, импортируются ли данные о рейсах, полученные в районе порта, и очищаются ли они для получения данных о продолжительности судна?',
  InconsistentFromTheBillDataTips: 'Примечание: если судно совершает неправильный рейс, это может привести к получению времени, соответствующего неправильному сроку (запланированное время отхода от причала, время перехвата, фактическое время отхода от причала).',
  TheTicketIsNotImport: 'Билет MBL для одного состояния не начинается и не может быть импортирован.',
  Correction: 'Исправление',
  ThisItIs1Again: 'Этот job {0} был успешно отправлен для бронирования EDI. BR > Эта передача... {1}- {2}, < br > Пожалуйста, подтвердите, требуется ли отправка снова?',
  PleaseOnePieceOfData: 'Пожалуйста, выберите данные!',
  BatchImport: 'Массовый импорт',
  GoodsInformationImport: 'Импорт ГД"',
  SeaFreight: 'Морские перевозки',
  AirFreight: 'Воздушные перевозки',
  Freight: 'Транспортные расходы',
  BatchCostScheme: 'Программа пакетных расходов',
  Shanghai: 'Шанхай',
  Qingdao: 'Циндао',
  SeaguardianSupportsSM2WeighingMethod: 'Поддерживается только способ взвешивания SM2.',
  ContainerNumberSealNumber: 'Номер ящика',
  DueCannotBePrintedNeeded: 'Из - за превышения контроля над письмом, простой вексель заблокирован, не может быть напечатан или EDI, пожалуйста, свяжитесь с вышестоящим начальником, чтобы разблокировать, когда это необходимо!',
  LockedContactTheSuperiorUnlock: 'Заблокирован, не может быть напечатан, пожалуйста, свяжитесь с вышестоящим руководителем для разблокировки!',
  ModificationSuccessful: 'Изменение успешно',
  StatusConversionSuccessful: 'Преобразование состояния успешно.',
  NoDeclarationFormCreated: 'Таможенная декларация не создана',
  Cleared: 'Получено',
  Uncleared: 'Не получено',
  SentOut: 'Отправлено',
  TakenOver: 'Полученные заказы',
  Filed: 'Архивировано',
  TaxRefunded: 'Возмещенные налоги',
  ReturnedbyOurCompany: 'Отобрано (наш отдел)',
  ReturnedtoTheCustomer: 'Возврат (клиенту)',
  WithdrawalOfDocumentStatus: 'Статус документа отозван',
  DocumentStatus: 'Статус документа',
  SendOut: 'Отправка',
  Archive: 'Архив',
  RefundTax: 'Возмещение налогов',
  RetrieveourCompany: 'Взять обратно (наш отдел)',
  Returncustomer: 'Возврат (Клиент)',
  StateNotSelected: 'Состояние не выбрано.',
  DateNotSelected: 'Дата не выбрана.',
  WithdrawalSuccessful: 'Эвакуация прошла успешно.',
  NoDataSelected: 'Данные не выбраны.',
  PleaseANewDeclarationForm: 'Пожалуйста, создайте новую таможенную декларацию.',
  NoDataModified: 'Данные не были изменены',
  SavedSuccessfully: 'Сохранить успешно.',
  BatchIsInconsistentPleaseSelect: 'Статус массовой печати не совпадает, выберите заново.',
  NoDataAvailableForPrinting: 'Нет данных для печати.',
  Document: 'Документация',
  Date: 'Дата',
  NoFilesAvailable: 'Нет документов',
  Takeover: 'Приемный ордер',
  Retrieve: 'Взять обратно',
  FileNotSelected: 'Файл не выбран.',
  NoTemplateFound: 'Не найдено',
  ForTheCorrespondingPrint: 'Соответствующий шаблон печати',
  BookingAPI: 'Забронировать API',
  BillOfLadingAPI: 'коносамент API',
  PleaseTheBusinessToSend: 'Выберите бизнес для отправки!',
  ContainerQuantity: 'Количество ящиков',
  BookingEdiSendingChannel: 'Канал бронирования EDI',
  BookingEdiSendingTime: 'Время бронирования EDI',
  EdiStateQuery: 'Запрос состояния EDI',
  JiLianStar: 'Чилиансинь',
  NotBeSent: '(Примечание: Эта поездка не отправляется)',
  FullyStored: 'Полный склад',
  CancelFullWarehousing: 'Отмена полного складирования',
  StoredTipOne: 'Складские накладные с оперативным номером {0} Всего {1}',
  StoredTipTwo: 'Подтвердить операцию {0}?',
  StoredTipThree: 'Выберите состояние хранения данных для [bracket0]',
  StoredTipFour: 'Складские квитанции по этому билету уже полностью на складе!',
  SelectedRightData: 'Выберите подходящие данные',
  EmptyContainerNotificationTime: 'Время оповещения пустого ящика',
  WaitBookingVerifyBatch: 'В пакетном аудите, пожалуйста, подождите немного, после успешного аудита будет напоминать вам.',
  BookingVerifyBatch: 'Количество проверок не должно превышать 500!',
  Roles: 'Роль',
  ZipForCountry: 'US, CA Обязательно заполнить',
  PleaseZipForSend: 'Пожалуйста, выберите почтовый индекс для отправки!',
  BL_EDI_SendChannel: 'Канал отправки коносамента EDI',
  BL_EDI_SendTime: 'Время отправки коносамента EDI',
  VGM_EDI_SendChannel: 'Канал передачи VGM EDI',
  VGM_EDI_EDISendTime: 'Время отправки VGM EDI',
  CleanManifest_EDI_SendChannel: 'Уборка каналов доставки ЭДИ',
  CleanManifest_EDI_SendTime: 'Время отправки Уборки манифеста EDI',
  Way99_EDI_SendChannel: '99 Кассет - посылка EDI',
  Way99_EDI_SendTime: '99 Время отправки багажника EDI',
  AMS_EDI_SendChannel: 'Канал передачи AMS EDI',
  AFR_EDI_SendChannel: 'Канал передачи AFR EDI',
  ACI_EDI_SendChannel: 'Канал передачи ACI EDI (CW)',
  ACI_EDI_SendTime: 'Время отправки ACI EDI (CW)',
  AMS_JS_STATE: 'Состояние отправки AMS',
  ACI_JS_STATE: 'Состояние отправки ACI',
  AFR_JS_STATE: 'Состояние отправки AFR',
  AMS_EDI_SendTime: 'Время отправки AMS EDI',
  AHR_EDI_SendTime: 'Время отправки AHR EDI',
  ENS_EDI_SendTime: 'Время отправки ENS',
  PreShippingBill_EDI_SendChannel: 'Канал доставки EDI',
  PreShippingBill_EDI_SendTime: 'Время отправки EDI',
  OverseaAgent_EDI_SendChannel: 'Зарубежные каналы доставки EDI',
  OverseaAgent_EDI_SendTime: 'Зарубежные агенты EDI Время отправки',
  PortOfHubSecond: 'Порт HUB - 2 пути',
  PortOfHubThird: 'Порт HUB - 3 пути',
  ProvisioningStatus: 'Предварительное состояние',
  ArrivalInformation: 'Информация о прибытии',
  QuantityConsign: 'Число претензий (Комиссия)',
  QuantityActual: 'Количество претензий (фактически)',
  WeightConsign: 'Вес брутто (КМ)',
  WeightActual: 'Вес брутто (реальный)',
  CubageConsign: 'Объем (КВ)',
  CubageActual: 'Объем (реальный)',
  VolumetricWeightConsign: 'Материал (комитет)',
  VolumetricWeightActual: 'Материал (реальный)',
  ChargeWeightConsign: 'Расчетный вес (комиссия)',
  ChargeWeightActual: 'Расчетный вес (фактически)',
  CategoryOfGoodsName: 'Название категории товаров',
  ShipperLine2: 'Отправитель, вторая строка',
  ConsigneeLine2: 'Грузополучатель, вторая строка',
  NotifyPartyLine2: 'Вторая строка',
  ShipperLine3: 'Отправитель, третья строка',
  ConsigneeLine3: 'Грузополучатель, третья строка',
  NotifyPartyLine3: 'Третья строка',
  ShipperLine4: 'Отправитель 4.',
  ConsigneeLine4: 'Грузополучатель, четвертая строка',
  NotifyPartyLine4: 'Четвертая строка',
  ShipperLine5: 'Отправитель 5.',
  ConsigneeLine5: 'Пятая строка грузополучателя',
  NotifyPartyLine5: 'Пятая строка',
  ShipperLine6: 'Отправитель, шестая строка',
  ConsigneeLine6: 'Грузополучатель, шестая строка',
  NotifyPartyLine6: 'Шестая строка',
  ShipperLine7: 'Седьмая строка отправителя',
  ConsigneeLine7: 'Седьмая строка грузополучателя',
  NotifyPartyLine7: 'Седьмая строка',
  OperationLog: 'Журнал операций',
  DimensionLength: 'Размер CM (длина)',
  DimensionWidth: 'Размер CM (ширина)',
  DimensionHeight: 'Размер CM (высокий)',
  SystemAdd: 'Платформа добавлена',
  FreeContainerEndTime: 'Срок годности',
  FreeStorageEndTime: 'Время истечения срока действия без реактора',
  QuantityConsign2: 'Количество претензий (доверенность)',
  QuantityBooking: 'Количество мест (бронирование)',
  QuantityActual2: 'Число претензий (фактически)',
  QuantityDocumentation: 'Количество единиц (накладных)',
  WeightConsign2: 'Вес брутто KGS (по заказу)',
  WeightBooking: 'Вес брутто KGS (бронирование)',
  WeightActual2: 'Вес брутто KGS (фактический)',
  WeightDocumentation: 'Вес брутто KGS (изготовление накладных)',
  CubageConsign2: 'Объем CBM (по заказу)',
  CubageBooking: 'Объем CBM (бронирование)',
  CubageActual2: 'Объем CBM (фактический)',
  CubageDocumentation: 'Объем CBM (изготовление накладных)',
  ChargeWeightConsign2: 'Расчетный вес M / T (по заказу)',
  ChargeWeightBooking: 'Расчетный вес M / T (бронирование)',
  ChargeWeightActual2: 'Расчетный вес М / Т (фактический)',
  ChargeWeightDocumentation: 'Расчетный вес M / T (заказ)',
  DensityConsign: 'Плотность kg / m³ (доверенность)',
  DensityBooking: 'Плотность kg / m³ (бронирование)',
  DensityActual: 'Плотность kg / m³ (фактически)',
  DensityDocumentation: 'Плотность kg / m³ (изготовление)',
  ConsignationCompany2: 'Подразделение - заказчик / фактическое уведомляющее лицо',
  ConsignationCompanyHeader2: 'Возвышение головы доверенного лица / фактического уведомляющего лица',
  WarehouseSupplier2: 'Поставщики / склады',
  ShipperDetail: 'Отправитель Подробнее',
  ConsigneeDetail: 'Детали грузополучателя',
  NotifyDetail: 'Информатор Подробнее',
  MasterBillNo2: 'Главная / MBL',
  SynchroniseBooking: 'Синхронизация информации о бронировании',
  HBLNoRepeat: 'Существует повторение HB / L NO, одиночный номер:"{0}"',
  ConfirmSynchronizeHBL: 'При использовании Synchronise HBL очищается дополнительная информация, вводимая вручную. Продолжение?',
  GetFiles: 'Получение файлов',
  UploadCustomerFiles: 'Загрузить клиент',
  CustomerSelfIssuedFiles: 'Собственные документы клиента',
  CheckTheBLLog: 'Единый журнал',
  Surrendered: 'Электрический лист',
  InterfaceName: 'Имя интерфейса',
  DataFlowDirection: 'Потоки данных',
  CheckTheBLCenterApiLog: 'Одноцентровый журнал',
  PleaseMaintainTheCorresponding: 'Поддерживайте соответствующий персонал {0}',
  PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel: 'Поддерживайте номер мобильного.',
  XhqCsrMsg: 'Сигнальный флаг, сообщение.',
  copyLink: 'Копировать ссылку',
  openLink: 'Открыть ссылку',
  BillNotCfm: 'коносамент не подтвержден, сначала убедитесь',
  ATDIsNull: 'Если вы еще не покинули порт, пожалуйста, выполните заказ на электроэнергию после отъезда.',
  BillNotRelease: 'Статус коносамента, не"Распускаемый лист"',
  CfmBillFirst: 'Пока нет, нажмите сначала"Подтверждение правильности"',
  IsReleased: 'Уже размещен заказ, здесь нельзя работать и загружать рукописи клиентов',
  IsReleased2: 'Помещен лист, без повторения операции',
  UnStartOrUnConfirmCanUpload: 'Файл может быть загружен только в состоянии коносамента [bracket1] или [bracket0]',
  LinkIsNull: 'Ссылка пуста',
  OnlySurrenderedSupport: 'Только форма коносамента "Surrendered", поддерживающая эмиссионный ордер',
  SynchronizePackingInfo: 'Синхронизация обновления информации об упаковке',
  ManifestNotConfirmed: 'Манифест не подтвержден!',
  AreYouSureSynchronizePackingInfo: 'Вы уверены, что хотите синхронизировать информацию об упаковке?',
  NoDataSynced: 'Без синхронизации каких - либо данных, пожалуйста, подтвердите вид ящика типа ящика ~',
  VirtualBillType: 'Типы форм',
  DestinationPortAgentIsNotEqualToDesignatedFreightAgent: 'Агент порта не назначенный',
  MultipleCustomsDeclarationInaccurate: 'Существует сценарий, в котором Job выполняет несколько таможенных поручений, и данные могут быть неточными. Пожалуйста, свяжитесь с таможенной службой онлайн, чтобы сообщить подробные данные таможенной декларации.',
  OnlySupportOneCustomsDeclaration: 'Эта функция доступна только для создания только одного сценария таможенного поручения в одном бизнесе.',
  OnlySupportOneCustomsCommission: 'Пожалуйста, выберите отдельный заказ на таможенную очистку и попросите проверить проект.',
  hblRefNo: 'HBL Скачать Ref',
  HBLRefNo2: 'HBL Ref No. ',
  BatchPushCharges: 'Расходы на массовую доставку (перекрестное делегирование)',
  ChargeConfirmed: 'Подлежащие подтверждению расходы',
  ViewReception: 'Просмотреть получение',
  ViewSending: 'Посмотреть Отправить',
  branchTransactions: 'Взаимодействие с филиалами',
  OurJobNo: 'Наш деловой номер',
  TheirJobNo: 'Номер операции другой стороны',
  firstSendTime: 'Время первой отправки',
  ConfirmReceiveTheseCharges: 'Подтвердить получение этих расходов?',
  AuditOperator: 'Проверка операторов',
  Dimensions: 'Размерные спецификации (длина * ширина * высокая единица М)',
  DoorRemarks: 'Дополнительные пояснения к дверям',
  BillOfLadingDesignatedFreightAgentFeedback: 'коносамент - обратная связь назначенного агента',
  ChangeValue: 'Изменить значение',
  AcceptChange: 'Принять изменения',
  Rejected: 'Нет.',
  AgentFeedbackRemarks1: 'Изменения в назначенном грузовом агенте приняты',
  AgentFeedbackRemarks2: 'Изменения в назначенном грузовом агенте были отклонены,',
  AgentFeedbackRemarks3: 'Пожалуйста, подтвердите окончательные изменения в режиме онлайн с грузоотправителем и назначенным экспедитором',
  AgentEmailSend: 'Отправка почтовых отправлений назначенным экспедитором',
  ETAFirstPortOfCall: 'Дата первого захода',
  ETAFirstPortOfCallNotNull: 'В режиме on - board,"ETA First Port of Call"Нельзя быть пустым',
  DocumentOffice: 'Документационная компания',
  CustomerOffice: 'Корпорация обслуживания клиентов',
  PleaseReferToTheEmailForSpecificErrorInformation: 'Подробная информация об ошибках почты.',
  AMSDeleteTips: 'AMS No не был успешно отправлен в систему и не может быть удален',
  MultipleMode: 'Многоразовая модель',
  NumberExchange: 'Однозначная коммутация',
  ReturnMode: 'Вернуться к одному шаблону',
  OcrTip: '* Советы: может быть в "Базовой конфигурации - Параметры распознавания документов", установить дополнительное отображение поля записи.',
  OcrOtherInfo: 'Дополнительная информация о записи:',
  DocumentRecognitionSettings: 'Параметры идентификации документов',
  SeOcr: 'Идентификация морских экспортных накладных',
  ocrOtherField: 'Выберите дополнительное поле записи',
  ocrTextMapper: 'Отображение текста',
  IdentifyingText: 'Идентифицирующий текст',
  mappedValue: 'Значение отображения',
  addMapper: 'Добавить отображение',
  editMapper: 'Изменить отображение',
  supplierCharge: 'Расходы поставщиков',
  supplierOrderNo: 'Номер поставщика',
  supplierName: 'Название поставщика',
  supplierMatchName: 'Название поставщика',
  chargeItemLocal: 'Название местных расходов',
  refMsg1: 'Справочная информация (i)',
  refMsg2: 'Справочная информация (II)',
  supportNo: 'вспомогательный номер',
  pushTime: 'Время нажатия',
  confirmCharge: 'Подтверждение расходов',
  selectBeConfirmedCharge: 'Выберите стоимость, которая будет подтверждена',
  RefreshSuccessfulRows: 'Обновление успешно {0}',
  SupplierFeesToBeProcessed: 'Расходы поставщиков подлежат обработке',
  ReceivingBranch: 'приемный филиал',
  ReceivingMatchBranch: 'Получение названия филиала',
  PleaseRefreshThePage: 'Код отображения не найден, пожалуйста, сохраните отображение. Обновите, если обслуживание выполнено.',
  BusinessDateIsNull: 'Сроки проведения операций пусты',
  NoJobMatch: 'Нет совпадений для бизнеса, пожалуйста, обновите',
  ReleaseGoodsJY: 'Выпуск JY',
  ReleaseJY: 'Посмотреть JY',
  TakeContainerJY: 'Чемоданы JY',
  ContainerPreloadJY: 'Упаковка JY',
  CancelContainerPreloadJY: 'Отменить упаковку JY',
  ReleaseGoodsPhotos: 'Отправка фотографий',
  ReleaseGoodsStatus: 'Режим выпуска',
  NoticeTime: 'Время уведомления',
  ReleaseGoods: 'Выпуск',
  warehouseNoNotNull: 'Номер склада не может быть пустым.',
  warehouseNotNull: 'Название склада не может быть пустым, пожалуйста, подпишите на основной странице Выберите поставщика склада или склада',
  consignerNotNull: 'Клиент не может быть пустым.',
  ReleaseRemarks: 'Пр.к листу',
  RequireDate: 'Дата запроса',
  TakeContRemarks: 'Чемоданы',
  ConfirmSendPackingInstructions: 'Вы уверены, что отправляете инструкции по упаковке?',
  AlreadySentReleaseGoods: 'Отправлен ордер, не нажимайте несколько раз',
  PleaseSelectWarehouseNo: 'Выберите номер склада.',
  TheWarehouseNoHasBeenReleased: 'Номер склада был отправлен, все еще отправлен?',
  ViewReleaseGoodsPhotos: 'Посмотреть фотографии груза',
  JyWarehouseInterfaceLog: 'Журнал стыковки склада',
  JyWarehouseApiLog: 'Журнал интерфейса склада',
  LclDynamic: 'Динамика упаковки',
  TakeContainerNotice: 'Уведомление о чемоданах',
  TakeContainerDone: 'Чемоданы закончены.',
  PreloadContainerOrder: 'Команда упаковки',
  PreloadContainerDone: 'Упаковка завершена.',
  SendPort: 'Отправка в порт',
  SendPortStart: 'Отправка в порт',
  ArrivalPort: 'Въезд в порт (отчет склада)',
  ExistEmptyContainer: 'Выбранный ящик содержит информацию о пустом ящике',
  docLink: 'Однозначные ссылки',
  Field: 'Поле',
  ErrorDescription: 'Описание ошибки',
  VerificationPrompt: 'Подсказка проверки',
  InformationSavingOnly: 'Сохранить только информацию',
  Required: 'ОБЯЗ',
  InputTwoAbove: 'Введите больше двух',
  SendError: 'Ошибка отправки',
  CounterTerrorismManifestConfiguration: 'Составление антитеррористических манифестов',
  AfrAccount: 'Счета AFR',
  AfrPassword: 'Код AFR',
  ApplicantEORI: 'Заявление EORI',
  AccountIsNotNull: 'Выберите номер счета для отправки',
  PasswordIsNotNull: 'Поддерживайте отправленный пароль.',
  Notification: 'Уведомление',
  Error: 'Сообщение об ошибке',
  NoSendingRecord: 'Нет записей отправки',
  GetExceptions: 'Получение аномалий',
  WaitingReceipt: 'Существует одно и то же название рейса Тот же Nvocc SCAC пока не получил таможенного подтверждения, не может отправить, пожалуйста, подождите',
  NotOperable: 'Существуют те, которые не получили квитанцию или не были успешно отправлены, не могут отправить оригинал, исправление, удаление',
  AmsVgm: 'Манифест / VGM',
  AmsReceipt: 'AMS Выписка',
  AciReceipt: 'ACI Выписка',
  AfrReceipt: 'AFR Выписка',
  VgmReceipt: 'Выписка VGM',
  ManifestReceipt: 'Удостоверения по расходным ордерам',
  UserDefinedRole1: 'Пользовательский пост 1',
  UserDefinedRole2: 'Пользовательский пост 2',
  AmsReceiptRemind: 'Напоминание о контртеррористической накладной',
  DangerousCargoCode: 'Тип груза - опасные грузы',
  CustomerToOrder: 'Клиентские накладные',
  DesignatedGoodsToBillOfLading: 'Назначенные накладные',
  OverwriteOriginalRemark: 'Покрытие исходного [bracket0]',
  DownloadPortServiceScope: 'Загрузить диапазон портовых услуг',
  AllowSaleProduct: 'Продается продукция',
  FullOrInside: 'Весь путь / страна',
  Commissioned: 'Поручено',
  weightVolumeBillWeightConsolidated: 'Включает вес / объем / расчетный вес',
  weightVolumeBillWeightConsolidatedTip: 'Выбранный бизнес существует и одинаков, будет подсчитан и один вес / объем / расчетный вес. По умолчанию подсчитать вес / объем / вес подписи на основной странице.',
  AttentionForSynchronizedContainer: 'Примечание: Эта настройка вступает в силу при заполнении номера ящика. Если они не заполнены, они не вступают в силу.',
  BatchFillGpExplain: 'Заполнить инструкцию GP',
  AiDocRecognition: 'Идентификация документов',
  AiRecognition: 'Идентификация ИИ',
  SupportMultipleFiles: 'Поддерживает идентификацию коносамента экспедитора, подтверждения коносамента, доверенности и многих других документов!',
  DragOrClick: 'Перетащите файл сюда, или',
  ClickUpload: 'Нажмите для загрузки',
  FileSizeLimit: 'Каждый раз можно загружать только один файл, не более 4 МБ для одного файла',
  InvalidFileType: 'Неправильный тип файла',
  FileTooLarge: 'Размер файла не должен превышать 4 МБ.',
  Reupload: 'Перезагрузить',
  StartRecognition: 'Начать ИД',
  RecognitionInProgress: 'В идентификации... Пожалуйста, позже, около 15s',
  RecognitionTextTip: 'Пожалуйста, скопируйте вставленное содержимое и нажмите кнопку распознавания, и система автоматически распознает и заполняет содержимое в соответствующем поле',
  EstimatedTime: 'Прогнозируемые потребности {time}',
  RecognitionSuccess: 'Идентификация успешно',
  RecognitionFailed: 'Ошибка идентификации',
  AiRecognitionWarn: 'Может быть ошибка в распознавании ИИ, проверьте ее перед отправкой',
  SupportsShanghaiPortShipAgent: 'Поддерживается только просмотр соответствующего порта Шанхая.',
  ServiceNotActivated: 'Вы не открыли эту услугу.',
  updateOrderContent: 'Обновить содержание заказа',
  CheckCustomsBrokerComfirm: 'Выбран 【Таможенная служба】, будет массовое обновление соответствующего поля 【Таможенная служба】, подтверждается ли это?',
  CheckCustomsBrokerComfirm2: 'Выберите [bracket2], но не выберите [bracket1], чтобы очистить поле [bracket0] для бизнеса, подтвердите это?',
  ClearCustomsBrokerComfirm: 'Отмечено очищение локальной службы бизнеса [bracket1] и массовое очищение поля [bracket0] выбранного бизнеса, подтверждается ли это?',
  EdiEuBolInfo: 'Дополнительная информация к коносаменту',
  EuroLineENSDeclaration: 'Европейская линия ENS',
  SelectEuroLineENSDeclaration: 'Выберите"Европейская линия ENS"',
  ManifestType: 'Тип манифеста',
  SelectManifestType: 'Выберите тип манифеста',
  SupplementaryDeclarant: 'Дополнительный заявитель',
  ChemicalIdentifier: 'Химическая маркировка',
  ChemicalProduct: 'Химические изделия',
  NonChemicalProduct: 'Нехимические изделия',
  ChemicalCUSCODE: 'Химические продукты CUS Code',
  PostalInformation: 'Почтовая информация',
  PostalInformation2: 'Почтовая информация < br > (с названием улицы, номер 2 выберите 1)',
  EORICode: 'Код EORI',
  ShipperStreetNumber: 'Номер улицы отправителя',
  ShipperStreetName: 'Название улицы отправителя',
  ActualShipperStreetNumber: 'Номер улицы фактического отправителя',
  ActualShipperStreetName: 'Название улицы фактического отправителя',
  ShipperZipCode: 'Почтовый индекс отправителя',
  ShipperAddress: 'Адрес отправителя',
  ConsigneeStreetNumber: 'Номер улицы грузополучателя',
  ConsigneeStreetName: 'Название улицы грузополучателя',
  ActualConsigneeStreetNumber: 'Номер улицы фактического грузополучателя',
  ActualConsigneeStreetName: 'Название улицы фактического грузополучателя',
  ConsigneeZipCode: 'Почтовый индекс грузополучателя',
  ConsigneeAddress: 'Адрес грузополучателя',
  NotifyStreetNumber: 'Сообщите номер улицы.',
  NotifyStreetName: 'Сообщить название улицы',
  NotifyZipCode: 'Почтовый индекс уведомляющего лица',
  ActualShipper: 'Фактический отправитель',
  ActualShipperName: 'Наименование фактического отправителя',
  ActualConsignee: 'Фактический грузополучатель',
  ActualConsigneeName: 'Наименование фактического получателя',
  ByBillingDate: 'Дата создания счета',
  ByBusinessDate: 'По оперативным датам',
  CostRateValue: 'Курсовая стоимость',
  CopyBusiness: 'Операции по копированию',
  CopyActualShipper: 'Запись отправителя',
  CopyActualConsignee: 'Запись получателя',
  SelectEORICode: 'Введите информацию о коде EORI в поле {0}',
  TOOrderRequired: 'Для этого требуется Order.',
  EORICodeExample: 'Тип кода + код',
  PlsInputParameter: 'Введите {0}',
  PlsSelectUnLCL: 'Выберите тип сборки для бизнеса',
  StreetInfo: 'Номер улицы, название улицы или почтовая информация',
  ImportingLater: 'Импортируется, пожалуйста, сделайте это позже',
  BusinessSeq: 'Номер операции',
  Yard: 'Станция',
  PleaseSelectCarrier: 'Выберите перевозчика, которому соответствует номер коносамента',
  ModifyStatus: 'Изменить статус',
  ModifyManifestStatusTip: 'Поддерживается только измененный статус таможенного листа, по которому был отправлен манифест',
  AllSoNos: 'Все таможенные номера',
  PlsSelectSoNo: 'Выберите номер таможенного листа, который необходимо изменить',
  FclOrderType: 'Подробная информация о заказах FCL',
  LclOrderType: 'Подробная информация о заказах LCL',
  ConsoleOrderType: 'Подробный заказ Console',
  CopyBusinessSendConsigneeNotify: 'Копирование операций',
  DeclarationInformation: 'Объявленная информация',
  RelatedInformation: 'Информация о ассоциированных сторонах',
  SubstratumDeclarant: 'Нижний декларант',
  PortInformation: 'Портовая информация',
  BuyerName: 'Наименование покупателя',
  BuyerAddress: 'Адрес покупателя',
  BuyerEORICode: 'Код покупателя EORI',
  BuyerPostalCode: 'Почтовый индекс покупателя',
  BuyerCountry: 'Страна покупателя',
  BuyerCity: 'Город покупателя',
  SellerName: 'Наименование продавца',
  SellerAddress: 'Адрес продавца',
  SellerEORICode: 'Код продавца EORI',
  SellerPostalCode: 'Почтовый индекс продавца',
  SellerCountry: 'Страна продавца',
  SellerCity: 'Город продавца',
  UCRNO: 'UCR NO',
  ShipperEORI: 'Отправитель EORI',
  ConsigneeEORI: 'Грузополучатель EORI',
  NotifyEORI: 'Уведомление EORI',
  FactoryEORI: 'Завод EORI',
  WarehouseEORI: 'Склад EORI',
  LCLPersonEORI: 'Ящик EORI',
  ActualShipperCountry: 'Страна отправителя',
  ActualShipperCity: 'Город отправителя',
  ActualRecipientCountry: 'Государство - получатель',
  ActualRecipientCity: 'Город - получатель',
  NotifyPhone: 'Телефон информатора',
  NotificationCountry: 'Уведомляющее государство',
  NotifyPersonCity: 'Уведомляющий город',
  BuyerStreetNumber: 'Номер улицы покупателя',
  BuyerStreetName: 'Название улицы покупателя',
  SellerStreetNumber: 'Номер улицы продавца',
  SellerStreetName: 'Название улицы продавца',
  CopyActualRecipient: 'Запись фактического получателя',
  CopyActualShip: 'Запись фактического отправителя',
  LinkSendAmsError: 'Отправка не разрешена снова во время процесса',
  DangerousCode: 'Код опасного груза',
  PleaseEnterHeader: 'Введите заголовок',
  PleaseEnterAddress: 'Введите адрес 1',
  PleaseEnterAddress2: 'Введите адрес 2',
  PleaseSelectCountry: 'Выберите страну',
  PhoneFormat: 'Только цифры',
  PleaseEnterState: 'Введите область/регион',
  PleaseEnterCity: 'Введите город',
  PleaseEnterPostalCode: 'Введите почтовый индекс',
  PleaseEnterMbl: 'Введите мастер-номер накладной без SCAC-кода',
  VesselCallSignCheck: 'Только 1-9 заглавных латинских букв и цифр',
  MarksFormat: 'Только латинские буквы верхнего/нижнего регистра, цифры, дефис, слэш, запятая, пробел, двоеточие, кавычки, плюс, подчёркивание',
  MustBe3: 'Должно быть ровно 3 символа',
  OneCargoInfo: 'Добавьте только одну сводную запись о грузе',
  Instructions: 'Конкретное объяснение причины',
  ExplanationRequired: 'При выборе «другое» это поле обязательно',
  ConfirmDeletion: 'Подтвердить удаление',
  HblCheck: 'Разрешены только заглавные буквы, цифры, дефис и слэш',
  MustBe2: 'Должно быть ровно 2 символа',
  MustBe11: 'Должно быть 11 символов, буквы или цифры, 4-й символ — U',
  MustBeU: '4-й символ должен быть U',
  MustBe4: 'Должно быть ровно 4 символа',
  VesselNotNull: 'Введите название судна на вкладке бронирования',
  VoyageNotNull: 'Введите номер рейса на вкладке бронирования',
  EtaNotNull: 'Введите ETA на вкладке основной информации',
  StreetName: 'Название улицы',
  ExampleIllustrateEORI: 'Примеры EORI12828',
  CycleTwoHundredTimesNotUseMbl: 'Задержки 200 раз, не найдено действующих таможенных деклараций',
  GenerateMblButLessThan: 'Сформирована статья 【{0}】, оставшиеся неиспользуемые таможенные номера',
  selectedRowCount: 'Выбран: {0} пункт',
  specialOperationCode: 'Код специальных операций',
  doubleClickToAddSpecialOperationCode: 'Двойной щелчок для добавления специального операционного кода',
  selectSpecialOperationCode: 'Двойной щелчок для выбора специального операционного кода',
  selectOperationRequirement: 'Двойной щелчок для выбора операции',
  TransshipmentTransportationMethod: 'Способ перевозки',
  specialHandlingCodes: 'Код специальных операций',
  AddApproximateSymbolToItemColumn: 'Добавить условный номер в строку сортировки',
  BusinessLockedStatus: 'Состояние блокировки операций',
  ImportChargeAllBusiness: 'Когда один бизнес - номер существует одновременно в нескольких типах операций, все обрабатываются, т.е. номера присутствуют как в выходе, так и в входе, и импортируются как в выходе, так и в море.',
  OriginBillOfLading: 'Оригинальный коносамент',
  ShippingOrder: 'Документация',
  EmptyOut: 'Пустой ящик (Empty Out)',
  GateIn: 'Время прибытия контейнера (Gate in)',
  VesselDeparturePOL: 'Отъезд судна (Vessel Departure POL)',
  EqCodeMatchError: 'Несоответствие типа и вида контейнера, пожалуйста, выберите заново',
  PendingPickingOrder: 'Заказ на комплектацию в ожидании',
  PickingList: 'Лист комплектации',
  WarehouseReleaseReceipt: 'Накладная на отгрузку',
  QuickSearchMBL: 'Быстрый поиск: номер основной накладной',
  QuickSearchPickingOrderNo: 'Быстрый поиск: номер листа комплектации',
  DeliveryStation: 'Пункт доставки',
  AssemblyPlanNumber: 'Номер плана сборки',
  FlightDateRange: 'Диапазон дат рейса',
  OutboundInstruction: 'Наличие инструкции на отгрузку',
  WarehouseEntryNumber: 'Номер приходной накладной',
  BoardNumber: 'Номер паллета',
  GenerateAPickingList: 'Создать лист комплектации',
  GenerateAndIssueOrders: 'Создать и выпустить заказы',
  PickingOrderNumber: 'Номер заказа на комплектацию',
  PickingStatus: 'Статус комплектации',
  ThisPickingOrderNoIs: 'Номер данного заказа на комплектацию:',
  SuccessfullyGenerated: 'Успешно создано',
  CloseAndCopyPickingOrderNo: 'Закрыть и скопировать номер заказа на комплектацию',
  PleaseCheckSameDataWareHouse: 'Товары из разных складов не могут быть в одном листе комплектации',
  DifferentGoodsCannotSamePickingList: 'Товары для разных пунктов доставки не могут быть в одном листе комплектации',
  PickingCompleted: 'Комплектация завершена',
  CancelPickingCompleted: 'Отменить завершение комплектации',
  OutboundStatus: 'Статус отгрузки',
  OutboundConfirmation: 'Подтверждение отгрузки',
  CancelWarehouseConfirmation: 'Отменить подтверждение отгрузки',
  WarehouseConfirmationSuccessful: 'Отгрузка успешно подтверждена',
  CancelWarehouseConfirmationSuccessfully: 'Подтверждение отгрузки успешно отменено',
  PleaseSelectCorrespondPickingList: 'Пожалуйста, выберите соответствующий лист комплектации',
  PleaseCheckDataPickingCompletionUnOutBound: 'Пожалуйста, выберите данные с завершенной комплектацией без отгрузки',
  PleaseCheckDataPickingCompletionOutBound: 'Пожалуйста, выберите данные с завершенной комплектацией и отгрузкой',
  NotAllowEditPickingCompletion: 'Редактирование завершенной комплектации не разрешено',
  NotAllowDeletePickingCompletion: 'Удаление завершенной комплектации не разрешено',
  PleaseCheckDataRemoved: 'Пожалуйста, выберите данные для удаления',
  KeepLeastOneDetail: 'Сохраните хотя бы одну запись',
  CargoVehicle: 'Транспортное средство',
  OutboundRemarks: 'Примечания к отгрузке',
  DeliveryTime3: 'Время получения',
  OutboundUser: 'Сотрудник отгрузки',
  QueryThreeMonths: 'Примечание: Данные запроса за три месяца',
  operationTrajectory: 'Траектория движения',
  pickupEmptyContainer: 'Забор пустого контейнера',
  arrivalFactory: 'Прибытие на завод',
  departureFactory: 'Отправление с завода',
  enterTerminal: 'Вход в терминал',
  customsRelease: 'Таможенное оформление',
  terminalRelease: 'Выпуск терминалом',
  loadedOnVessel: 'Погрузка на судно',
  departurePort: 'Отход из порта',
  arrivalPort: 'Прибытие в порт',
  destinationCustomsClearance: 'Таможенное оформление в порту назначения',
  deliveryGoods: 'Доставка груза',
  returnContainer: 'Возврат контейнера',
  driver: 'Водитель',
  contactInfo: 'Контактная информация',
  licensePlate: 'Госномер',
  jobNumber: 'Номер заказа',
  vesselVoyage: 'Судно и рейс',
  customsDeclarationNo: 'Номер таможенной декларации',
  sailingDate: 'Дата отплытия',
  closingTime: 'Время таможенного закрытия',
  WarehouseEntrySerialNumber: 'Серийный номер поступления',
  SendAll: 'Отправить все сразу',
  PreWarehouseNumberOfPackages: 'Количество мест в предварительном складе',
  PreWarehouseGrossWeight: 'Вес брутто в предварительном складе',
  PreWarehouseVolume: 'Объем в предварительном складе',
  PreWarehouseChargeableWeight: 'Платный вес в предварительном складе',
  CargoTerminalNumberOfPackages: 'Количество мест в грузовом терминале',
  CargoTerminalGrossWeight: 'Вес брутто в грузовом терминале',
  CargoTerminalVolume: 'Объем в грузовом терминале',
  CargoTerminalChargeableWeight: 'Платный вес в грузовом терминале',
  DocumentationChargeableWeight: 'Платный вес в документации',
  SignedDocumentNumberOfPackages: 'Количество мест в подписанных документах',
  SignedDocumentGrossWeight: 'Вес брутто в подписанных документах',
  SignedDocumentVolume: 'Объем в подписанных документах',
  SignedDocumentChargeableWeight: 'Платный вес в подписанных документах',
  DeadlineForDeclaringHazards: 'Срок подачи заявления о рисках',
  BookingManagementListPage: 'Страница списка управления бронированием',
  PrintByFleet: 'Печать по车队',
  BoxContents: 'Содержимое коробки',
  BatchAssignMasterOrderNumbers: 'Массовое назначение номеров основных заказов',
  PleaseForThePositiveAssign: 'Пожалуйста, выберите бизнес для положительной операции для распределения',
  SuccessfullyItemsFailed1Items: 'Успешно назначено {0} элементов, не удалось {1} элементов!',
  ReasonForFailure: 'Причина неудачи:',
  MBLNOAlreadyExists: 'Номер MB/L уже существует',
  NonOperational: 'Не рабочий',
  UnableTheMainTrackingNumber: 'Не удалось найти основной номер отслеживания',
  WarehouseEntryInformation: 'По умолчанию',
  NumberOfItemsReceived: 'Количество полученных товаров',
  GrossWeightUponEntry: 'Брутто-вес при поступлении',
  WarehouseVolume: 'Объём склада'
}
